"use strict";
// AUTO-GENERATED by packages/common/scripts/generate-email-templates.ts
// Do not edit. Edit the source .html/.hbs under src/email-templates/raw/ and re-run `bun run libbuild`.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATION_NEGATIVE_PAYOUT_CREATED = exports.ORGANIZATION_ISSUING_CARD_ON_THE_WAY = exports.ORGANIZATION_FAILED_PAD_ACH = exports.ORGANIZATION_MAILING_FEEDBACK_REQUEST = exports.ORGANIZATION_PAGE_PUBLISHED = exports.ORGANIZATION_TIPS_UPCOMING_EVENT = exports.ORGANIZATION_NBCTC_NEW_LEAD_SIGNED_UP = exports.ORGANIZATION_ATTENDEE_CANCELLATION = exports.ORGANIZATION_EMAIL_STATS_READY = exports.ORGANIZATION_IMPORT_COMPLETED = exports.ORGANIZATION_PAGE_CREATED = exports.ORGANIZATION_QUICKBOOKS_DISCONNECTED_NOTIFICATION = exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_PAYOUT = exports.ORGANIZATION_NEXT_DAY_PAYOUTS_ENABLED = exports.ORGANIZATION_REFERRAL_DURING_ONBOARDING = exports.ORGANIZATION_ISSUING_TOPUP_SUCCEEDED = exports.ORGANIZATION_STRIPE_RISK_REVIEW = exports.ORGANIZATION_LOW_TREASURY_BALANCE = exports.ORGANIZATION_RECEIVED_CREDIT = exports.ORGANIZATION_DAF_TO_CONFIRM = exports.ORGANIZATION_TREASURY_BETA_INVITATION = exports.ORGANIZATION_PAST_DUE_SUBSCRIPTION = exports.ORGANIZATION_RECURRING_PAYMENT_NEVER_MADE = exports.ORGANIZATION_FINANCIAL_ACCOUNT_CREATED = exports.ORGANIZATION_DONATION_FORM_CREATED = exports.ORGANIZATION_CAMPAIGN_PARTICIPATION = exports.ORGANIZATION_ISSUING_CARD_ACTIVATED = exports.ORGANIZATION_FAILED_RECURRING_CARD_PAYMENT = exports.ORGANIZATION_STRIPE_INFORMATION_REQUIRED = exports.ORGANIZATION_AUCTION_ORGANIZATION_BID_SUBMITTED = exports.ORGANIZATION_DISPUTE_CREATED = exports.ORGANIZATION_RECURRING_PAYMENT_SUCCEEDED_AFTER_FAILURE = exports.ORGANIZATION_ISSUING_REWARD_SUCCEEDED = exports.ORGANIZATION_CHECK_IN_MANAGER_UPCOMING_EVENT = exports.ORGANIZATION_OWNERSHIP_VERIFICATION_HELPER = exports.ORGANIZATION_DISPUTE_CLOSED = exports.ORGANIZATION_CUSTOM_DOMAIN_SUCCEEDED = exports.ORGANIZATION_CUSTOM_DOMAIN_FAILED = exports.ORGANIZATION_TICKET_TRANSFERRED_TO_NEW_OCCURRENCE = exports.ORGANIZATION_OUTBOUND_PAYMENT_POSTED = exports.ORGANIZATION_PAYOUT_PAUSED = exports.ORGANIZATION_WEBHOOK_AUTO_DISABLED = exports.ORGANIZATION_AUCTION_FAILED_PAYMENT = exports.ORGANIZATION_BANK_ACCOUNT_UPDATE = exports.DAF_DONATION = exports.THANK_YOU_FUNDRAISER = exports.THANK_YOU_TICKETING = exports.THANK_YOU_DONATION = exports.THANK_YOU_TEAM_MEMBER_JOINED = exports.THANK_YOU_SWEEPSTAKES_FREE_ENTRY = void 0;
exports.USER_DELETE_IMPORT_SUCCESS = exports.USER_ADMIN_ADDED = exports.USER_EMAIL_VERIFICATION = exports.USER_ORGANIZATION_INVITATION = exports.USER_FAILED_PAD_ACH = exports.USER_INVITATION_REFUSED = exports.USER_ORGANIZATION_CREATED = exports.USER_INVITATION_SECOND_REMINDER = exports.USER_CONTACT_EMAIL_CHANGED = exports.USER_FAILED_RECURRING_CARD_PAYMENT = exports.USER_NPO_STARTER_INVITATION = exports.USER_MERGE_USERS_REQUEST = exports.USER_CARD_EXPIRING = exports.USER_COLLABORATOR_APP_INVITE = exports.USER_INVITATION_FIRST_REMINDER = exports.SUBSCRIPTION_PAYMENT_METHOD_UPDATED_DONOR = exports.SUBSCRIPTION_AMOUNT_UPDATED_DONOR = exports.ORGANIZATION_TICKETING_CREATED = exports.ORGANIZATION_EXPORT_COMPLETED = exports.ORGANIZATION_ORG_PAGE_CONTACT_MESSAGE = exports.ORGANIZATION_AUCTION_CREATED = exports.ORGANIZATION_ISSUING_EXPENSE_FAILED = exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_TRANSACTION = exports.ORGANIZATION_DESKTOP_COMPLETION_SUGGESTION = exports.ORGANIZATION_ORDER_RECEIVED = exports.ORGANIZATION_REFERRAL_DURING_SIGN_UP = exports.ORGANIZATION_WEEKLY_VISITOR_REPORT = exports.ORGANIZATION_SATISFACTION_SURVEY = exports.ORGANIZATION_SCHEDULED_EMAIL_CONFIRMATION = exports.ORGANIZATION_REFUND_REQUEST = exports.ORGANIZATION_CARD_PAYMENT_CAPABILITY_BLOCKED = exports.ORGANIZATION_INDIVIDUAL_FUNDRAISING_OUTREACH = exports.ORGANIZATION_SUPPORT_SERVER_ERROR = exports.ORGANIZATION_DONATION_RECEIVED = exports.ORGANIZATION_STRIPE_VERIFICATION_COMPLETED = exports.ORGANIZATION_SUBSCRIPTION_AMOUNT_UPDATED = exports.ORGANIZATION_BENEFICIARY_ADDED = exports.ORGANIZATION_OUTBOUND_PAYMENT_FAILED = exports.ORGANIZATION_NEWSLETTER_SIGNUP_NOTIFICATION = exports.ORGANIZATION_INSUFFICIENT_CAPABILITIES = exports.ORGANIZATION_AUCTION_CLOSED = exports.ORGANIZATION_PAYOUT_FAILED = exports.ORGANIZATION_RADAR_EARLY_FRAUD = exports.ORGANIZATION_FIRST_PROCESSED_PAYMENT_WITHOUT_BANK = exports.ORGANIZATION_PAYOUT_CREATED = exports.ORGANIZATION_IMPORT_FAILED = exports.ORGANIZATION_FACING_COMPONENTS = exports.ORGANIZATION_MONTHLY_VISITOR_REPORT = exports.ORGANIZATION_RECURRING_DONATION_CANCELLED = exports.ORGANIZATION_FIRST_PAYMENT_RECEIVED = void 0;
exports.GUEST_TICKET = exports.GUEST_INFO_UPDATED = exports.DISPUTE_CREATED_CUSTOMER = exports.FULFILLMENT_ORDER_SHIPPED = exports.FULFILLMENT_READY_FOR_PICKUP = exports.REMINDER_TICKETING = exports.NEWSLETTER_THANK_YOU = exports.NEWSLETTER_SIGNUP_CONFIRMATION = exports.RECEIPT_CANCELLED_DONOR = exports.IMPACT_CHAIN_THANK_YOU = exports.SEPA_DEBIT_NOTICE = exports.MEMBERSHIP_MEMBERS_ONLY_NOT_ELIGIBLE = exports.MEMBERSHIP_MEMBER_CARD = exports.MEMBERSHIP_RENEWAL = exports.MEMBERSHIP_NEW_CARD_DONOR = exports.DONATION_RENEWAL = exports.TRANSFER_IN_PROGRESS_TICKETING = exports.AUCTION_BID_CANCELLED = exports.AUCTION_THANK_YOU_WINNER = exports.AUCTION_THANK_YOU_NON_WINNER = exports.AUCTION_NEW_TOP_BIDDER = exports.AUCTION_OUTBID = exports.AUCTION_BID_PLACED = exports.INVOICE_REMINDER_DONOR = exports.TRIBUTE_DONATION = exports.USER_OWNERSHIP_TRANSFERRED = exports.USER_NEW_DEVICE = exports.USER_DELETE_IMPORT_ERROR = exports.USER_ASSISTANT_VERIFICATION_CODE = exports.USER_PASSWORD_CHANGED = exports.USER_EMAIL_CHANGED = exports.USER_EMAIL_CHANGE_CONFIRMED = exports.USER_ADMIN_REVOKED = exports.USER_RESET_PASSWORD = void 0;
exports.THANK_YOU_SWEEPSTAKES_FREE_ENTRY = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderSweepstakesFreeEntriesConfirmed}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;
</div>
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">{{orgName}}</td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>

<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">{{labels.hi}} {{firstName}},</p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">{{labels.sweepstakesFreeEntriesConfirmed}}</h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">{{labels.sweepstakesFreeEntryLede}} <strong style="color: {{theme.tIntense}};">{{sweepstakesTitle}}</strong>.</p>
</td></tr>

<tr data-section="entries"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.noteBg}};{{#if theme.isDark}} border: 1px solid {{theme.bModerate}};{{/if}} border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px 18px 0;" class="mobile-pad-inner">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 12px;">{{labels.yourEntries}}</p>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#each entries}}
        <tr>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 600; color: {{../theme.tModerate}}; padding: 3px 0; line-height: 1.5;">{{../labels.entryNumber}} #{{number}}</td>
        </tr>
        {{/each}}
      </table>
    </td></tr>
    {{#if entriesUrl}}
    <tr><td style="padding: 15px 18px 18px;" class="mobile-pad-inner">
      <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{{entriesUrl}}" style="height:42px;v-text-anchor:middle;width:504px;" arcsize="29%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:17px;font-weight:bold;">{{labels.viewEntries}}</center></v:roundrect><![endif]-->
      <!--[if !mso]><!-->
      <a href="{{entriesUrl}}" target="_blank" class="cta-primary" style="display: block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 12px; border-radius: 6px; line-height: 1.4; text-align: center;">{{labels.viewEntries}}</a>
      <!--<![endif]-->
    </td></tr>
    {{else}}
    <tr><td style="height: 18px; font-size: 0; line-height: 0;">&nbsp;</td></tr>
    {{/if}}
  </table>
</td></tr>

<tr><td style="height: 30px; font-size: 0; line-height: 0;">&nbsp;</td></tr>
<!-- Zeffy branding footer. Param: labels.footerCopyrightParticipation (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightParticipation}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.THANK_YOU_TEAM_MEMBER_JOINED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderTeamMemberJoined}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.teamMemberJoinedTitle}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.teamMemberJoinedLinePrefix}} <strong style="color: {{theme.tIntense}};">{{memberName}}</strong> {{labels.teamMemberJoinedLineMid}} <strong style="color: {{theme.tIntense}};">{{teamTitle}}</strong> {{labels.teamMemberJoinedLineSuffix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>.
  </p>
</td></tr>

<!-- ========== 4. VIEW TEAM CTA ========== -->
<tr data-section="cta"><td style="padding: 16px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#if teamLink}}href="{{teamLink}}" {{/if}}style="height:42px;v-text-anchor:middle;width:540px;" arcsize="29%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:17px;font-weight:bold;">{{labels.teamMemberJoinedViewTeam}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#if teamLink}}href="{{teamLink}}" target="_blank" {{/if}}class="cta-primary" style="display: block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 12px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.teamMemberJoinedViewTeam}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 5. ENCOURAGE THE NEW MEMBER ========== -->
<tr data-section="encourage-note"><td style="padding: 18px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.teamMemberJoinedEncourageNote}}
  </p>
</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyrightTeamMemberJoined (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightTeamMemberJoined}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.THANK_YOU_DONATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{#if shouldHideAmounts}}{{labels.thankYouDonationNoAmount}}{{else}}{{labels.preheaderDonationConfirmed}} {{paidAmount}}.{{/if}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{#if shouldHideAmounts}}{{labels.thankYouDonationNoAmount}}{{else if isChequeReceived}}{{labels.chequeReceivedTitlePrefix}}{{orgName}} {{labels.chequeReceivedTitleMiddle}} {{donationAmount}}{{labels.chequeReceivedTitleSuffix}}{{else}}{{labels.thankYouDonationAmountPrefix}} {{donationAmount}}{{labels.thankYouDonationAmountSuffix}}{{/if}}
  </h1>
  {{#if hasTribute}}
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 9px;"><tr>
    <td style="background-color: {{theme.headerBg}}; border-radius: 8px; padding: 7px 12px;" valign="middle">
      <img src="{{iconHeart}}" width="16" height="16" alt="" style="display: inline-block; vertical-align: -3px; margin-right: 6px; border: 0;" /><span style="font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: 700; color: {{theme.tBrand}};">{{#if isInHonour}}{{labels.inHonourOf}}{{else}}{{labels.inMemoryOf}}{{/if}}{{#if tributeName}} {{tributeName}}{{/if}}</span>
    </td>
  </tr></table>
  {{/if}}
  {{#if isChequePending}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 3px;">
    {{labels.chequePendingDonationTo}} {{orgName}}. {{#if chequeReceiptPromised}}{{labels.chequePendingReceiptNote}}{{else}}{{labels.chequePendingReminder}}{{/if}}
  </p>
  {{else if isChequeReceived}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 3px;">
    {{orgName}} {{labels.chequeReceivedLede}}
  </p>
  {{else}}{{#unless isRecurring}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 3px;">
    {{labels.oneTimeDonationTo}} {{orgName}}.
  </p>
  {{else if showsRenewalScheduleSentence}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 3px;">
    {{labels.recurringDonationIsPrefix}} {{#if isQuarterly}}{{labels.recurrenceQuarterly}}{{else}}{{labels.recurrenceYearly}}{{/if}} {{labels.recurringDonationChargedOn}} {{recurringChargeSchedule}}{{labels.recurringDonationManageSuffix}} <a href="{{simplykConnectionLink}}" class="account-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.zeffyAccount}}</a>.
  </p>
  {{else}}{{#unless nextRenewalDate}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 3px;">
    {{labels.recurringDonationIsPrefix}} {{#if isWeekly}}{{labels.recurrenceWeekly}}{{else if isBiWeekly}}{{labels.recurrenceBiWeekly}}{{else}}{{labels.recurrenceMonthly}}{{/if}}.
  </p>
  {{/unless}}{{/unless}}{{/if}}
  {{#unless nextRenewalDate}}{{#unless showsRenewalScheduleSentence}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.manageDonations}} <a href="{{simplykConnectionLink}}" class="account-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.zeffyAccount}}</a>
  </p>
  {{/unless}}{{/unless}}
  {{#if proratedFromAmount}}{{#unless shouldHideAmounts}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.proratedPaymentPrefix}} <strong>{{donationAmount}} {{labels.proratedPaymentInsteadOf}} {{proratedFromAmount}}</strong> {{labels.proratedPaymentSuffix}}
  </p>
  {{/unless}}{{/if}}
  {{#if hasCumulativeReceipt}}{{#if hasReceipt}}
  <!-- cumulativeReceiptNote is a sentence fragment ending at the month word; the year token is dynamic (donation year + 1). -->
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tBrand}}; margin: 9px 0 0;">
    {{labels.cumulativeReceiptNote}} {{cumulativeReceiptYear}}.
  </p>
  {{/if}}{{/if}}
</td></tr>

<!-- ========== NEXT RENEWAL (recurring donations) ========== -->
{{#if isRecurring}}{{#if nextRenewalDate}}
<tr data-section="next-renewal"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="background-color: {{theme.headerBg}}; border-radius: 9px; padding: 18px;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td class="mfs11" valign="middle" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}};">{{labels.nextRenewal}}</td>
        <td class="mfs12" valign="middle" align="right" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}};">{{#unless shouldHideAmounts}}<strong>{{nextRenewalAmount}}</strong> {{labels.nextRenewalOn}} {{/unless}}{{nextRenewalDate}}</td>
      </tr></table>
      {{#if manageRecurringDonationUrl}}
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin-top: 15px;"><tr><td>
        <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{manageRecurringDonationUrl}}" {{/unless}}style="height:42px;v-text-anchor:middle;width:504px;" arcsize="29%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:17px;font-weight:bold;">{{labels.manageRecurringDonation}}</center></v:roundrect><![endif]-->
        <!--[if !mso]><!-->
        <a {{#unless isPreview}}href="{{manageRecurringDonationUrl}}" target="_blank" {{/unless}}class="cta-primary" data-test="manage-recurring-donation" style="display: block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 12px; border-radius: 6px; line-height: 1.4; text-align: center;">
          {{labels.manageRecurringDonation}}
        </a>
        <!--<![endif]-->
      </td></tr></table>
      {{/if}}
    </td>
  </tr></table>
</td></tr>
{{/if}}{{/if}}

<!-- ========== CHEQUE INSTRUCTIONS (until the organization receives the cheque) ========== -->
{{#if isChequePending}}{{#if chequeInstructions}}
<tr data-section="cheque-instructions"><td style="padding: 16px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="background-color: {{theme.headerBg}}; border-radius: 8px; padding: 16px;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 9px;">{{labels.chequeInstructionsTitle}}</p>
      <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0; white-space: pre-line;">{{chequeInstructions}}</p>
    </td>
  </tr></table>
</td></tr>
{{/if}}{{/if}}

<!-- ========== 4. DOWNLOAD TAX RECEIPT CTA (hidden for recurring donations with a cumulative receipt) ========== -->
{{#unless hasCumulativeReceipt}}{{#if receiptUrl}}
<tr data-section="cta"><td style="padding: 16px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{receiptUrl}}" {{/unless}}style="height:42px;v-text-anchor:middle;width:540px;" arcsize="29%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:17px;font-weight:bold;">{{labels.downloadTaxReceipt}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#unless isPreview}}href="{{receiptUrl}}" target="_blank" {{/unless}}class="cta-primary" style="display: block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 12px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.downloadTaxReceipt}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>
{{/if}}{{/unless}}

<!-- ========== 5. NOTE FROM ORGANIZER ========== -->
{{#if message}}
<tr data-section="note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.emailBg}}; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      {{!-- No quote glyph here on purpose (KRA-5052). A lone opening quote beside the heading read
            as a grammar error to organizations, and the design-system version that closes it sits
            centred on the card's border — which needs absolute positioning plus an image mask that
            Gmail and Outlook strip. The card's own outline already frames the message. --}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.4;">
        {{labels.aThankYouFrom}} {{orgName}}
      </p>
      <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
        {{{message}}}
      </div>
    </td></tr>
  </table>
</td></tr>
{{/if}}

<!-- ========== 6. RECEIPT ========== -->
<tr data-section="receipt"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
    <!-- Receipt header -->
    <tr><td style="padding: 0 0 12px;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0;">{{#if isChequePending}}{{labels.transactionInfo}}{{else}}{{labels.transactionReceipt}}{{/if}}</p>
    </td></tr>
    <!-- Buyer details -->
    <tr><td style="padding: 0;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{#if isDonation}}{{labels.donorName}}{{else if isSweepstakes}}{{labels.participantName}}{{else}}{{labels.buyerName}}{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{firstName}} {{lastName}}</td>
        </tr>
        {{#if companyName}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{labels.company}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{companyName}}</td>
        </tr>
        {{/if}}
        {{#if address}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap; vertical-align: top;">{{labels.location}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0; word-break: break-word; vertical-align: top;">{{address}}</td>
        </tr>
        {{/if}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{#if isDonation}}{{labels.donationDate}}{{else}}{{labels.date}}{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{date}}</td>
        </tr>
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{labels.method}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{paymentMethodDisplay}}</td>
        </tr>
        {{#if shippingAddress}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{labels.shippingAddress}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0; word-break: break-word;">{{shippingAddress}}</td>
        </tr>
        {{/if}}
      </table>
    </td></tr>
    <!-- Purchase / donation details -->
    <tr><td style="padding: 12px 0 0;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 6px;">{{#if isDonation}}{{labels.donationDetails}}{{else if isSweepstakes}}{{labels.participationDetails}}{{else}}{{labels.purchaseDetails}}{{/if}}</p>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#if isDonation}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{#if isOneTime}}{{labels.oneTimeDonation}}{{else if isWeekly}}{{labels.weeklyDonation}}{{else if isBiWeekly}}{{labels.biWeeklyDonation}}{{else if isMonthly}}{{labels.monthlyDonation}}{{else if isQuarterly}}{{labels.quarterlyDonation}}{{else}}{{labels.yearlyDonation}}{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{#unless shouldHideAmounts}}{{donationAmount}}{{/unless}}</td>
        </tr>
        {{else}}
        {{#each tickets}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tModerate}}; padding: 3px 0; word-break: break-word;">{{#unless ../isAuction}}{{number}} × {{/unless}}{{title}}{{#if variantValues}}{{#each variantValues}} • {{this}}{{/each}}{{else}}{{#if variantLabel}} — {{variantLabel}}{{/if}}{{/if}}{{#if taxMarkers}} <span style="color: {{../theme.tQuiet}};">({{taxMarkers}} {{#if hasMultipleTaxMarkers}}{{../labels.taxAppliesSuffixMany}}{{else}}{{../labels.taxAppliesSuffixOne}}{{/if}})</span>{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{formattedPrice}}</td>
        </tr>
        {{/each}}
        {{#each addOns}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tModerate}}; padding: 3px 0; word-break: break-word;">{{number}} × <span style="color: {{../theme.tBrand}};">{{../labels.addOnReceiptPrefix}}</span> {{title}}{{#if taxMarkers}} <span style="color: {{../theme.tQuiet}};">({{taxMarkers}} {{#if hasMultipleTaxMarkers}}{{../labels.taxAppliesSuffixMany}}{{else}}{{../labels.taxAppliesSuffixOne}}{{/if}})</span>{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{formattedPrice}}</td>
        </tr>
        {{/each}}
        {{#if extraDonation}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.additionalDonation}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{extraDonation}}</td>
        </tr>
        {{/if}}
        {{#if shippingFeeAmount}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.shippingFee}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{shippingFeeAmount}}</td>
        </tr>
        {{/if}}
        {{#if discountAmount}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.discount}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">−{{discountAmount}}</td>
        </tr>
        {{/if}}
        {{#if proratedAdjustmentAmount}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.proratedAdjustment}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">−{{proratedAdjustmentAmount}}</td>
        </tr>
        {{/if}}
        {{/if}}
        {{#each orderTaxes}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tModerate}}; padding: 3px 0;"><span style="color: {{../theme.tQuiet}};">({{marker}})</span> {{label}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{amount}}</td>
        </tr>
        {{/each}}
        {{#if shouldDisplayContributionLine}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.optionalContributionToZeffy}}{{#if shouldDisplayDonorRefundOptionInEmail}} – <a href="{{donorRefundPageLink}}" style="color: {{theme.tBrand}}; text-decoration: underline;">{{labels.learnMore}}</a>{{else}} – <a href="https://www.zeffy.com/home/100-free-for-donors?UTM_source=email_whatiszeffy" style="color: {{theme.tBrand}}; text-decoration: underline;">{{labels.whatIsZeffy}}</a>{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{contributionAmount}}</td>
        </tr>
        {{/if}}
      </table>
    </td></tr>
    {{#if shouldHideAmounts}}
    <!-- No total: the value is an internal record the donor self-assesses, so no figure is stated to them. -->
    <tr><td style="padding: 0; font-size: 0; line-height: 0; height: {{#if soldByTaxNumbers}}12px{{else}}30px{{/if}};">&nbsp;</td></tr>
    {{else}}
    <!-- Divider -->
    <tr><td style="padding: 12px 0;">
      <div style="height: 1px; background-color: {{theme.bSupershy}};"></div>
    </td></tr>
    <!-- Total -->
    <tr><td style="padding: 0 0 {{#if soldByTaxNumbers}}12px{{else}}30px{{/if}};">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td class="mfs14" style="font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: 700; line-height: 1.3; color: {{theme.tIntense}};">{{#if paymentHasFailed}}{{labels.totalDue}}{{else if isChequePending}}{{labels.total}}{{else}}{{labels.totalPaid}}{{/if}}</td>
        <td align="right" class="mfs14" style="font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: 700; line-height: 1.3; color: {{theme.tIntense}};">{{paidAmount}}</td>
      </tr></table>
    </td></tr>
    {{/if}}

    {{#if soldByTaxNumbers}}
    <!-- Sold by + tax registration numbers — only when at least one applied tax carries a tax ID -->
    <tr><td style="padding: 0 0 12px;">
      <div style="height: 1px; background-color: {{theme.bSupershy}};"></div>
    </td></tr>
    <tr><td style="padding: 0 0 30px;">
      <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; margin: 0;"><span style="color: {{theme.tQuiet}};">{{labels.soldBy}}</span> <span style="color: {{theme.tIntense}};">{{orgName}}</span></p>
      <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; margin: 6px 0 0;">{{#each soldByTaxNumbers}}{{#unless @first}}<span style="color: {{../theme.bSupershy}};">&nbsp;&nbsp;|&nbsp;&nbsp;</span>{{/unless}}<span style="color: {{../theme.tQuiet}};">{{name}}</span> <span style="color: {{../theme.tIntense}};">{{number}}</span>{{/each}}</p>
    </td></tr>
    {{/if}}

    {{#if isOfflinePayment}}
    <!-- Offline (cheque/cash) payment still owed to and collected by the organizer -->
    <tr><td style="padding: 0 0 30px;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; margin: 0;">
        {{#if isDonation}}{{labels.offlinePaymentPendingPrefixDonation}}{{else if isSweepstakes}}{{labels.offlinePaymentPendingPrefixParticipation}}{{else}}{{labels.offlinePaymentPendingPrefixPurchase}}{{/if}} <strong>{{#if isCashPayment}}{{labels.offlinePaymentMethodCash}}{{else}}{{labels.offlinePaymentMethodCheque}}{{/if}}</strong> {{labels.offlinePaymentArrangePrefix}} {{orgName}} {{labels.offlinePaymentArrangeSuffix}}
      </p>
    </td></tr>
    {{/if}}

    {{#if hasGiftAidConfirmation}}
    <tr><td style="padding: 2px 0 0;">
      {{#if iconGiftAid}}
      <img src="{{iconGiftAid}}" width="66" alt="Gift Aid" style="display: block; border: 0; margin: 0 0 10px;" />
      {{/if}}
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; color: {{theme.tIntense}}; margin: 0;">{{labels.giftAidAdded}} {{hasGiftAid}}</p>
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: {{theme.tQuiet}}; line-height: 1.5; margin: 6px 0 0;">
        {{labels.giftAidDeclaration}} {{orgName}} {{labels.giftAidExtra}} {{giftaidExtraAmount}} {{labels.giftAidNoCost}}
      </p>
    </td></tr>
    {{/if}}

    {{#if shouldDisplayCharityNumberOnTransactionReceipt}}
    <tr><td style="padding: {{#if hasGiftAidConfirmation}}14px{{else}}2px{{/if}} 0 0;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: {{theme.tQuiet}}; line-height: 1.5; margin: 0;">
        {{labels.receiptEmittedBy}} {{orgName}}<br />
        {{transactionReceiptCharityNumberLabel}} {{charityNumber}}
      </p>
    </td></tr>
    {{/if}}

    {{#if registeredCharityName}}
    <tr><td style="padding: {{#if (or hasGiftAidConfirmation shouldDisplayCharityNumberOnTransactionReceipt)}}14px{{else}}2px{{/if}} 0 0;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: {{theme.tQuiet}}; line-height: 1.5; margin: 0;">
        <span style="color: {{theme.tIntense}};">{{registeredCharityName}}</span> {{labels.registeredCharityStatement}} {{registeredCharityNumber}}
      </p>
    </td></tr>
    {{/if}}

    {{#if (or hasGiftAidConfirmation shouldDisplayCharityNumberOnTransactionReceipt registeredCharityName)}}
    <tr><td style="padding: 0; font-size: 0; line-height: 0; height: 24px;">&nbsp;</td></tr>
    {{/if}}
  </table>
</td></tr>

<!-- ========== 7. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.THANK_YOU_TICKETING = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{#if isSweepstakes}}{{labels.preheaderSweepstakesConfirmed}}{{else}}{{labels.preheaderConfirmed}} {{paidAmount}}.{{/if}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  {{#if isMembership}}
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{#if isBuyerAMember}}{{labels.thankYouMember}}{{else}}{{labels.thankYouMembershipPurchase}}{{/if}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 3px;">
    {{labels.membershipSecured}}
  </p>
  {{#if isRecurrent}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{#if isMonthly}}{{labels.membershipRecurringMonthly}}{{else}}{{labels.membershipRecurringAnnual}}{{/if}} <a href="{{simplykConnectionLink}}" class="account-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.zeffyAccount}}</a>.
  </p>
  {{/if}}
  {{else if isSweepstakes}}
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.sweepstakesParticipationConfirmed}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 3px;">
    {{labels.sweepstakesParticipationSecured}}
  </p>
  {{else if isEventForm}}
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{#if isDonationOnly}}{{labels.thankYouDonationTo}}{{else if isFreeOrder}}{{labels.thankYouReservationTo}}{{else}}{{labels.thankYouPurchaseTo}}{{/if}} {{eventTitle}}
  </h1>
  {{#unless isDonationOnly}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 3px;">
    {{#if isSingleTicket}}{{labels.singleTicketBooked}}{{else}}{{labels.multipleTicketsBooked}}{{/if}}
  </p>
  {{/unless}}
  {{else if isPurchaseWording}}
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.thankYouPurchase}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 3px;">
    {{#if isLotteryForm}}{{#if isSingleTicket}}{{labels.purchaseLotterySingleTicket}}{{else}}{{labels.purchaseLotteryMultipleTickets}}{{/if}}{{else}}{{labels.purchaseItemsSecured}}{{/if}}
  </p>
  {{else}}
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.thankYouDonationTo}} {{eventTitle}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 3px;">
    {{#if isSingleTicket}}{{labels.singleTicketBooked}}{{else}}{{labels.multipleTicketsBooked}}{{/if}}
  </p>
  {{/if}}
  {{#unless isMembership}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{#if isSweepstakes}}{{labels.manageSweepstakesParticipation}}{{else}}{{labels.managePurchase}}{{/if}} <a href="{{simplykConnectionLink}}" class="account-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.zeffyAccount}}</a>
  </p>
  {{/unless}}
</td></tr>

<!-- ========== 4. ORDER BLOCK ========== -->
<tr data-section="order"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.noteBg}};{{#if theme.isDark}} border: 1px solid {{theme.bModerate}};{{/if}} border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <!-- Order items -->
    <tr><td style="padding: 18px 18px 0;" class="mobile-pad-inner">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 15px;">{{#if isSweepstakes}}{{labels.yourEntries}}{{else}}{{labels.yourOrder}}{{/if}}</p>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#each tickets}}
        <tr>
          <td class="mfs12" width="15" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{../theme.tOrderNumber}}; text-align: right; padding: 3px 6px 3px 0; vertical-align: baseline; font-variant-numeric: tabular-nums; line-height: 1.5;">{{number}}×</td>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 600; color: {{../theme.tModerate}}; padding: 3px 0; vertical-align: baseline; line-height: 1.5; word-break: break-word;">{{title}}{{#if variantValues}}{{#each variantValues}} • {{this}}{{/each}}{{else}}{{#if variantLabel}} — {{variantLabel}}{{/if}}{{/if}}</td>
        </tr>
        {{/each}}
        {{#if (or extraDonation addOns.length)}}
        <tr>
          <td colspan="2" style="padding: 9px 0 9px 0; line-height: 0; font-size: 0; mso-line-height-rule: exactly;">
            <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
              <td style="border-top: 1px dashed {{theme.bModerate}}; font-size: 0; line-height: 0; height: 0; mso-line-height-rule: exactly;">&nbsp;</td>
            </tr></table>
          </td>
        </tr>
        {{/if}}
        {{#if extraDonation}}
        <tr>
          <td class="mfs12" width="15" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tQuiet}}; text-align: right; padding: 0 6px 3px 0; vertical-align: baseline; line-height: 1.5;">+</td>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 600; color: {{theme.tModerate}}; padding: 0 0 3px; vertical-align: baseline; line-height: 1.5;">{{labels.additionalDonation}} {{extraDonation}}</td>
        </tr>
        {{/if}}
        {{#each addOns}}
        <tr>
          <td class="mfs12" width="15" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{../theme.tQuiet}}; text-align: right; padding: 0 6px 3px 0; vertical-align: baseline; font-variant-numeric: tabular-nums; line-height: 1.5;">{{#if (eq number 1)}}+{{else}}{{number}}×{{/if}}</td>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 600; color: {{../theme.tModerate}}; padding: 0 0 3px; vertical-align: baseline; line-height: 1.5; word-break: break-word;">{{title}}</td>
        </tr>
        {{/each}}
      </table>
    </td></tr>
    <!-- CTAs -->
    {{#if (or eTicketUrl webBasedEventTicketUrl receiptUrl)}}
    <tr><td style="padding: 15px 18px 18px;" class="mobile-pad-inner">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-cta-stack"><tr>
        {{#if (or eTicketUrl webBasedEventTicketUrl)}}
        <td width="50%" style="padding-right: 4px;">
          <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{#if webBasedEventTicketUrl}}{{webBasedEventTicketUrl}}{{else}}{{eTicketUrl}}{{/if}}" {{/unless}}style="height:42px;v-text-anchor:middle;width:248px;" arcsize="29%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{#if isSweepstakes}}{{labels.viewEntries}}{{else if isMembership}}{{#if isSingleTicket}}{{labels.downloadMemberCard}}{{else}}{{labels.downloadMemberCards}}{{/if}}{{else if webBasedEventTicketUrl}}{{labels.viewTickets}}{{else}}{{labels.downloadETicket}}{{/if}}</center></v:roundrect><![endif]-->
          <!--[if !mso]><!-->
          <a {{#unless isPreview}}href="{{#if webBasedEventTicketUrl}}{{webBasedEventTicketUrl}}{{else}}{{eTicketUrl}}{{/if}}" target="_blank" {{/unless}}class="cta-primary" style="display: block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 12px; border-radius: 6px; line-height: 1.4; text-align: center;">
            {{#if isSweepstakes}}{{labels.viewEntries}}{{else if isMembership}}{{#if isSingleTicket}}{{labels.downloadMemberCard}}{{else}}{{labels.downloadMemberCards}}{{/if}}{{else if webBasedEventTicketUrl}}{{labels.viewTickets}}{{else}}{{labels.downloadETicket}}{{/if}}
          </a>
          <!--<![endif]-->
        </td>
        {{/if}}
        {{#if receiptUrl}}
        <td width="{{#if (or eTicketUrl webBasedEventTicketUrl)}}50%{{else}}100%{{/if}}" style="{{#if (or eTicketUrl webBasedEventTicketUrl)}}padding-left: 4px;{{/if}}">
          {{#if (or eTicketUrl webBasedEventTicketUrl)}}
          <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{receiptUrl}}" {{/unless}}style="height:42px;v-text-anchor:middle;width:248px;" arcsize="29%" fillcolor="{{theme.secondaryCtaBg}}" strokecolor="{{theme.secondaryCtaBorder}}"><w:anchorlock/><center style="color:{{theme.secondaryCtaText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.downloadTaxReceipt}}</center></v:roundrect><![endif]-->
          <!--[if !mso]><!-->
          <a {{#unless isPreview}}href="{{receiptUrl}}" target="_blank" {{/unless}}class="cta-secondary" style="display: block; background-color: {{#if theme.isDark}}transparent{{else}}{{theme.secondaryCtaBg}}{{/if}}; color: {{theme.secondaryCtaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 8px 12px; border-radius: 6px; line-height: 1.4; text-align: center; border: 1px solid {{theme.secondaryCtaBorder}};">
            {{labels.downloadTaxReceipt}}
          </a>
          <!--<![endif]-->
          {{else}}
          <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{receiptUrl}}" {{/unless}}style="height:42px;v-text-anchor:middle;width:504px;" arcsize="29%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:17px;font-weight:bold;">{{labels.downloadTaxReceipt}}</center></v:roundrect><![endif]-->
          <!--[if !mso]><!-->
          <a {{#unless isPreview}}href="{{receiptUrl}}" target="_blank" {{/unless}}class="cta-primary" style="display: block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 12px; border-radius: 6px; line-height: 1.4; text-align: center;">
            {{labels.downloadTaxReceipt}}
          </a>
          <!--<![endif]-->
          {{/if}}
        </td>
        {{/if}}
      </tr></table>
      {{#if (or appleWalletUrl googleWalletUrl)}}
<!-- Wallet badges — both always shown (no device detection), buyer taps the one matching their device -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin-top: 15px;"><tr>
  <td align="center">
    <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
      {{#if appleWalletUrl}}
      <td style="padding: 0 3px;">
        <a {{#unless isPreview}}href="{{appleWalletUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
          <img src="{{badgeAppleWalletImg}}" width="78" height="24" alt="{{labels.addToAppleWallet}}" style="display: block; border: 0; width: 78px; height: 24px;" />
        </a>
      </td>
      {{/if}}
      {{#if googleWalletUrl}}
      <td style="padding: 0 3px;">
        <a {{#unless isPreview}}href="{{googleWalletUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
          <img src="{{badgeGoogleWalletImg}}" width="87" height="24" alt="{{labels.addToGoogleWallet}}" style="display: block; border: 0; width: 87px; height: 24px;" />
        </a>
      </td>
      {{/if}}
    </tr></table>
  </td>
</tr></table>
{{/if}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: {{theme.tQuiet}}; text-align: center; margin: 15px 0 0; line-height: 1.4;">
        {{labels.fullReceiptBelow}}
      </p>
    </td></tr>
    {{else}}
    <tr><td style="padding: 0 18px 18px;" class="mobile-pad-inner">{{#if (or appleWalletUrl googleWalletUrl)}}
<!-- Wallet badges — both always shown (no device detection), buyer taps the one matching their device -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin-top: 15px;"><tr>
  <td align="center">
    <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
      {{#if appleWalletUrl}}
      <td style="padding: 0 3px;">
        <a {{#unless isPreview}}href="{{appleWalletUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
          <img src="{{badgeAppleWalletImg}}" width="78" height="24" alt="{{labels.addToAppleWallet}}" style="display: block; border: 0; width: 78px; height: 24px;" />
        </a>
      </td>
      {{/if}}
      {{#if googleWalletUrl}}
      <td style="padding: 0 3px;">
        <a {{#unless isPreview}}href="{{googleWalletUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
          <img src="{{badgeGoogleWalletImg}}" width="87" height="24" alt="{{labels.addToGoogleWallet}}" style="display: block; border: 0; width: 87px; height: 24px;" />
        </a>
      </td>
      {{/if}}
    </tr></table>
  </td>
</tr></table>
{{/if}}</td></tr>
    {{/if}}
  </table>
</td></tr>

<!-- ========== 4.5 PICK UP LOCATION & INSTRUCTIONS ========== -->
{{#if pickupAddress}}
<tr data-section="pickup"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.noteBg}};{{#if theme.isDark}} border: 1px solid {{theme.bModerate}};{{/if}} border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px 18px 0;" class="mobile-pad-inner">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 12px; line-height: 1.5;">{{labels.pickupLocationAndInstructions}}</p>
    </td></tr>
    <tr><td style="padding: 0 18px 18px;" class="mobile-pad-inner">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td width="{{#if pickupInstructions}}50%{{else}}100%{{/if}}" valign="top" class="mobile-stack" style="{{#if pickupInstructions}}padding-right: 24px;{{/if}}">
          <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
            {{#if iconPin}}
            <td width="20" valign="top" style="padding-right: 5px; padding-top: 1px;">
              <img src="{{iconPin}}" width="15" height="15" alt="" style="display: block; border: 0;" />
            </td>
            {{/if}}
            <td valign="top">
              <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tIntense}}; margin: 0; line-height: 1.5;">{{pickupAddress}}</p>
              {{#if pickupMapLink}}
              <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; margin: 4px 0 0; line-height: 1.4;">
                <a href="{{pickupMapLink}}" class="map-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.openInMaps}}</a>
              </p>
              {{/if}}
            </td>
          </tr></table>
        </td>
        {{#if pickupInstructions}}
        <td width="50%" valign="top" class="mobile-stack mobile-stack-divider" style="padding-left: 0;">
          <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
            {{#if iconEdit}}
            <td width="20" valign="top" style="padding-right: 5px; padding-top: 1px;">
              <img src="{{iconEdit}}" width="15" height="15" alt="" style="display: block; border: 0;" />
            </td>
            {{/if}}
            <td valign="top">
              <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 4px; line-height: 1.5;">{{labels.pickupInstructions}}</p>
              <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; margin: 0; line-height: 1.4;">{{pickupInstructions}}</p>
            </td>
          </tr></table>
        </td>
        {{/if}}
      </tr></table>
    </td></tr>
  </table>
</td></tr>
{{/if}}

<!-- ========== 5. NOTE FROM ORGANIZER ========== -->
{{#if message}}
<tr data-section="note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.emailBg}}; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      {{!-- No quote glyph here on purpose (KRA-5052). A lone opening quote beside the heading read
            as a grammar error to organizations, and the design-system version that closes it sits
            centred on the card's border — which needs absolute positioning plus an image mask that
            Gmail and Outlook strip. The card's own outline already frames the message. --}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.4;">
        {{labels.aThankYouFrom}} {{orgName}}
      </p>
      <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
        {{{message}}}
      </div>
    </td></tr>
  </table>
</td></tr>
{{/if}}

<!-- ========== 6. EVENT / RAFFLE DETAILS ========== -->
<!-- Event / raffle details card (date block, venue or online link, add-to-calendar). Shared by the
     ticketing thank-you and the event reminder. Block partial: children render inside the card, under
     the details (the reminder puts its ticket CTAs there); call it with an empty block otherwise. -->
{{#if (or eventStartDate eventAddress eventOnlineUrl)}}
<tr data-section="event"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.noteBg}};{{#if theme.isDark}} border: 1px solid {{theme.bModerate}};{{/if}} border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px 18px 0;" class="mobile-pad-inner">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 6px; line-height: 1.5;">{{#if isSweepstakes}}{{labels.sweepstakesDetails}}{{else if isLotteryForm}}{{labels.raffleDetails}}{{else}}{{labels.eventDetails}}{{/if}}</p>
      <p class="mfs13_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 16px; font-weight: 700; color: {{theme.tModerate}}; margin: 0; line-height: 1.3;">{{eventTitle}}</p>
    </td></tr>
    {{#if theme.isDark}}
    <tr><td style="padding: 14px 0 0; font-size: 0; line-height: 0; mso-line-height-rule: exactly;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="border-top: 1px solid {{theme.bModerate}}; font-size: 0; line-height: 0; height: 0; mso-line-height-rule: exactly;">&nbsp;</td>
      </tr></table>
    </td></tr>
    {{/if}}
    <tr><td style="padding: {{#if theme.isDark}}14px{{else}}12px{{/if}} 18px 18px;" class="mobile-pad-inner">
      {{#if eventCalendarBesideDate}}
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td width="48" valign="middle" style="padding-right: 9px;">
          <table width="48" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: transparent; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 6px; text-align: center; border-collapse: separate; border-spacing: 0;">
            <tr><td style="padding: 4px 4px 1px;">
              <p class="mfs7_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 9px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: {{theme.tBrand}}; margin: 0; line-height: 1;">{{eventMonth}}</p>
            </td></tr>
            <tr><td>
              <p class="mfs15" style="font-family: Arial, Helvetica, sans-serif; font-size: 18px; font-weight: 700; line-height: 1.05; color: {{theme.tIntense}}; margin: 0; letter-spacing: -0.02em;">{{eventDay}}</p>
            </td></tr>
            <tr><td style="padding: 1px 4px 5px;">
              <p class="mfs7_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 9px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: {{theme.tBrand}}; margin: 0; line-height: 1;">{{eventWeekday}}</p>
            </td></tr>
          </table>
        </td>
        <td valign="middle" style="padding-right: 24px;">
          <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 2px; line-height: 1.5;">{{eventDateLabel}}</p>
          <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{#if theme.isDark}}{{theme.tBrand}}{{else}}{{theme.tQuiet}}{{/if}}; margin: 0; line-height: 1.4;">{{eventTimeRange}}</p>
        </td>
        <td valign="middle" class="mobile-cal-beside" style="white-space: nowrap;">
          <a href="{{calendarFileUrl}}" class="cal-btn mfs10_5" style="display: inline-block; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tBrand}}; text-decoration: none; line-height: 1.5; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 1000px; padding: 6px 12px;">
            {{#if iconCalendar}}<img src="{{iconCalendar}}" width="12" height="12" alt="" style="display: inline-block; vertical-align: -2px; margin-right: 6px; border: 0;" />{{/if}}<span>{{labels.addToCalendar}}</span>
          </a>
        </td>
      </tr></table>
      {{else}}
      {{#if (or eventStartDate (or eventAddress eventOnlineUrl))}}
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        {{#if eventStartDate}}
        <td width="{{#if (or eventAddress eventOnlineUrl)}}50%{{else}}100%{{/if}}" valign="middle" class="mobile-stack" style="{{#if (or eventAddress eventOnlineUrl)}}padding-right: 24px;{{/if}}">
          <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
            <td width="48" valign="middle" style="padding-right: 12px;">
              <table width="48" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: transparent; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 6px; text-align: center; border-collapse: separate; border-spacing: 0;">
                <tr><td style="padding: 4px 4px 1px;">
                  <p class="mfs7_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 9px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: {{theme.tBrand}}; margin: 0; line-height: 1;">{{eventMonth}}</p>
                </td></tr>
                <tr><td>
                  <p class="mfs15" style="font-family: Arial, Helvetica, sans-serif; font-size: 18px; font-weight: 700; line-height: 1.05; color: {{theme.tIntense}}; margin: 0; letter-spacing: -0.02em;">{{eventDay}}</p>
                </td></tr>
                <tr><td style="padding: 1px 4px 5px;">
                  <p class="mfs7_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 9px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: {{theme.tBrand}}; margin: 0; line-height: 1;">{{eventWeekday}}</p>
                </td></tr>
              </table>
            </td>
            <td valign="middle">
              <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 2px; line-height: 1.5;">{{eventDateLabel}}</p>
              <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{#if theme.isDark}}{{theme.tBrand}}{{else}}{{theme.tQuiet}}{{/if}}; margin: 0; line-height: 1.4;">{{eventTimeRange}}</p>
            </td>
          </tr></table>
        </td>
        {{/if}}
        {{#if (or eventAddress eventOnlineUrl)}}
        <td width="{{#if eventStartDate}}50%{{else}}100%{{/if}}" valign="middle" class="mobile-stack {{#if eventStartDate}}mobile-stack-divider{{/if}}" style="{{#if eventStartDate}}padding-left: 0;{{/if}}">
          {{#if eventOnlineUrl}}
          <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
            {{#if iconOnline}}
            <td width="20" valign="top" style="padding-right: 5px; padding-top: 1px;">
              <img src="{{iconOnline}}" width="15" height="15" alt="" style="display: block; border: 0;" />
            </td>
            {{/if}}
            <td valign="top">
              <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tIntense}}; margin: 0; line-height: 1.5;">{{labels.onlineEvent}}</p>
              <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; margin: 4px 0 0; line-height: 1.4;">
                <a href="{{eventOnlineUrl}}" class="map-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.joinOnline}}</a>
              </p>
            </td>
          </tr></table>
          {{else}}
          <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
            {{#if iconPin}}
            <td width="20" valign="top" style="padding-right: 5px; padding-top: 1px;">
              <img src="{{iconPin}}" width="15" height="15" alt="" style="display: block; border: 0;" />
            </td>
            {{/if}}
            <td valign="top">
              <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tIntense}}; margin: 0; line-height: 1.5;">{{eventAddress}}</p>
              {{#if eventMapLink}}
              <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; margin: 4px 0 0; line-height: 1.4;">
                <a href="{{eventMapLink}}" class="map-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.openInMaps}}</a>
              </p>
              {{/if}}
            </td>
          </tr></table>
          {{/if}}
        </td>
        {{/if}}
      </tr></table>
      {{/if}}
      {{#if calendarFileUrl}}
      {{#unless eventCalendarBesideDate}}
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin-top: 12px;"><tr>
        <td>
          <a href="{{calendarFileUrl}}" class="cal-btn mfs10_5" style="display: inline-block; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tBrand}}; text-decoration: none; line-height: 1.5; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 1000px; padding: 6px 12px;">
            {{#if iconCalendar}}<img src="{{iconCalendar}}" width="12" height="12" alt="" style="display: inline-block; vertical-align: -2px; margin-right: 6px; border: 0;" />{{/if}}<span>{{labels.addToCalendar}}</span>
          </a>
        </td>
      </tr></table>
      {{/unless}}
      {{/if}}
      {{/if}}
      
    </td></tr>
  </table>
</td></tr>
{{/if}}

<!-- ========== 7. RECEIPT ========== -->
<tr data-section="receipt"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
    <!-- Receipt header -->
    <tr><td style="padding: 0 0 12px;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0;">{{#if isChequePending}}{{labels.transactionInfo}}{{else}}{{labels.transactionReceipt}}{{/if}}</p>
    </td></tr>
    <!-- Buyer details -->
    <tr><td style="padding: 0;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{#if isDonation}}{{labels.donorName}}{{else if isSweepstakes}}{{labels.participantName}}{{else}}{{labels.buyerName}}{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{firstName}} {{lastName}}</td>
        </tr>
        {{#if companyName}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{labels.company}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{companyName}}</td>
        </tr>
        {{/if}}
        {{#if address}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap; vertical-align: top;">{{labels.location}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0; word-break: break-word; vertical-align: top;">{{address}}</td>
        </tr>
        {{/if}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{#if isDonation}}{{labels.donationDate}}{{else}}{{labels.date}}{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{date}}</td>
        </tr>
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{labels.method}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{paymentMethodDisplay}}</td>
        </tr>
        {{#if shippingAddress}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{labels.shippingAddress}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0; word-break: break-word;">{{shippingAddress}}</td>
        </tr>
        {{/if}}
      </table>
    </td></tr>
    <!-- Purchase / donation details -->
    <tr><td style="padding: 12px 0 0;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 6px;">{{#if isDonation}}{{labels.donationDetails}}{{else if isSweepstakes}}{{labels.participationDetails}}{{else}}{{labels.purchaseDetails}}{{/if}}</p>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#if isDonation}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{#if isOneTime}}{{labels.oneTimeDonation}}{{else if isWeekly}}{{labels.weeklyDonation}}{{else if isBiWeekly}}{{labels.biWeeklyDonation}}{{else if isMonthly}}{{labels.monthlyDonation}}{{else if isQuarterly}}{{labels.quarterlyDonation}}{{else}}{{labels.yearlyDonation}}{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{#unless shouldHideAmounts}}{{donationAmount}}{{/unless}}</td>
        </tr>
        {{else}}
        {{#each tickets}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tModerate}}; padding: 3px 0; word-break: break-word;">{{#unless ../isAuction}}{{number}} × {{/unless}}{{title}}{{#if variantValues}}{{#each variantValues}} • {{this}}{{/each}}{{else}}{{#if variantLabel}} — {{variantLabel}}{{/if}}{{/if}}{{#if taxMarkers}} <span style="color: {{../theme.tQuiet}};">({{taxMarkers}} {{#if hasMultipleTaxMarkers}}{{../labels.taxAppliesSuffixMany}}{{else}}{{../labels.taxAppliesSuffixOne}}{{/if}})</span>{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{formattedPrice}}</td>
        </tr>
        {{/each}}
        {{#each addOns}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tModerate}}; padding: 3px 0; word-break: break-word;">{{number}} × <span style="color: {{../theme.tBrand}};">{{../labels.addOnReceiptPrefix}}</span> {{title}}{{#if taxMarkers}} <span style="color: {{../theme.tQuiet}};">({{taxMarkers}} {{#if hasMultipleTaxMarkers}}{{../labels.taxAppliesSuffixMany}}{{else}}{{../labels.taxAppliesSuffixOne}}{{/if}})</span>{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{formattedPrice}}</td>
        </tr>
        {{/each}}
        {{#if extraDonation}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.additionalDonation}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{extraDonation}}</td>
        </tr>
        {{/if}}
        {{#if shippingFeeAmount}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.shippingFee}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{shippingFeeAmount}}</td>
        </tr>
        {{/if}}
        {{#if discountAmount}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.discount}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">−{{discountAmount}}</td>
        </tr>
        {{/if}}
        {{#if proratedAdjustmentAmount}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.proratedAdjustment}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">−{{proratedAdjustmentAmount}}</td>
        </tr>
        {{/if}}
        {{/if}}
        {{#each orderTaxes}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tModerate}}; padding: 3px 0;"><span style="color: {{../theme.tQuiet}};">({{marker}})</span> {{label}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{amount}}</td>
        </tr>
        {{/each}}
        {{#if shouldDisplayContributionLine}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.optionalContributionToZeffy}}{{#if shouldDisplayDonorRefundOptionInEmail}} – <a href="{{donorRefundPageLink}}" style="color: {{theme.tBrand}}; text-decoration: underline;">{{labels.learnMore}}</a>{{else}} – <a href="https://www.zeffy.com/home/100-free-for-donors?UTM_source=email_whatiszeffy" style="color: {{theme.tBrand}}; text-decoration: underline;">{{labels.whatIsZeffy}}</a>{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{contributionAmount}}</td>
        </tr>
        {{/if}}
      </table>
    </td></tr>
    {{#if shouldHideAmounts}}
    <!-- No total: the value is an internal record the donor self-assesses, so no figure is stated to them. -->
    <tr><td style="padding: 0; font-size: 0; line-height: 0; height: {{#if soldByTaxNumbers}}12px{{else}}30px{{/if}};">&nbsp;</td></tr>
    {{else}}
    <!-- Divider -->
    <tr><td style="padding: 12px 0;">
      <div style="height: 1px; background-color: {{theme.bSupershy}};"></div>
    </td></tr>
    <!-- Total -->
    <tr><td style="padding: 0 0 {{#if soldByTaxNumbers}}12px{{else}}30px{{/if}};">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td class="mfs14" style="font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: 700; line-height: 1.3; color: {{theme.tIntense}};">{{#if paymentHasFailed}}{{labels.totalDue}}{{else if isChequePending}}{{labels.total}}{{else}}{{labels.totalPaid}}{{/if}}</td>
        <td align="right" class="mfs14" style="font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: 700; line-height: 1.3; color: {{theme.tIntense}};">{{paidAmount}}</td>
      </tr></table>
    </td></tr>
    {{/if}}

    {{#if soldByTaxNumbers}}
    <!-- Sold by + tax registration numbers — only when at least one applied tax carries a tax ID -->
    <tr><td style="padding: 0 0 12px;">
      <div style="height: 1px; background-color: {{theme.bSupershy}};"></div>
    </td></tr>
    <tr><td style="padding: 0 0 30px;">
      <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; margin: 0;"><span style="color: {{theme.tQuiet}};">{{labels.soldBy}}</span> <span style="color: {{theme.tIntense}};">{{orgName}}</span></p>
      <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; margin: 6px 0 0;">{{#each soldByTaxNumbers}}{{#unless @first}}<span style="color: {{../theme.bSupershy}};">&nbsp;&nbsp;|&nbsp;&nbsp;</span>{{/unless}}<span style="color: {{../theme.tQuiet}};">{{name}}</span> <span style="color: {{../theme.tIntense}};">{{number}}</span>{{/each}}</p>
    </td></tr>
    {{/if}}

    {{#if isOfflinePayment}}
    <!-- Offline (cheque/cash) payment still owed to and collected by the organizer -->
    <tr><td style="padding: 0 0 30px;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; margin: 0;">
        {{#if isDonation}}{{labels.offlinePaymentPendingPrefixDonation}}{{else if isSweepstakes}}{{labels.offlinePaymentPendingPrefixParticipation}}{{else}}{{labels.offlinePaymentPendingPrefixPurchase}}{{/if}} <strong>{{#if isCashPayment}}{{labels.offlinePaymentMethodCash}}{{else}}{{labels.offlinePaymentMethodCheque}}{{/if}}</strong> {{labels.offlinePaymentArrangePrefix}} {{orgName}} {{labels.offlinePaymentArrangeSuffix}}
      </p>
    </td></tr>
    {{/if}}

    {{#if hasGiftAidConfirmation}}
    <tr><td style="padding: 2px 0 0;">
      {{#if iconGiftAid}}
      <img src="{{iconGiftAid}}" width="66" alt="Gift Aid" style="display: block; border: 0; margin: 0 0 10px;" />
      {{/if}}
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; color: {{theme.tIntense}}; margin: 0;">{{labels.giftAidAdded}} {{hasGiftAid}}</p>
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: {{theme.tQuiet}}; line-height: 1.5; margin: 6px 0 0;">
        {{labels.giftAidDeclaration}} {{orgName}} {{labels.giftAidExtra}} {{giftaidExtraAmount}} {{labels.giftAidNoCost}}
      </p>
    </td></tr>
    {{/if}}

    {{#if shouldDisplayCharityNumberOnTransactionReceipt}}
    <tr><td style="padding: {{#if hasGiftAidConfirmation}}14px{{else}}2px{{/if}} 0 0;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: {{theme.tQuiet}}; line-height: 1.5; margin: 0;">
        {{labels.receiptEmittedBy}} {{orgName}}<br />
        {{transactionReceiptCharityNumberLabel}} {{charityNumber}}
      </p>
    </td></tr>
    {{/if}}

    {{#if registeredCharityName}}
    <tr><td style="padding: {{#if (or hasGiftAidConfirmation shouldDisplayCharityNumberOnTransactionReceipt)}}14px{{else}}2px{{/if}} 0 0;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: {{theme.tQuiet}}; line-height: 1.5; margin: 0;">
        <span style="color: {{theme.tIntense}};">{{registeredCharityName}}</span> {{labels.registeredCharityStatement}} {{registeredCharityNumber}}
      </p>
    </td></tr>
    {{/if}}

    {{#if (or hasGiftAidConfirmation shouldDisplayCharityNumberOnTransactionReceipt registeredCharityName)}}
    <tr><td style="padding: 0; font-size: 0; line-height: 0; height: 24px;">&nbsp;</td></tr>
    {{/if}}
  </table>
</td></tr>

<!-- ========== 8. ZEFFY FOOTER ========== -->
{{#if isSweepstakes}}
<!-- Zeffy branding footer. Param: labels.footerCopyrightParticipation (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightParticipation}}
  </p>
</td></tr>
{{else}}
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>
{{/if}}

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.THANK_YOU_FUNDRAISER = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderFundraiserThankYou}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.fundraiserThankYouTitle}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.fundraiserCreatedPrefix}} <strong style="color: {{theme.tIntense}};">{{formTitle}}</strong>{{labels.fundraiserCreatedMid}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>{{labels.fundraiserCreatedSuffix}}
  </p>
</td></tr>

<!-- ========== 4. VIEW CAMPAIGN CTA ========== -->
<tr data-section="cta"><td style="padding: 16px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#if formLink}}href="{{formLink}}" {{/if}}style="height:42px;v-text-anchor:middle;width:540px;" arcsize="29%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:17px;font-weight:bold;">{{labels.fundraiserViewCampaign}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#if formLink}}href="{{formLink}}" target="_blank" {{/if}}class="cta-primary" style="display: block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 12px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.fundraiserViewCampaign}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 5. DONATION NOTIFICATION NOTE ========== -->
<tr data-section="notification-note"><td style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.fundraiserDonationNotificationNote}}
  </p>
</td></tr>

<!-- ========== 6. ACTIVATE ACCOUNT (hidden when fundraiser form edit is disabled) ========== -->
{{#unless isFundraiserFormEditDisabled}}
<tr data-section="activate-account-note"><td style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.fundraiserActivateAccountNote}}
  </p>
</td></tr>
<tr data-section="activate-account-cta"><td style="padding: 12px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#if simplykConnectionLink}}href="{{simplykConnectionLink}}" {{/if}}style="height:42px;v-text-anchor:middle;width:540px;" arcsize="29%" fillcolor="{{theme.secondaryCtaBg}}" strokecolor="{{theme.secondaryCtaBorder}}"><w:anchorlock/><center style="color:{{theme.secondaryCtaText}};font-family:Arial,sans-serif;font-size:17px;font-weight:bold;">👉 {{labels.fundraiserActivateAccount}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#if simplykConnectionLink}}href="{{simplykConnectionLink}}" target="_blank" {{/if}}class="cta-secondary emoji-inline" style="display: block; background-color: {{#if theme.isDark}}transparent{{else}}{{theme.secondaryCtaBg}}{{/if}}; color: {{theme.secondaryCtaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 8px 12px; border-radius: 6px; line-height: 1.4; text-align: center; border: 1px solid {{theme.secondaryCtaBorder}};">
      👉 {{labels.fundraiserActivateAccount}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>
{{/unless}}

<!-- ========== 7. NOTE FROM ORGANIZER (optional org message) ========== -->
{{#if message}}
<tr data-section="note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.emailBg}}; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      {{!-- No quote glyph here on purpose (KRA-5052). A lone opening quote beside the heading read
            as a grammar error to organizations, and the design-system version that closes it sits
            centred on the card's border — which needs absolute positioning plus an image mask that
            Gmail and Outlook strip. The card's own outline already frames the message. --}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.4;">
        {{labels.aThankYouFrom}} {{orgName}}
      </p>
      <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
        {{{message}}}
      </div>
    </td></tr>
  </table>
</td></tr>
{{/if}}

<!-- ========== 8. TIPS FOR SHARING THE CAMPAIGN ========== -->
<tr data-section="tips"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12 emoji-inline" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 12px; line-height: 1.5;">
    {{labels.fundraiserTipsTitle}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 10px;">
    <span style="color: {{theme.tBrand}};">&bull;</span> <strong style="color: {{theme.tIntense}};">{{labels.fundraiserTip1Title}}</strong> {{labels.fundraiserTip1Body}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 10px;">
    <span style="color: {{theme.tBrand}};">&bull;</span> <strong style="color: {{theme.tIntense}};">{{labels.fundraiserTip2Title}}</strong> {{labels.fundraiserTip2Body}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 10px;">
    <span style="color: {{theme.tBrand}};">&bull;</span> <strong style="color: {{theme.tIntense}};">{{labels.fundraiserTip3Title}}</strong> {{labels.fundraiserTip3Body}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    <span style="color: {{theme.tBrand}};">&bull;</span> <strong style="color: {{theme.tIntense}};">{{labels.fundraiserTip4Title}}</strong> {{labels.fundraiserTip4Body}}
  </p>
</td></tr>

<!-- Breathing room between the tips and the footer -->
<tr data-section="tips-spacer"><td style="height: 30px; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 9. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.DAF_DONATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>
<link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;600;700&amp;display=swap" rel="stylesheet" />
<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{#if theme.isDark}}{{theme.canvas}}{{else}}{{theme.sSupershy}}{{/if}};">
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{#if theme.isDark}}{{theme.canvas}}{{else}}{{theme.sSupershy}}{{/if}};">
<tr><td align="center" style="padding: 24px 16px;">
<table width="480" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 480px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">
<tr><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>
<tr><td style="padding: 18px {{#if isReminder}}16px{{else}}30px{{/if}}; background-color: {{theme.headerBg}};">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name" valign="middle" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; line-height: 16px; color: {{theme.tModerate}};">{{orgName}}</td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: true (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 6px; padding: 4px 13px; font-size: 11px; line-height: 14px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="13" height="13" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>
<tr><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; line-height: 1.5; color: {{theme.tBrand}}; margin: 0 0 9px;">{{labels.hi}} {{firstName}},</p>
  <h1 style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 24px; font-weight: 700; line-height: 1.2; color: {{theme.tIntense}}; margin: 0 0 9px;">{{subject}}</h1>
  <p style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{#if isDeclared}}{{labels.dafDeclaredPrefix}} {{orgName}} {{labels.dafDeclaredSuffix}}{{/if}}
    {{#if isReceived}}{{receivedDescription}}{{/if}}
    {{#if isReminder}}{{labels.dafDonorReminderDescription}}{{/if}}
  </p>
  {{#unless isReminder}}<p style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; margin: 3px 0 0;">{{labels.dafManageDonationsPrefix}} <a href="{{donorDashboardUrl}}" style="color: {{theme.tBrand}}; text-decoration: underline;">{{labels.dafAccountLink}}</a></p>{{/unless}}
  {{#if isReminder}}
  <p style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.tModerate}}; margin: 9px 0;">{{reminderInstructionsPrefix}}{{#if providerEmailUrl}} <a href="{{providerEmailUrl}}" style="text-decoration: underline;">{{labels.dafReminderEmailLink}}</a>{{/if}}{{#if providerPortalUrl}} {{#if providerEmailUrl}}{{labels.dafReminderPortalJoin}}{{else}}{{labels.dafReminderPortalOnly}}{{/if}} <a href="{{providerPortalUrl}}" style="text-decoration: underline;">{{labels.dafReminderPortalLink}}</a>{{/if}}.</p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.headerBg}}; border-radius: 8px;"><tr><td style="padding: 24px; font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.tModerate}};">
    <p style="font-weight: 700; margin: 0 0 8px;">{{grantDescription}}</p>
    <p style="margin: 0 0 8px;">{{labels.dafOrganizationEin}}: {{organizationEin}}</p>
    <p style="margin: 0 0 8px;">{{labels.dafOrganizationAddress}}: {{organizationAddress}}</p>
    <p style="margin: 0;">{{labels.dafReference}}: {{reference}}</p>
  </td></tr></table>
  <p style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.tModerate}}; margin: 16px 0;">{{reminderFollowup}}</p>
  <p style="margin: 0 0 30px;"><a href="{{resumeUrl}}" style="display: inline-block; padding: 9px 12px; border-radius: 6px; background: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none;">{{labels.dafResume}}</a></p>
  {{/if}}
</td></tr>
{{#unless isReminder}}{{#if message}}
<tr data-section="note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.emailBg}}; border: 0.75px solid {{theme.bSecondaryCta}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 17.25px;" class="mobile-pad-inner">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin-bottom: 12px;"><tr>
        <td style="padding-right: 9px; vertical-align: middle;"><img src="{{dafQuoteIcon}}" width="9.75" height="7.5" alt="" style="display: block;" /></td>
        <td style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 10px; font-weight: 700; text-transform: uppercase; color: {{theme.tBrand}}; line-height: 12px;">{{labels.aThankYouFrom}} {{orgName}}</td>
      </tr></table>
      <div class="note-message" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">{{{message}}}</div>
    </td></tr>
  </table>
</td></tr>
{{/if}}
<tr data-section="daf-transaction-info"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 11px; font-weight: 700; line-height: 13px; text-transform: uppercase; color: {{theme.tQuiet}}; margin: 0 0 12px;">{{labels.dafTransactionInfo}}</p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 11px; line-height: 15px; color: {{theme.tModerate}};">
    <tr><td style="padding-bottom: 6px;">{{labels.dafDonorName}}</td><td align="right" style="padding-bottom: 6px;">{{donorFullName}}</td></tr>
    {{#if donorLocation}}<tr><td style="padding-bottom: 6px;">{{labels.dafLocation}}</td><td align="right" style="padding-bottom: 6px;">{{donorLocation}}</td></tr>{{/if}}
    <tr><td style="padding-bottom: 6px;">{{labels.dafDonationDate}}</td><td align="right" style="padding-bottom: 6px;">{{donationDate}}</td></tr>
    <tr><td style="padding-bottom: 6px;">{{labels.method}}</td><td align="right" style="padding-bottom: 6px;">{{labels.dafMethod}}{{#unless isOtherProvider}} ({{providerName}}){{/unless}}</td></tr>
    <tr><td>{{labels.dafReference}}</td><td align="right" style="overflow-wrap: anywhere;">{{reference}}</td></tr>
  </table>
  <div style="margin-top: 12px; padding-top: 11px; border-top: 1px solid {{theme.bSupershy}};">
    <p style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 11px; font-weight: 700; line-height: 13px; text-transform: uppercase; color: {{theme.tQuiet}}; margin: 0 0 6px;">{{labels.donationDetails}}</p>
    <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 11px; line-height: 15px; color: {{theme.tModerate}};"><tr><td>{{labels.oneTimeDonation}}</td><td align="right">{{amount}}</td></tr></table>
  </div>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-top: 1px solid {{theme.bSupershy}}; margin-top: 12px; font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; font-weight: 700; color: {{theme.tIntense}};"><tr><td style="padding-top: 11px;">{{labels.dafTotal}}</td><td align="right" style="padding-top: 11px;">{{amount}}</td></tr></table>
</td></tr>{{/unless}}
{{#if isReminder}}<!-- Zeffy branding footer. Param: labels.footerCopyrightDafReminder (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 9px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="{{dafFacebookIcon}}" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="{{dafLinkedinIcon}}" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="{{dafInstagramIcon}}" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 9px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 16px 0 0; padding-top: 16px; border-top: 0.75px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightDafReminder}}
  </p>
</td></tr>{{else}}<!-- Zeffy branding footer. Param: labels.footerCopyrightDaf (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 9px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="{{dafFacebookIcon}}" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="{{dafLinkedinIcon}}" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="{{dafInstagramIcon}}" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 9px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 16px 0 0; padding-top: 16px; border-top: 0.75px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightDaf}}
  </p>
</td></tr>{{/if}}
</table>
</td></tr>
</table>
</body>
</html>
`;
exports.ORGANIZATION_BANK_ACCOUNT_UPDATE = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.bankAccountUpdatePreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing composition: container → single body → org-* components. -->
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.bankAccountUpdateIntroPrefix}}{{organizationName}}{{labels.bankAccountUpdateIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.bankAccountUpdateDetailsHeading}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.bankAccountUpdateBankName}} {{bankName}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.bankAccountUpdateRoutingNumber}} {{routingNumber}}</p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.bankAccountUpdateAccountEnding}} ****{{lastDigits}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.bankAccountUpdateUnauthorized (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.bankAccountUpdateUnauthorized}}</p></div>
    {{#if pausePayoutLink}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Button. Params: labels.bankAccountUpdateButton (label path), pausePayoutLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{pausePayoutLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.bankAccountUpdateButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{pausePayoutLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.bankAccountUpdateButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    {{/if}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.bankAccountUpdateIntentional (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.bankAccountUpdateIntentional}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.bestRegards (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.bestRegards}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_AUCTION_FAILED_PAYMENT = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.auctionFailedPaymentPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.auctionFailedPaymentTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.auctionFailedPaymentTitle}}</p></div>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.auctionFailedPaymentIntroPrefix}}<strong style="color: {{theme.headerText}};">{{firstName}}</strong>{{labels.auctionFailedPaymentIntroMiddle}}<strong style="color: {{theme.headerText}};">{{items}}</strong>{{labels.auctionFailedPaymentIntroSuffix}}</p>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.auctionFailedPaymentFollowUp (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.auctionFailedPaymentFollowUp}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.auctionFailedPaymentBidderHeading}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{firstName}} {{lastName}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{email}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.auctionFailedPaymentAmountLabel}} {{amount}}</p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.auctionFailedPaymentItemLabel}} {{items}}</p>
    </div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_WEBHOOK_AUTO_DISABLED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.webhookAutoDisabledPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.webhookAutoDisabledTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.webhookAutoDisabledTitle}}</p></div>
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.webhookAutoDisabledIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.webhookAutoDisabledIntro}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
        <span style="font-weight: 700;">{{labels.webhookAutoDisabledUrlLabel}}</span> {{webhookUrl}}
      </p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
        <span style="font-weight: 700;">{{labels.webhookAutoDisabledAbandonedCountLabel}}</span> {{abandonedDeliveryCount}}
      </p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.webhookAutoDisabledNextSteps (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.webhookAutoDisabledNextSteps}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Button. Params: labels.webhookAutoDisabledButton (label path), settingsUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{settingsUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.webhookAutoDisabledButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{settingsUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.webhookAutoDisabledButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <p class="mfs12" style="margin: 16px 0 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_PAYOUT_PAUSED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.payoutPausedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.payoutPausedIntroPrefix}}<strong style="font-weight: 700;">{{organizationName}}</strong>{{labels.payoutPausedIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.payoutPausedUrgentPrefix}}<a href="mailto:verify@zeffy.com" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">verify@zeffy.com</a>{{labels.payoutPausedUrgentSuffix}}</p>
    </div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.bestRegards (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.bestRegards}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_OUTBOUND_PAYMENT_POSTED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.outboundPaymentPostedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.treasurySuccessSubtitle, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.treasurySuccessSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.treasurySuccessSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasurySuccessSubtitle}}</p></div>
  {{/if}}
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.outboundPaymentPostedTitlePrefix}} {{amount}} {{labels.outboundPaymentPostedTitleSentTo}} {{beneficiary}}{{labels.outboundPaymentPostedTitleSuffix}}</p>
    </div>
    <div style="margin: 0;"><!-- Organization-facing / Text (body paragraph). Param: labels.outboundPaymentPostedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.outboundPaymentPostedIntro}}</p></div>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.treasuryStripePartnerPrefix}} <a {{#unless isPreview}}href="{{labels.treasuryStripePartnerUrl}}" target="_blank" {{/unless}}class="account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: {{theme.link}}; text-decoration: underline;">{{labels.treasuryStripePartnerLink}}</a> {{labels.treasuryStripePartnerSuffix}}
    </p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_TICKET_TRANSFERRED_TO_NEW_OCCURRENCE = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.ticketTransferredPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
{{!-- Donor-facing: goes to the ticket BUYER, so it carries the organization's branding
     (resolveEmailThemeTokens from the org color + form dark mode), not the fixed Zeffy palette. --}}
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.ticketTransferredTitle}}
  </h1>
</td></tr>

<!-- ========== 4. UPDATED TICKETS ========== -->
<tr data-section="updated"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 8px;">{{labels.ticketTransferredUpdatedHeading}}</p>
  {{#each rateNames}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../theme.tModerate}}; margin: 0 0 4px;">{{this}}</p>
  {{/each}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 20px;">{{ticketingName}}{{#if newOccurrenceStart}} | {{newOccurrenceStart}}{{/if}}</p>
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{eticketUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:260px;" arcsize="20%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.ticketTransferredDownloadButton}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#unless isPreview}}href="{{eticketUrl}}" target="_blank" {{/unless}}class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.ticketTransferredDownloadButton}}</a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 5. PREVIOUS TICKETS (for reference) ========== -->
<tr data-section="previous"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr><td style="border-top: 1px solid {{theme.bSupershy}}; padding-top: 24px;">
    <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 8px;">{{labels.ticketTransferredPreviousHeading}}</p>
    {{#each rateNames}}
    <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../theme.tModerate}}; margin: 0 0 4px;">{{this}}</p>
    {{/each}}
    <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">{{ticketingName}}{{#if oldOccurrenceStart}} | {{oldOccurrenceStart}}{{/if}}</p>
  </td></tr></table>
</td></tr>

<!-- ========== 6. NOTES + CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">{{labels.ticketTransferredOriginalConfirmation}}</p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">{{labels.ticketTransferredQuestions}}</p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">{{labels.ticketTransferredSignOff}}<br />{{labels.ticketTransferredOnBehalfOf}} {{orgName}}</p>
</td></tr>

<!-- ========== 7. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.ORGANIZATION_CUSTOM_DOMAIN_FAILED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.customDomainFailedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.customDomainFailedIntro}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.customDomainFailedNotRegistered (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.customDomainFailedNotRegistered}}</p></div>
    <div style="margin: 0 0 8px;"><!-- Organization-facing / Text (body paragraph). Param: labels.customDomainFailedCheckIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.customDomainFailedCheckIntro}}</p></div>
    <ul style="margin: 0 0 16px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.customDomainFailedBulletDomain}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.customDomainFailedBulletDns}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.customDomainFailedBulletHelp}}</li>
    </ul>
    {{#if failureDetailsHtml}}
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.customDomainFailedErrorHeading}}</p>
      <div class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{{failureDetailsHtml}}}</div>
    </div>
    {{/if}}
    <p class="mfs12" style="margin: 16px 0 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_CUSTOM_DOMAIN_SUCCEEDED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.customDomainSucceededPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.customDomainSucceededIntro (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.customDomainSucceededIntro}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.customDomainSucceededBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.customDomainSucceededBody}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.customDomainSucceededReady (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.customDomainSucceededReady}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.customDomainSucceededButton (label path), redirectionUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{redirectionUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.customDomainSucceededButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{redirectionUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.customDomainSucceededButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.thankYou (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.thankYou}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_DISPUTE_CLOSED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.disputeClosedOrganizationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.disputeClosedOrganizationIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.disputeClosedOrganizationIntroSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeClosedOrganizationIntro}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.disputeClosedOrganizationIntroSuffix}}{{/if}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.disputeDetailsHeading}}</p>
      {{#if description}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeDetailDescription}} {{description}}</p>
      {{/if}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeDetailAmount}} <strong style="color: {{theme.headerText}};">{{amount}}</strong></p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeDetailDate}} {{date}}</p>
    </div>
    <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.disputeClosedOrganizationStepsHeading}}</p>
    <ul style="margin: 0 0 16px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.disputeClosedOrganizationStepPayments}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.disputeClosedOrganizationStepFindPayment}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.disputeClosedOrganizationStepSucceeded}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.disputeClosedOrganizationStepDisputed}}</li>
    </ul>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.disputeClosedOrganizationWonNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeClosedOrganizationWonNote}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.disputeClosedOrganizationQuestions (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeClosedOrganizationQuestions}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_OWNERSHIP_VERIFICATION_HELPER = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.ownershipVerificationHelperPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}}{{#if firstName}} {{firstName}}{{/if}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.ownershipVerificationHelperIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.ownershipVerificationHelperIntro}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.ownershipVerificationHelperClarify (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.ownershipVerificationHelperClarify}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.ownershipVerificationHelperTrouble (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.ownershipVerificationHelperTroubleSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.ownershipVerificationHelperTrouble}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.ownershipVerificationHelperTroubleSuffix}}{{/if}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.ownershipVerificationHelperObligated (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.ownershipVerificationHelperObligated}}</p></div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.ownershipVerificationHelperKeyPointsHeading}}</p>
    </div>
    <ul style="margin: 0 0 16px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.ownershipVerificationHelperKeyPoint1}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.ownershipVerificationHelperKeyPoint2}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.ownershipVerificationHelperKeyPoint3}}</li>
    </ul>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.ownershipVerificationHelperVerifyHeading}}</p>
    </div>
    <ol style="margin: 0 0 16px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.ownershipVerificationHelperVerifyStep1}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.ownershipVerificationHelperVerifyStep2}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.ownershipVerificationHelperVerifyStep3}}
        <ul style="margin: 8px 0 0; padding-left: 20px;">
          <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.ownershipVerificationHelperVerifyStep3Option1}}</li>
          <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.ownershipVerificationHelperVerifyStep3Option2}}</li>
          <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.ownershipVerificationHelperVerifyStep3Option3}}</li>
        </ul>
      </li>
    </ol>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.ownershipVerificationHelperClosing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.ownershipVerificationHelperClosing}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_CHECK_IN_MANAGER_UPCOMING_EVENT = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.checkInManagerUpcomingEventPreheader}} {{eventTitle}}.
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  {{!-- Same rendering as org-banner-header — inlined because the title interpolates {{eventTitle}},
       which the partial's single false label param can't express. --}}
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.brandFilledBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td class="mobile-pad-banner" style="padding: 24px;">
    <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bannerAccentText}}; word-break: break-word;">{{labels.checkInManagerUpcomingEventBannerSubtitle}}</p>
    <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.bannerTitleText}}; word-break: break-word;">{{labels.checkInManagerUpcomingEventTitlePrefix}}{{eventTitle}}{{labels.checkInManagerUpcomingEventTitleSuffix}}</p>
  </td></tr></table>
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     true (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 20px;"><!-- Organization-facing / Text (body paragraph). Param: labels.checkInManagerUpcomingEventIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.checkInManagerUpcomingEventIntro}}</p></div>
    {{!-- Ships as an inline CID attachment (see ORG_CHECK_IN_MANAGER_IMAGE) — previews swap it to a data URI. --}}
    <div style="margin: 0 0 20px; text-align: center;">
      <img src="cid:img-check-in-manager" alt="{{labels.checkInManagerUpcomingEventBannerSubtitle}}" width="240" style="display: inline-block; width: 240px; max-width: 100%; height: auto; border: 0; border-radius: 8px;" />
    </div>

    <div style="margin: 0 0 4px;"><!-- Organization-facing / H2 (section heading). Param: labels.checkInManagerUpcomingEventBrowserHeading (label path). Desktop 22px · mobile 18px (.mfs18).
     Sits below org-header (29px) in the hierarchy — use it for section headings inside a body. -->
<p class="mfs18" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 22px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.checkInManagerUpcomingEventBrowserHeading}}</p></div>
    <div style="margin: 0 0 20px;">
      <!-- Organization-facing / Bullet list (block partial). Slot: one or more org-bullet items.
     Usage: open a block ("#>" org-list), put org-bullet partials inside, close the block.
     No literal partial syntax in this comment — the inliner resolves partial refs even in comments. -->
<ul style="margin: 0; padding-left: 20px;">
        <!-- Organization-facing / Bullet list item. Params: labels.checkInManagerUpcomingEventBrowserBullet1 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.checkInManagerUpcomingEventBrowserBullet1}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.checkInManagerUpcomingEventBrowserBullet2 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.checkInManagerUpcomingEventBrowserBullet2}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.checkInManagerUpcomingEventBrowserBullet3 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.checkInManagerUpcomingEventBrowserBullet3}}</li>
      </ul>
    </div>
    <div style="margin: 0 0 20px;"><!-- Organization-facing / Button. Params: labels.checkInManagerUpcomingEventAccessButton (label path), accessLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{accessLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.checkInManagerUpcomingEventAccessButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{accessLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.checkInManagerUpcomingEventAccessButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>

    <div style="margin: 0 0 20px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 4px;"><!-- Organization-facing / H2 (section heading). Param: labels.checkInManagerUpcomingEventAppHeading (label path). Desktop 22px · mobile 18px (.mfs18).
     Sits below org-header (29px) in the hierarchy — use it for section headings inside a body. -->
<p class="mfs18" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 22px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.checkInManagerUpcomingEventAppHeading}}</p></div>
    <div style="margin: 0 0 20px;">
      <!-- Organization-facing / Bullet list (block partial). Slot: one or more org-bullet items.
     Usage: open a block ("#>" org-list), put org-bullet partials inside, close the block.
     No literal partial syntax in this comment — the inliner resolves partial refs even in comments. -->
<ul style="margin: 0; padding-left: 20px;">
        <!-- Organization-facing / Bullet list item. Params: labels.checkInManagerUpcomingEventAppBullet1 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.checkInManagerUpcomingEventAppBullet1}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.checkInManagerUpcomingEventAppBullet2 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.checkInManagerUpcomingEventAppBullet2}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.checkInManagerUpcomingEventAppBullet3 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.checkInManagerUpcomingEventAppBullet3}}</li>
      </ul>
    </div>
    <div style="margin: 0;"><!-- Organization-facing / Zeffy app download buttons (App Store filled + Google Play outline, side by side).
     Reads appStoreUrl, playStoreUrl, isPreview and labels from context — the caller passes no params,
     it just ensures those template variables exist (see getAppStoreUrl / getPlayStoreUrl in helpers/mobile-app-links.ts). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="padding: 0 8px 0 0;"><!-- Organization-facing / Button. Params: labels.appStoreButton (label path), appStoreUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{appStoreUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.appStoreButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{appStoreUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.appStoreButton}}</a>
  <!--<![endif]-->
</td></tr></table></td>
  <td><!-- Organization-facing / Button. Params: labels.googlePlayButton (label path), playStoreUrl (path), true (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{playStoreUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.outlineBg}}" strokecolor="{{theme.outlineBorder}}"><w:anchorlock/><center style="color:{{theme.outlineText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.googlePlayButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{playStoreUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.outlineBg}}; border: 0.75px solid {{theme.outlineBorder}}; color: {{theme.outlineText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.googlePlayButton}}</a>
  <!--<![endif]-->
</td></tr></table></td>
</tr></table></div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_ISSUING_REWARD_SUCCEEDED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.issuingRewardSucceededPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    {{!-- Same rendering as org-header — inlined because the heading interpolates {{amount}},
         which the partial's single false label param can't express. --}}
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.issuingRewardSucceededTitlePrefix}}{{amount}}{{labels.issuingRewardSucceededTitleMiddle}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.issuingRewardSucceededTitleSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.issuingRewardSucceededReport (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingRewardSucceededReport}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.issuingRewardSucceededButton (label path), balanceUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{balanceUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.issuingRewardSucceededButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{balanceUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.issuingRewardSucceededButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.issuingRewardSucceededGuidePrefix}} <!-- Organization-facing / Link. Params: labels.issuingRewardSucceededGuideLink (label path), labels.issuingRewardSucceededGuideUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.issuingRewardSucceededGuideUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.issuingRewardSucceededGuideLink}}</a>{{labels.issuingRewardSucceededGuideSuffix}}
    </p>
    <div style="margin: 0 0 4px;"><!-- Organization-facing / Text (body paragraph). Param: labels.issuingRewardSucceededClosing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingRewardSucceededClosing}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryCelticBankDisclaimer}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_RECURRING_PAYMENT_SUCCEEDED_AFTER_FAILURE = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.recurringPaymentSucceededAfterFailurePreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}}{{#if firstName}} {{firstName}}{{/if}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.recurringPaymentSucceededAfterFailureIntroPrefix}}{{donorName}}{{labels.recurringPaymentSucceededAfterFailureIntroOrg}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.recurringPaymentSucceededAfterFailureIntroMiddle1}}{{amount}}{{labels.recurringPaymentSucceededAfterFailureIntroMiddle2}}{{programTypeLabelShort}}{{labels.recurringPaymentSucceededAfterFailureIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.recurringPaymentSucceededAfterFailureNoAction (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.recurringPaymentSucceededAfterFailureNoAction}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_DISPUTE_CREATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.disputeCreatedOrganizationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.disputeCreatedOrganizationIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.disputeCreatedOrganizationIntroSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeCreatedOrganizationIntro}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.disputeCreatedOrganizationIntroSuffix}}{{/if}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.disputeDetailsHeading}}</p>
      {{#if description}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeDetailDescription}} {{description}}</p>
      {{/if}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeDetailAmount}} <strong style="color: {{theme.headerText}};">{{amount}}</strong></p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeDetailDate}} {{date}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.disputeCreatedOrganizationReversal (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeCreatedOrganizationReversal}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.disputeCreatedOrganizationResolution (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeCreatedOrganizationResolution}}</p></div>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.disputeCreatedOrganizationLearnMorePrefix}} <a {{#unless isPreview}}href="{{labels.disputeHelpUrl}}" target="_blank" {{/unless}}style="font-family: Arial, Helvetica, sans-serif; color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.disputeCreatedOrganizationLearnMoreLink}}</a>
    </p>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.disputeCreatedOrganizationQuestions (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeCreatedOrganizationQuestions}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_AUCTION_ORGANIZATION_BID_SUBMITTED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.auctionOrganizationBidSubmittedPreheader}} {{orgName}}.
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: auctionName (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{auctionName}}</p></div>
    <div style="margin: 0 0 16px;">
      {{!-- Same rendering as org-header — inlined because it interpolates {{firstName}}. --}}
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.auctionOrganizationBidSubmittedTitlePrefix}}{{firstName}}{{labels.auctionOrganizationBidSubmittedTitleSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 8px;"><tr>
        <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; white-space: nowrap; padding-right: 12px;">{{labels.auctionOrganizationBidSubmittedBidderHeading}}</td>
        <td width="100%" style="vertical-align: middle;"><table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr><td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{theme.dividerNeutral}}; border-radius: 10px;">&nbsp;</td></tr></table></td>
      </tr></table>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.auctionOrganizationBidSubmittedBidderName}} {{firstName}} {{lastName}}</p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.auctionOrganizationBidSubmittedBidderEmail}} {{email}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 8px;"><tr>
        <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; white-space: nowrap; padding-right: 12px;">{{labels.auctionOrganizationBidSubmittedItemsHeading}}</td>
        <td width="100%" style="vertical-align: middle;"><table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr><td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{theme.dividerNeutral}}; border-radius: 10px;">&nbsp;</td></tr></table></td>
      </tr></table>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#each items}}
        <tr>
          <td width="12" class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; color: {{../theme.link}}; padding: 3px 8px 3px 0; vertical-align: baseline; line-height: 1.5;">&bull;</td>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; color: {{../theme.bodyText}}; padding: 3px 0; vertical-align: baseline; line-height: 1.5; word-break: break-word;">
            <strong>{{itemPrice}}</strong> — {{itemName}}{{#if isAutoBid}} ({{../labels.auctionOrganizationBidSubmittedAutoBid}}){{/if}}{{#if bidLabel}} — {{bidLabel}}{{/if}}
          </td>
        </tr>
        {{/each}}
      </table>
    </div>
    {{#if additionalQuestions.length}}
    <div style="margin: 0 0 16px;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 8px;"><tr>
        <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; white-space: nowrap; padding-right: 12px;">{{labels.auctionOrganizationBidSubmittedQuestionsHeading}}</td>
        <td width="100%" style="vertical-align: middle;"><table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr><td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{theme.dividerNeutral}}; border-radius: 10px;">&nbsp;</td></tr></table></td>
      </tr></table>
      {{#each additionalQuestions}}
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../theme.bodyText}}; word-break: break-word;"><strong>{{question}}</strong><br />{{answer}}</p>
      {{/each}}
    </div>
    {{/if}}
    <div style="margin: 0 0 20px;"><!-- Organization-facing / Button. Params: labels.auctionOrganizationBidSubmittedFormButton (label path), formLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{formLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.auctionOrganizationBidSubmittedFormButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{formLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.auctionOrganizationBidSubmittedFormButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    {{!-- Same rendering as org-subtitle — inlined because it interpolates {{referralAmount}}. --}}
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">
      {{labels.auctionOrganizationBidSubmittedReferralPrefix}} <strong>{{referralAmount}}</strong> {{labels.auctionOrganizationBidSubmittedReferralSuffix}}
    </p>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.auctionOrganizationBidSubmittedReferralButton (label path), referralLink (path), true (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{referralLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.outlineBg}}" strokecolor="{{theme.outlineBorder}}"><w:anchorlock/><center style="color:{{theme.outlineText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.auctionOrganizationBidSubmittedReferralButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{referralLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.outlineBg}}; border: 0.75px solid {{theme.outlineBorder}}; color: {{theme.outlineText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.auctionOrganizationBidSubmittedReferralButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.auctionOrganizationBidSubmittedClosing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.auctionOrganizationBidSubmittedClosing}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_STRIPE_INFORMATION_REQUIRED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.stripeInformationRequiredPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.stripeInformationRequiredTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.stripeInformationRequiredTitle}}</p></div>
    {{#if isOneCause}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.stripeInformationRequiredIntroOneCause (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.stripeInformationRequiredIntroOneCauseSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeInformationRequiredIntroOneCause}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.stripeInformationRequiredIntroOneCauseSuffix}}{{/if}}</p></div>
    {{/if}}
    {{#if isSeveralCauses}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.stripeInformationRequiredIntroSeveralCauses (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.stripeInformationRequiredIntroSeveralCausesSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeInformationRequiredIntroSeveralCauses}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.stripeInformationRequiredIntroSeveralCausesSuffix}}{{/if}}</p></div>
    {{/if}}
    {{#if isMissingInformation}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.stripeInformationRequiredIntroMissing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.stripeInformationRequiredIntroMissingSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeInformationRequiredIntroMissing}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.stripeInformationRequiredIntroMissingSuffix}}{{/if}}</p></div>
    {{/if}}
    {{#if isFallback}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.stripeInformationRequiredIntroFallback (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.stripeInformationRequiredIntroFallbackSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeInformationRequiredIntroFallback}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.stripeInformationRequiredIntroFallbackSuffix}}{{/if}}</p></div>
    {{/if}}
    {{#each causes}}
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{@root.theme.headerText}}; word-break: break-word;">{{shortLabel}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{@root.theme.bodyText}}; word-break: break-word;">{{paragraph}}</p>
      <a href="{{helpUrl}}" target="_blank" class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{@root.theme.link}}; font-weight: 700; text-decoration: underline;">{{@root.labels.stripeInformationRequiredHowToFix}}</a>
    </div>
    {{/each}}
    {{#if missingFields.length}}
    {{#if isSeveralCauses}}
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.stripeInformationRequiredMissingTitle}}</p>
    </div>
    {{/if}}
    <ul style="margin: 0 0 8px; padding-left: 20px;">
      {{#each missingFields}}
      <li class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{@root.theme.bodyText}}; word-break: break-word;">{{this}}</li>
      {{/each}}
    </ul>
    {{/if}}
    {{#if showGuideLink}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Link. Params: labels.stripeInformationRequiredLearnHow (label path), guideUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{guideUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.stripeInformationRequiredLearnHow}}</a></div>
    {{/if}}
    <div style="margin: 8px 0 16px;"><!-- Organization-facing / Button. Params: labels.stripeInformationRequiredButton (label path), bankPageUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{bankPageUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.stripeInformationRequiredButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{bankPageUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.stripeInformationRequiredButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.stripeInformationRequiredAfter (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeInformationRequiredAfter}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.bestRegards (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.bestRegards}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_FAILED_RECURRING_CARD_PAYMENT = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.failedRecurringCardPaymentPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}}{{#if firstName}} {{firstName}}{{/if}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.failedRecurringCardPaymentIntroPrefix}}{{donorName}}{{labels.failedRecurringCardPaymentIntroOrg}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.failedRecurringCardPaymentIntroMiddle1}}{{amount}}{{labels.failedRecurringCardPaymentIntroMiddle2}}{{programTypeLabelShort}}{{labels.failedRecurringCardPaymentIntroSuffix}} {{labels.failedRecurringCardPaymentExpiredCard}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.failedRecurringCardPaymentFollowUp (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.failedRecurringCardPaymentFollowUp}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.failedRecurringCardPaymentNoAction (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.failedRecurringCardPaymentNoAction}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_ISSUING_CARD_ACTIVATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.issuingCardActivatedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.treasuryCongratulationsSubtitle, labels.issuingCardActivatedTitle (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.treasuryCongratulationsSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.treasuryCongratulationsSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryCongratulationsSubtitle}}</p></div>
  {{/if}}
  {{#if labels.issuingCardActivatedTitle}}
  <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.issuingCardActivatedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.issuingCardActivatedTitle}}</p></div>
  {{/if}}
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.issuingCardActivatedManualPayoutNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.issuingCardActivatedManualPayoutNote}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.issuingCardActivatedSchedulePayout (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingCardActivatedSchedulePayout}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.issuingCardActivatedPerksHeading}}</p>
    </div>
    <div style="margin: 0 0 16px;"><p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryPerkCollectRewardsTitle}}</p>
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingCardActivatedPerkCollectRewards}}</p></div>
    <div style="margin: 0 0 16px;"><p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryPerkSpendFasterTitle}}</p>
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingCardActivatedPerkSpendFaster}}</p></div>
    <div style="margin: 0;"><p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryPerkTrackSmarterTitle}}</p>
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingCardActivatedPerkTrackSmarter}}</p></div>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryCelticBankDisclaimer}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_CAMPAIGN_PARTICIPATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.campaignParticipationPreheader}} {{campaignTitle}}.
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.campaignParticipationTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.campaignParticipationTitle}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: activityLine (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{activityLine}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Button. Params: labels.campaignParticipationViewPage (label path), formUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{formUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.campaignParticipationViewPage}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{formUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.campaignParticipationViewPage}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.campaignParticipationShareNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.campaignParticipationShareNote}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_DONATION_FORM_CREATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.donationFormCreatedPreheader}} {{formTitle}}.
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.donationFormCreatedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.donationFormCreatedTitle}}</p></div>
{{#unless showBankAccountNote}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.donationFormCreatedShareIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.donationFormCreatedShareIntro}}</p></div>
    {{/unless}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Button. Params: labels.donationFormCreatedFormButton (label path), formUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{formUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.donationFormCreatedFormButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{formUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.donationFormCreatedFormButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    {{#if showBankAccountNote}}
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.bankAccountReminderPrefix}} <!-- Organization-facing / Link. Params: labels.bankAccountReminderLink (label path), bankAccountUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{bankAccountUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.bankAccountReminderLink}}</a>{{labels.bankAccountReminderSuffix}}
    </p>
    {{/if}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.donationFormCreatedTipsHeading}}</p>
    </div>
    <ul style="margin: 0 0 16px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.donationFormCreatedTipTrackDonors}}
      </li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.donationFormCreatedTipIncreasePrefix}} <!-- Organization-facing / Link. Params: labels.donationFormCreatedTipIncreaseLink (label path), labels.donationFormCreatedTipIncreaseUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.donationFormCreatedTipIncreaseUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.donationFormCreatedTipIncreaseLink}}</a>{{labels.donationFormCreatedTipIncreaseSuffix}}
      </li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        <!-- Organization-facing / Link. Params: labels.donationFormCreatedTipThankYouLink (label path), labels.donationFormCreatedTipThankYouUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.donationFormCreatedTipThankYouUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.donationFormCreatedTipThankYouLink}}</a> {{labels.donationFormCreatedTipThankYouSuffix}}
      </li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.donationFormCreatedTipTaxReceiptsPrefix}} <!-- Organization-facing / Link. Params: labels.donationFormCreatedTipTaxReceiptsLink (label path), labels.donationFormCreatedTipTaxReceiptsUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.donationFormCreatedTipTaxReceiptsUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.donationFormCreatedTipTaxReceiptsLink}}</a> {{labels.donationFormCreatedTipTaxReceiptsSuffix}}
      </li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.donationFormCreatedTipPeerToPeerPrefix}} <!-- Organization-facing / Link. Params: labels.donationFormCreatedTipPeerToPeerLink (label path), labels.donationFormCreatedTipPeerToPeerUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.donationFormCreatedTipPeerToPeerUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.donationFormCreatedTipPeerToPeerLink}}</a> {{labels.donationFormCreatedTipPeerToPeerSuffix}}
      </li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        <!-- Organization-facing / Link. Params: labels.donationFormCreatedTipRelaunchLink (label path), labels.donationFormCreatedTipRelaunchUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.donationFormCreatedTipRelaunchUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.donationFormCreatedTipRelaunchLink}}</a> {{labels.donationFormCreatedTipRelaunchSuffix}}
      </li>
    </ul>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.donationFormCreatedClosing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.donationFormCreatedClosing}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_FINANCIAL_ACCOUNT_CREATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.financialAccountCreatedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.treasuryCongratulationsSubtitle, labels.financialAccountCreatedTitle (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.treasuryCongratulationsSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.treasuryCongratulationsSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryCongratulationsSubtitle}}</p></div>
  {{/if}}
  {{#if labels.financialAccountCreatedTitle}}
  <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.financialAccountCreatedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.financialAccountCreatedTitle}}</p></div>
  {{/if}}
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.financialAccountCreatedPerksHeading}}</p>
    </div>
    <div style="margin: 0 0 16px;"><p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryPerkCollectRewardsTitle}}</p>
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.financialAccountCreatedPerkCollectRewards}}</p></div>
    <div style="margin: 0 0 16px;"><p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryPerkSpendFasterTitle}}</p>
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.financialAccountCreatedPerkSpendFaster}}</p></div>
    <div style="margin: 0;"><p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryPerkTrackSmarterTitle}}</p>
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.financialAccountCreatedPerkTrackSmarter}}</p></div>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryCelticBankDisclaimer}}</p>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.treasuryStripePartnerPrefix}} <a {{#unless isPreview}}href="{{labels.treasuryStripePartnerUrl}}" target="_blank" {{/unless}}class="account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: {{theme.link}}; text-decoration: underline;">{{labels.treasuryStripePartnerLink}}</a> {{labels.treasuryStripePartnerSuffix}}
    </p>
    <p class="mfs10_5" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.treasuryYieldDisclaimerPrefix}} <a {{#unless isPreview}}href="{{labels.treasuryYieldTermsUrl}}" target="_blank" {{/unless}}class="account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: {{theme.link}}; text-decoration: underline;">{{labels.treasuryYieldDisclaimerLink}}</a>{{labels.treasuryYieldDisclaimerSuffix}}
    </p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_RECURRING_PAYMENT_NEVER_MADE = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.recurringPaymentNeverMadePreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}}{{#if firstName}} {{firstName}}{{/if}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.recurringPaymentNeverMadeIntroPrefix}}{{donorName}}{{labels.recurringPaymentNeverMadeIntroOrg}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.recurringPaymentNeverMadeIntroMiddle1}}{{amount}}{{labels.recurringPaymentNeverMadeIntroMiddle2}}{{programTypeLabelShort}}{{labels.recurringPaymentNeverMadeIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.recurringPaymentNeverMadeContactIntro}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{donorName}}</p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{email}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.recurringPaymentNeverMadeFollowUp (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.recurringPaymentNeverMadeFollowUp}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_PAST_DUE_SUBSCRIPTION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.pastDueSubscriptionPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{orgFirstName}},</p>
    </div>
    {{!-- Same rendering as org-header — inlined because the heading interpolates the donor name,
         which the partial's single false label param can't express. --}}
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.pastDueSubscriptionIntroPrefix}}{{donorFirstName}} {{donorLastName}}{{labels.pastDueSubscriptionIntroOrg}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.pastDueSubscriptionIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.pastDueSubscriptionUpdateNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.pastDueSubscriptionUpdateNote}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.pastDueSubscriptionContactPrefix}}{{donorEmail}}{{labels.pastDueSubscriptionContactMiddle}}<a href="{{labels.pastDueSubscriptionGuideUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.pastDueSubscriptionGuideLink}}</a>{{labels.pastDueSubscriptionContactSuffix}}</p>
    </div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.allTheBest (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_TREASURY_BETA_INVITATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.treasuryBetaInvitationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, labels.treasuryBetaInvitationTitle (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  {{#if labels.treasuryBetaInvitationTitle}}
  <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.treasuryBetaInvitationTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.treasuryBetaInvitationTitle}}</p></div>
  {{/if}}
  
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.treasuryBetaInvitationFree (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryBetaInvitationFree}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.treasuryBetaInvitationPerksHeading}}</p>
    </div>
    <div style="margin: 0 0 16px;"><p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryBetaInvitationPerkSelfServeTitle}}</p>
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryBetaInvitationPerkSelfServe}}</p></div>
    <div style="margin: 0 0 16px;"><p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryBetaInvitationPerkYieldTitle}}</p>
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryBetaInvitationPerkYield}}</p></div>
    <div style="margin: 0 0 16px;"><p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryPerkSpendFasterTitle}}</p>
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryBetaInvitationPerkSpendFaster}}</p></div>
    <div style="margin: 0 0 24px;"><p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryBetaInvitationPerkCreditScoreTitle}}</p>
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryBetaInvitationPerkCreditScore}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.treasuryBetaInvitationButton (label path), bankUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{bankUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.treasuryBetaInvitationButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{bankUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.treasuryBetaInvitationButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.treasuryBetaInvitationHelp (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryBetaInvitationHelp}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryBetaInvitationSignature}}</p>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryCelticBankDisclaimer}}</p>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.treasuryStripePartnerPrefix}} <a {{#unless isPreview}}href="{{labels.treasuryStripePartnerUrl}}" target="_blank" {{/unless}}class="account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: {{theme.link}}; text-decoration: underline;">{{labels.treasuryStripePartnerLink}}</a> {{labels.treasuryStripePartnerSuffix}}
    </p>
    <p class="mfs10_5" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.treasuryYieldDisclaimerPrefix}} <a {{#unless isPreview}}href="{{labels.treasuryYieldTermsUrl}}" target="_blank" {{/unless}}class="account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: {{theme.link}}; text-decoration: underline;">{{labels.treasuryYieldDisclaimerLink}}</a>{{labels.treasuryYieldDisclaimerSuffix}}
    </p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_DAF_TO_CONFIRM = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>
<link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;600;700&amp;display=swap" rel="stylesheet" />
<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}};">
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" style="padding: 24px 16px;">
<table width="480" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 480px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">
<tr><td>
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 9px;"><!-- Organization-facing / Header. Param: subject (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 24px; line-height: 1.2; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{subject}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: orgReminderDescription (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{orgReminderDescription}}</p></div>
    <!-- Organization-facing / Button. Params: labels.dafViewDonation (label path), viewDonationUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{viewDonationUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.dafViewDonation}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{viewDonationUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 12px; border-radius: 6px; line-height: normal; text-align: center;">{{labels.dafViewDonation}}</a>
  <!--<![endif]-->
</td></tr></table>
  
</td></tr></table>
</td></tr>
<!-- Zeffy branding footer. Param: labels.footerCopyrightDafOrganization (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 9px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="{{dafFacebookIcon}}" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="{{dafLinkedinIcon}}" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="{{dafInstagramIcon}}" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Roboto, Arial, Helvetica, sans-serif; font-size: 9px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 16px 0 0; padding-top: 16px; border-top: 0.75px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightDafOrganization}}
  </p>
</td></tr>
</table></td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_RECEIVED_CREDIT = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.receivedCreditPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.receivedCreditSubtitle, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.receivedCreditSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.receivedCreditSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.receivedCreditSubtitle}}</p></div>
  {{/if}}
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.receivedCreditTitlePrefix}} {{amount}} {{labels.receivedCreditTitleFrom}} {{senderName}}{{labels.receivedCreditTitleSuffix}}</p>
    </div>
    <div style="margin: 0;"><!-- Organization-facing / Text (body paragraph). Param: labels.receivedCreditIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.receivedCreditIntro}}</p></div>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.treasuryStripePartnerPrefix}} <a {{#unless isPreview}}href="{{labels.treasuryStripePartnerUrl}}" target="_blank" {{/unless}}class="account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: {{theme.link}}; text-decoration: underline;">{{labels.treasuryStripePartnerLink}}</a> {{labels.treasuryStripePartnerSuffix}}
    </p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_LOW_TREASURY_BALANCE = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.lowTreasuryBalancePreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.lowTreasuryBalanceSubtitle, labels.lowTreasuryBalanceTitle (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.lowTreasuryBalanceSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.lowTreasuryBalanceSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.lowTreasuryBalanceSubtitle}}</p></div>
  {{/if}}
  {{#if labels.lowTreasuryBalanceTitle}}
  <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.lowTreasuryBalanceTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.lowTreasuryBalanceTitle}}</p></div>
  {{/if}}
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.lowTreasuryBalanceInfo (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.lowTreasuryBalanceInfo}}</p></div>
    <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.treasuryRaiseMoreHeading}}</p>
    <ul style="margin: 0; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMorePeerToPeer}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreRaffle}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreEvent}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreShop}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreAndMore}}</li>
    </ul>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryCelticBankDisclaimer}}</p>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.treasuryStripePartnerPrefix}} <a {{#unless isPreview}}href="{{labels.treasuryStripePartnerUrl}}" target="_blank" {{/unless}}class="account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: {{theme.link}}; text-decoration: underline;">{{labels.treasuryStripePartnerLink}}</a> {{labels.treasuryStripePartnerSuffix}}
    </p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_STRIPE_RISK_REVIEW = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.stripeRiskReviewPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.stripeRiskReviewTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.stripeRiskReviewTitle}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.stripeRiskReviewIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.stripeRiskReviewIntroSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeRiskReviewIntro}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.stripeRiskReviewIntroSuffix}}{{/if}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.stripeRiskReviewFunds (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeRiskReviewFunds}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.stripeRiskReviewNext (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeRiskReviewNext}}</p></div>
    <div style="margin: 8px 0 16px;"><!-- Organization-facing / Button. Params: labels.stripeRiskReviewButton (label path), bankPageUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{bankPageUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.stripeRiskReviewButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{bankPageUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.stripeRiskReviewButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.stripeRiskReviewHelp (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeRiskReviewHelp}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.bestRegards (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.bestRegards}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_ISSUING_TOPUP_SUCCEEDED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.issuingTopupSucceededPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.treasurySuccessSubtitle, labels.issuingTopupSucceededTitle (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.treasurySuccessSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.treasurySuccessSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasurySuccessSubtitle}}</p></div>
  {{/if}}
  {{#if labels.issuingTopupSucceededTitle}}
  <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.issuingTopupSucceededTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.issuingTopupSucceededTitle}}</p></div>
  {{/if}}
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0;"><!-- Organization-facing / Text (body paragraph). Param: labels.issuingTopupSucceededIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingTopupSucceededIntro}}</p></div>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryCelticBankDisclaimer}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_REFERRAL_DURING_ONBOARDING = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.referralDuringOnboardingPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    {{!-- Same rendering as org-header — inlined because the heading interpolates {{orgName}},
         which the partial's single false label param can't express. --}}
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.referralDuringOnboardingIntroPrefix}}{{orgName}}{{labels.referralDuringOnboardingIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralDuringOnboardingHeardPrompt}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralDuringOnboardingNextTimePrefix}}{{referralAmount}}{{labels.referralDuringOnboardingNextTimeSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.referralSharing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralSharing}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.referralThankYouEverything (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralThankYouEverything}}</p></div>
    <div style="margin: 0 0 4px;"><!-- Organization-facing / Text (body paragraph). Param: labels.allTheBest (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}</p></div>
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 8px;">
      {{!-- Same rendering as org-subtitle — inlined because the line interpolates {{referralAmount}}. --}}
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.referralCtaPrefix}}{{referralAmount}}{{labels.referralCtaSuffix}}</p>
    </div>
    <div style="margin: 0;"><!-- Organization-facing / Button. Params: labels.referralCtaLink (label path), referralLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{referralLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.referralCtaLink}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{referralLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.referralCtaLink}}</a>
  <!--<![endif]-->
</td></tr></table></div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_NEXT_DAY_PAYOUTS_ENABLED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.nextDayPayoutsEnabledPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.nextDayPayoutsEnabledTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.nextDayPayoutsEnabledTitle}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.nextDayPayoutsEnabledIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nextDayPayoutsEnabledIntro}}</p></div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.nextDayPayoutsEnabledActivateHeading}}</p>
    </div>
    <ol style="margin: 0 0 16px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nextDayPayoutsEnabledStep1}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nextDayPayoutsEnabledStep2}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nextDayPayoutsEnabledStep3}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nextDayPayoutsEnabledStep4}}</li>
    </ol>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.nextDayPayoutsEnabledOutro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nextDayPayoutsEnabledOutro}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.nextDayPayoutsEnabledClosing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nextDayPayoutsEnabledClosing}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.warmly}}</p>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_PAYOUT = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.referralFirstRefereePayoutPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.referralFirstRefereePayoutIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralFirstRefereePayoutIntro}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><strong style="color: {{theme.headerText}};">{{referrerOrgName}}</strong>{{labels.referralFirstRefereePayoutReferrerMiddle}}{{referralAmount}}{{labels.referralFirstRefereePayoutReferrerSuffix}}</p>
    </div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralFirstRefereePayoutYouCanEarnPrefix}}{{referralAmount}}{{labels.referralFirstRefereePayoutYouCanEarnSuffix}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.referralCopyLink (label path), referralLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{referralLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.referralCopyLink}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{referralLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.referralCopyLink}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.referralSharing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralSharing}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.referralThankYouEverything (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralThankYouEverything}}</p></div>
    <div style="margin: 0 0 4px;"><!-- Organization-facing / Text (body paragraph). Param: labels.allTheBest (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_QUICKBOOKS_DISCONNECTED_NOTIFICATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.quickbooksDisconnectedNotificationPreheader}} {{organizationName}}.
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.quickbooksDisconnectedNotificationIntroPrefix}}{{organizationName}}{{labels.quickbooksDisconnectedNotificationIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.quickbooksDisconnectedNotificationMappings (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.quickbooksDisconnectedNotificationMappings}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.quickbooksDisconnectedNotificationQuestions (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.quickbooksDisconnectedNotificationQuestions}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.allTheBest (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_PAGE_CREATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.organizationPageCreatedDraftPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Header. Param: labels.organizationPageCreatedDraftTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.organizationPageCreatedDraftTitle}}</p></div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.organizationPageCreatedDraftWhatHeading}}</p>
      <!-- Organization-facing / Text (body paragraph). Param: labels.organizationPageCreatedDraftWhatBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPageCreatedDraftWhatBody}}</p>
    </div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPageCreatedDraftSupportersHeading}}</p>
    </div>
    <ul style="margin: 0 0 24px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.organizationPageCreatedDraftSupportersEvents}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.organizationPageCreatedDraftSupportersCampaigns}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.organizationPageCreatedDraftSupportersSubscribe}}</li>
    </ul>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.organizationPageCreatedDraftControlHeading}}</p>
      <!-- Organization-facing / Text (body paragraph). Param: labels.organizationPageCreatedDraftControlBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPageCreatedDraftControlBody}}</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.organizationPageCreatedDraftNextHeading}}</p>
      <!-- Organization-facing / Text (body paragraph). Param: labels.organizationPageCreatedDraftNextBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPageCreatedDraftNextBody}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.organizationPageCreatedButton (label path), organizationPageUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{organizationPageUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.organizationPageCreatedButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{organizationPageUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.organizationPageCreatedButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.organizationPageCreatedFeedback (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPageCreatedFeedback}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPageCreatedHappyFundraising}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_IMPORT_COMPLETED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.importCompletedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.importCompletedIntro (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.importCompletedIntro}}</p></div>
    {{#if contactLine}}
    <p class="mfs12" style="margin: 0 0 12px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><a href="{{contactLine.url}}" style="color: {{theme.bodyText}}; text-decoration: underline;">{{contactLine.count}} {{#if (eq contactLine.count 1)}}{{labels.importCompletedContactsOne}}{{else}}{{labels.importCompletedContactsMany}}{{/if}}</a></p>
    {{/if}}
    {{#if memberLine}}
    <p class="mfs12" style="margin: 0 0 12px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><a href="{{memberLine.url}}" style="color: {{theme.bodyText}}; text-decoration: underline;">{{memberLine.count}} {{#if (eq memberLine.count 1)}}{{labels.importCompletedMembersOne}}{{else}}{{labels.importCompletedMembersMany}}{{/if}}</a></p>
    {{/if}}
    {{#if templateLine}}
    <p class="mfs12" style="margin: 0 0 12px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><a href="{{templateLine.url}}" style="color: {{theme.bodyText}}; text-decoration: underline;">{{templateLine.count}} {{#if (eq templateLine.count 1)}}{{labels.importCompletedTemplatesOne}}{{else}}{{labels.importCompletedTemplatesMany}}{{/if}}</a>{{#if templateLine.skipped}} · {{templateLine.skipped}} {{#if (eq templateLine.skipped 1)}}{{labels.importCompletedSkippedOne}}{{else}}{{labels.importCompletedSkippedMany}}{{/if}}{{/if}}</p>
    {{/if}}
    {{#if emailLine}}
    <p class="mfs12" style="margin: 0 0 12px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><a href="{{emailLine.url}}" style="color: {{theme.bodyText}}; text-decoration: underline;">{{emailLine.count}} {{#if (eq emailLine.count 1)}}{{labels.importCompletedEmailsOne}}{{else}}{{labels.importCompletedEmailsMany}}{{/if}}</a>{{#if emailLine.skipped}} · {{emailLine.skipped}} {{#if (eq emailLine.skipped 1)}}{{labels.importCompletedSkippedOne}}{{else}}{{labels.importCompletedSkippedMany}}{{/if}}{{/if}}</p>
    {{/if}}
    {{#if listLine}}
    <p class="mfs12" style="margin: 0 0 12px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><a href="{{listLine.url}}" style="color: {{theme.bodyText}}; text-decoration: underline;">{{listLine.count}} {{#if (eq listLine.count 1)}}{{labels.importCompletedListsOne}}{{else}}{{labels.importCompletedListsMany}}{{/if}}</a></p>
    {{/if}}
    {{#if transactionLine}}
    <p class="mfs12" style="margin: 0 0 12px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><a href="{{transactionLine.url}}" style="color: {{theme.bodyText}}; text-decoration: underline;">{{transactionLine.count}} {{#if (eq transactionLine.count 1)}}{{labels.importCompletedTransactionsOne}}{{else}}{{labels.importCompletedTransactionsMany}}{{/if}}</a></p>
    {{/if}}
    <div style="margin: 24px 0 24px;"><!-- Organization-facing / Button. Params: labels.viewImport (label path), redirectionUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{redirectionUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.viewImport}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{redirectionUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.viewImport}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.importCompletedQuestions (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.importCompletedQuestions}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.allTheBest (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_EMAIL_STATS_READY = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.emailStatsReadyPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.emailStatsReadyTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.emailStatsReadyTitle}}</p></div>
    {{#if sentEmailSubject}}
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><strong style="font-weight: 700; color: {{theme.headerText}};">{{labels.scheduledEmailConfirmationSubjectLabel}}</strong> {{sentEmailSubject}}</p>
    </div>
    {{/if}}
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.emailStatsReadyBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.emailStatsReadyBody}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.emailStatsReadyButton (label path), followUpUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{followUpUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.emailStatsReadyButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{followUpUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.emailStatsReadyButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.emailStatsReadyClosing}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_ATTENDEE_CANCELLATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.attendeeCancellationPreheader}} {{eventTitle}}.
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.attendeeCancellationTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.attendeeCancellationTitle}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.hi}} {{adminFirstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><strong style="font-weight: 700;">{{buyerFirstName}} {{buyerLastName}}</strong>{{labels.attendeeCancellationIntroMiddle}}<strong style="font-weight: 700;">{{eventTitle}}</strong>{{labels.attendeeCancellationCancelledPrefix}}{{cancelledCount}}{{labels.attendeeCancellationCancelledSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <!-- Organization-facing / Bullet list (block partial). Slot: one or more org-bullet items.
     Usage: open a block ("#>" org-list), put org-bullet partials inside, close the block.
     No literal partial syntax in this comment — the inliner resolves partial refs even in comments. -->
<ul style="margin: 0; padding-left: 20px;">
        {{#each cancelledLines}}
        <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../theme.bodyText}}; word-break: break-word;">{{name}} · {{#if isAddOn}}{{../labels.attendeeCancellationAddOnNumber}}{{else}}{{../labels.attendeeCancellationTicketNumber}}{{/if}}{{number}}</li>
        {{/each}}
      </ul>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{#if isSingleCancellation}}{{labels.attendeeCancellationSpotSingle}}{{else}}{{labels.attendeeCancellationSpotsPrefix}}{{cancelledCount}}{{labels.attendeeCancellationSpotsSuffix}}{{/if}}</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.attendeeCancellationNoRefundPrefix}}{{buyerFirstName}}{{labels.attendeeCancellationNoRefundSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Button. Params: labels.attendeeCancellationViewGuestListButton (label path), guestListUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{guestListUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.attendeeCancellationViewGuestListButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{guestListUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.attendeeCancellationViewGuestListButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0;"><!-- Organization-facing / Link. Params: labels.attendeeCancellationSeePaymentLink (label path), paymentUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{paymentUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.attendeeCancellationSeePaymentLink}}</a></div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_NBCTC_NEW_LEAD_SIGNED_UP = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.nbctcNewLeadSignedUpPreheader}} {{orgName}}.
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.nbctcNewLeadSignedUpGreeting}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.nbctcNewLeadSignedUpIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nbctcNewLeadSignedUpIntro}}</p></div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nbctcNewLeadSignedUpDetailsIntro}}</p>
    </div>
    <ul style="margin: 0 0 16px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nbctcNewLeadSignedUpOrgName}} {{orgName}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nbctcNewLeadSignedUpOrgState}} {{orgState}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nbctcNewLeadSignedUpOrgId}} {{orgId}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nbctcNewLeadSignedUpContactFirstName}} {{contactFirstName}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nbctcNewLeadSignedUpContactLastName}} {{contactLastName}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nbctcNewLeadSignedUpContactEmail}} {{contactEmail}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nbctcNewLeadSignedUpReferralCode}} {{referralCode}}</li>
    </ul>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.nbctcNewLeadSignedUpThanks (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.nbctcNewLeadSignedUpThanks}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_TIPS_UPCOMING_EVENT = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.tipsUpcomingEventPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
{{!-- Figma: Design System | Product Zeffy → Email-Org-Container (node 11697-2916). Banner header
     owns the card's top rounding, so the body below is called with false=true. --}}
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Banner header. Params: labels.tipsUpcomingEventBannerSubtitle, labels.tipsUpcomingEventTitle (label paths).
     Brand-blue banner that tops the card (rounded 12px top corners) with an accent subtitle over a
     large title. Pair it with an org-body called with flatTop true so the white card below doesn't
     re-round the corners the banner already owns. Subtitle 14.5px/12px (.mfs12) · title 29px/24px (.mfs24). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.brandFilledBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td class="mobile-pad-banner" style="padding: 24px;">
  <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bannerAccentText}}; word-break: break-word;">{{labels.tipsUpcomingEventBannerSubtitle}}</p>
  <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.bannerTitleText}}; word-break: break-word;">{{labels.tipsUpcomingEventTitle}}</p>
</td></tr></table>
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     true (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 4px;"><!-- Organization-facing / H2 (section heading). Param: labels.tipsUpcomingEventTrackHeading (label path). Desktop 22px · mobile 18px (.mfs18).
     Sits below org-header (29px) in the hierarchy — use it for section headings inside a body. -->
<p class="mfs18" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 22px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.tipsUpcomingEventTrackHeading}}</p></div>
    <div style="margin: 0 0 20px;">
      <!-- Organization-facing / Bullet list (block partial). Slot: one or more org-bullet items.
     Usage: open a block ("#>" org-list), put org-bullet partials inside, close the block.
     No literal partial syntax in this comment — the inliner resolves partial refs even in comments. -->
<ul style="margin: 0; padding-left: 20px;">
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventTrackBullet1 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventTrackBullet1}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventTrackBullet2 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventTrackBullet2}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventTrackBullet3 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventTrackBullet3}}</li>
      </ul>
    </div>
    <div style="margin: 0 0 20px;"><!-- Organization-facing / Button. Params: labels.tipsUpcomingEventGuestListButton (label path), accessLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{accessLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.tipsUpcomingEventGuestListButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{accessLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.tipsUpcomingEventGuestListButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>

    <div style="margin: 0 0 20px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 4px;"><!-- Organization-facing / H2 (section heading). Param: labels.tipsUpcomingEventShareHeading (label path). Desktop 22px · mobile 18px (.mfs18).
     Sits below org-header (29px) in the hierarchy — use it for section headings inside a body. -->
<p class="mfs18" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 22px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.tipsUpcomingEventShareHeading}}</p></div>
    <div style="margin: 0 0 4px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventShareIntroPrefix}}<strong style="font-weight: 700;">{{labels.tipsUpcomingEventShareIntroBold}}</strong></p>
    </div>
    <div style="margin: 0 0 20px;">
      <!-- Organization-facing / Bullet list (block partial). Slot: one or more org-bullet items.
     Usage: open a block ("#>" org-list), put org-bullet partials inside, close the block.
     No literal partial syntax in this comment — the inliner resolves partial refs even in comments. -->
<ul style="margin: 0; padding-left: 20px;">
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventShareBullet1 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventShareBullet1}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventShareBullet2 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventShareBullet2}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventShareBullet3 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventShareBullet3}}</li>
      </ul>
    </div>
    <div style="margin: 0 0 20px;"><!-- Organization-facing / Button. Params: labels.tipsUpcomingEventEmailerButton (label path), emailerLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{emailerLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.tipsUpcomingEventEmailerButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{emailerLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.tipsUpcomingEventEmailerButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>

    <div style="margin: 0 0 20px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 4px;"><!-- Organization-facing / H2 (section heading). Param: labels.tipsUpcomingEventAppHeading (label path). Desktop 22px · mobile 18px (.mfs18).
     Sits below org-header (29px) in the hierarchy — use it for section headings inside a body. -->
<p class="mfs18" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 22px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.tipsUpcomingEventAppHeading}}</p></div>
    <div style="margin: 0 0 20px;">
      <!-- Organization-facing / Bullet list (block partial). Slot: one or more org-bullet items.
     Usage: open a block ("#>" org-list), put org-bullet partials inside, close the block.
     No literal partial syntax in this comment — the inliner resolves partial refs even in comments. -->
<ul style="margin: 0; padding-left: 20px;">
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventAppBullet1 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventAppBullet1}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventAppBullet2 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventAppBullet2}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventAppBullet3 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventAppBullet3}}</li>
      </ul>
    </div>
    <div style="margin: 0;"><!-- Organization-facing / Zeffy app download buttons (App Store filled + Google Play outline, side by side).
     Reads appStoreUrl, playStoreUrl, isPreview and labels from context — the caller passes no params,
     it just ensures those template variables exist (see getAppStoreUrl / getPlayStoreUrl in helpers/mobile-app-links.ts). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="padding: 0 8px 0 0;"><!-- Organization-facing / Button. Params: labels.appStoreButton (label path), appStoreUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{appStoreUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.appStoreButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{appStoreUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.appStoreButton}}</a>
  <!--<![endif]-->
</td></tr></table></td>
  <td><!-- Organization-facing / Button. Params: labels.googlePlayButton (label path), playStoreUrl (path), true (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{playStoreUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.outlineBg}}" strokecolor="{{theme.outlineBorder}}"><w:anchorlock/><center style="color:{{theme.outlineText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.googlePlayButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{playStoreUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.outlineBg}}; border: 0.75px solid {{theme.outlineBorder}}; color: {{theme.outlineText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.googlePlayButton}}</a>
  <!--<![endif]-->
</td></tr></table></td>
</tr></table></div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_PAGE_PUBLISHED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.organizationPagePublishedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.organizationPagePublishedEyebrow, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.organizationPagePublishedEyebrow}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.organizationPagePublishedEyebrow (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.organizationPagePublishedEyebrow}}</p></div>
  {{/if}}
  
  
    <div style="margin: 0 0 24px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.organizationPagePublishedTitlePrefix}}{{organizationName}}{{labels.organizationPagePublishedTitleSuffix}}</p>
    </div>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    <div style="margin: 0 0 8px;"><!-- Organization-facing / Text (body paragraph). Param: labels.organizationPagePublishedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPagePublishedIntro}}</p></div>
    <div style="margin: 0 0 20px;">
      <!-- Organization-facing / Bullet list (block partial). Slot: one or more org-bullet items.
     Usage: open a block ("#>" org-list), put org-bullet partials inside, close the block.
     No literal partial syntax in this comment — the inliner resolves partial refs even in comments. -->
<ul style="margin: 0; padding-left: 20px;">
        <!-- Organization-facing / Bullet list item. Params: labels.organizationPagePublishedSupportersCampaigns (label path), optional true (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPagePublishedSupportersCampaigns}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.organizationPagePublishedSupportersSubscribe (label path), optional true (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPagePublishedSupportersSubscribe}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.organizationPagePublishedSupportersNewsletters (label path), optional true (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPagePublishedSupportersNewsletters}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.organizationPagePublishedSupportersContact (label path), optional true (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPagePublishedSupportersContact}}</li>
      </ul>
    </div>
    {{#if organizationPagePreviewImageUrl}}
    <a {{#unless isPreview}}href="{{organizationPageUrl}}" target="_blank" {{/unless}}style="display: block; margin: 0 0 20px; text-decoration: none;">
      <img src="{{organizationPagePreviewImageUrl}}" width="540" alt="{{organizationName}}" style="display: block; width: 100%; max-width: 540px; height: auto; border: 0; border-radius: 12px;" />
    </a>
    {{/if}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / H2 (section heading). Param: labels.organizationPagePublishedCustomizeHeading (label path). Desktop 22px · mobile 18px (.mfs18).
     Sits below org-header (29px) in the hierarchy — use it for section headings inside a body. -->
<p class="mfs18" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 22px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.organizationPagePublishedCustomizeHeading}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.organizationPagePublishedCustomizeBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPagePublishedCustomizeBody}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.organizationPagePublishedCustomizeButton (label path), organizationPageEditorUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{organizationPageEditorUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.organizationPagePublishedCustomizeButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{organizationPageEditorUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.organizationPagePublishedCustomizeButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPagePublishedUnpublishPrefix}} <!-- Organization-facing / Link. Params: labels.organizationPagePublishedUnpublishLink (label path), organizationPageLoginUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{organizationPageLoginUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.organizationPagePublishedUnpublishLink}}</a></p>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPageCreatedHappyFundraising}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_MAILING_FEEDBACK_REQUEST = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.mailingFeedbackPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.mailingFeedbackIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.mailingFeedbackIntro}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.mailingFeedbackQuestion}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.mailingFeedbackShapes (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.mailingFeedbackShapes}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.mailingFeedbackThanks (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.mailingFeedbackThanks}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.mailingFeedbackClosing}}<br />{{labels.mailingFeedbackSignature}}<br />{{labels.mailingFeedbackSignatureRole}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_FAILED_PAD_ACH = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.failedPadAchPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.failedPadAchIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.failedPadAchIntroSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.failedPadAchIntro}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.failedPadAchIntroSuffix}}{{/if}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{buyerName}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{buyerEmail}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{amount}}</p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{transactionDate}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.failedPadAchQuestions (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.failedPadAchQuestions}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.allTheBest (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_ISSUING_CARD_ON_THE_WAY = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.issuingCardOnTheWayPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.treasuryCongratulationsSubtitle, labels.issuingCardOnTheWayTitle (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.treasuryCongratulationsSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.treasuryCongratulationsSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryCongratulationsSubtitle}}</p></div>
  {{/if}}
  {{#if labels.issuingCardOnTheWayTitle}}
  <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.issuingCardOnTheWayTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.issuingCardOnTheWayTitle}}</p></div>
  {{/if}}
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.issuingCardOnTheWayWhenQuestion}}</p>
      <!-- Organization-facing / Text (body paragraph). Param: labels.issuingCardOnTheWayWhenAnswer (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingCardOnTheWayWhenAnswer}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.issuingCardOnTheWayActivateQuestion}}</p>
      <!-- Organization-facing / Text (body paragraph). Param: labels.issuingCardOnTheWayActivateAnswer (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingCardOnTheWayActivateAnswer}}</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.issuingCardOnTheWayUseQuestion}}</p>
      <!-- Organization-facing / Text (body paragraph). Param: labels.issuingCardOnTheWayUseAnswer (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingCardOnTheWayUseAnswer}}</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.issuingCardOnTheWayShippingHeading}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{address}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{city}}, {{postalCode}}</p>
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{region}}, {{country}}</p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.issuingCardOnTheWayExpectedDelivery}}</p>
    </div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.issuingCardOnTheWayContactPrefix}} <!-- Organization-facing / Link. Params: labels.issuingCardOnTheWayContactLink (label path), supportEmailUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{supportEmailUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.issuingCardOnTheWayContactLink}}</a>
    </p>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryCelticBankDisclaimer}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_NEGATIVE_PAYOUT_CREATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.negativePayoutCreatedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.negativePayoutCreatedIntroPrefix}}{{amount}}{{labels.negativePayoutCreatedIntroMiddle}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.negativePayoutCreatedIntroAccount}}{{account}}{{labels.negativePayoutCreatedIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.negativePayoutCreatedExplanation (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.negativePayoutCreatedExplanation}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.negativePayoutCreatedDocsPrefix}}<a href="{{labels.negativePayoutCreatedDocsUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.negativePayoutCreatedDocsLink}}</a>{{labels.negativePayoutCreatedDocsSuffix}}</p>
    </div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.allTheBest (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_FIRST_PAYMENT_RECEIVED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.firstPaymentReceivedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.firstPaymentReceivedTitlePrefix}}{{firstPaymentAmount}}{{labels.firstPaymentReceivedTitleSuffix}}</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.firstPaymentReceivedEvenBetterPrefix}}<strong style="color: {{theme.headerText}};">{{firstPaymentAmount}}</strong>{{labels.firstPaymentReceivedEvenBetterSuffix}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.firstPaymentReceivedViewPayouts (label path), viewPayoutLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{viewPayoutLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.firstPaymentReceivedViewPayouts}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{viewPayoutLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.firstPaymentReceivedViewPayouts}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.firstPaymentReceivedPromise (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.firstPaymentReceivedPromiseSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.firstPaymentReceivedPromise}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.firstPaymentReceivedPromiseSuffix}}{{/if}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.firstPaymentReceivedTypicallyPrefix}}<strong style="color: {{theme.headerText}};">{{processingtime}}</strong>{{labels.firstPaymentReceivedTypicallySuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.firstPaymentReceivedThanks (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.firstPaymentReceivedThanks}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.firstPaymentReceivedCheers (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.firstPaymentReceivedCheers}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_RECURRING_DONATION_CANCELLED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.recurringDonationCancelledOrganizationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.recurringDonationCancelledOrganizationIntroPrefix}} <strong style="color: {{theme.headerText}};">{{donorFirstName}} {{donorLastName}} {{labels.recurringDonationCancelledOrganizationIntroOrg}} <strong style="font-weight: 700;">{{orgName}}</strong></strong>
      {{labels.recurringDonationCancelledOrganizationIntroMiddle}} {{churnReason}}{{labels.recurringDonationCancelledOrganizationIntroSuffix}}
    </p>
    {{#if cancellationReason}}
    <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      <strong style="color: {{theme.headerText}};">{{labels.recurringDonationCancelledOrganizationReason}}</strong> {{cancellationReason}}
    </p>
    {{/if}}
    {{#if cancellationFeedback}}
    <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      <strong style="color: {{theme.headerText}};">{{labels.recurringDonationCancelledOrganizationFeedback}}</strong> {{cancellationFeedback}}
    </p>
    {{/if}}
    {{#if donorEmail}}
    <p class="mfs12" style="margin: 16px 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.recurringDonationCancelledOrganizationContactPrefix}}
      <a {{#unless isPreview}}href="mailto:{{donorEmail}}" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{donorEmail}}</a>{{labels.recurringDonationCancelledOrganizationContactSuffix}}
    </p>
    {{/if}}
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_MONTHLY_VISITOR_REPORT = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.monthlyVisitorReportPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  {{!-- Same rendering as org-banner-header — inlined because both lines interpolate variables
       (reportDate / firstName / orgName), which the partial's label params can't express. --}}
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.brandFilledBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td class="mobile-pad-banner" style="padding: 24px;">
    <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bannerAccentText}}; word-break: break-word;">{{reportDate}}</p>
    <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.bannerTitleText}}; word-break: break-word;">👋 {{labels.hi}} {{firstName}}, {{labels.monthlyVisitorReportTitlePrefix}} {{orgName}} {{labels.monthlyVisitorReportTitleSuffix}}</p>
  </td></tr></table>
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     true (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.monthlyVisitorReportFundsRaisedHeading}}</p>
      <p class="mfs22" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 24px; line-height: 1.3; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{fundsRaised}}</p>
      {{#if forms.length}}
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin-top: 8px;">
        {{#each forms}}
        <tr>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../theme.bodyText}}; padding: 3px 8px 3px 0; vertical-align: baseline; word-break: break-word;">{{title}}</td>
          <td align="right" class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{../theme.headerText}}; padding: 3px 0; vertical-align: baseline; white-space: nowrap;">{{volume}}</td>
        </tr>
        {{/each}}
      </table>
      {{#if moreFormsCount}}
      <p class="mfs12" style="margin: 8px 0 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.visitorReportAndMorePrefix}}{{moreFormsCount}}{{labels.visitorReportAndMoreSuffix}}</p>
      {{/if}}
      {{/if}}
    </div>
    {{#if hasPayout}}
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.monthlyVisitorReportPayoutsHeading}}</p>
      <p class="mfs22" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 24px; line-height: 1.3; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{payoutAmount}}</p>
    </div>
    {{/if}}
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.monthlyVisitorReportFeesSavedHeading}}</p>
      <p class="mfs22" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 24px; line-height: 1.3; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{feesSaved}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.monthlyVisitorReportCongrats (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.monthlyVisitorReportCongrats}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.monthlyVisitorReportPaymentsButton (label path), paymentPageLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{paymentPageLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.monthlyVisitorReportPaymentsButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{paymentPageLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.monthlyVisitorReportPaymentsButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.recurringReportAddUsersPrefix}} <!-- Organization-facing / Link. Params: labels.recurringReportAddUsersLink (label path), addUserLink (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{addUserLink}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.recurringReportAddUsersLink}}</a> {{labels.recurringReportAddUsersSuffix}}
    </p>
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.recurringReportMissingInfoPrefix}} <!-- Organization-facing / Link. Params: labels.recurringReportMissingInfoLink (label path), letUsKnowLink (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{letUsKnowLink}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.recurringReportMissingInfoLink}}</a>
    </p>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.monthlyVisitorReportUnsubscribePrompt}} <a {{#unless isPreview}}href="{{unsubscribeLink}}" target="_blank" {{/unless}}style="color: {{theme.link}}; text-decoration: underline;">{{labels.footerUnsubscribeLink}}</a>
    </p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_FACING_COMPONENTS = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Showcase / composition gallery for the organization-facing email design system.
     Demonstrates every component (header, subtitle, text, button, link, footer) composed into
     body sections inside the container. Rendered by the Storybook story at desktop + mobile widths. -->
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Banner header. Params: labels.tipsUpcomingEventBannerSubtitle, labels.tipsUpcomingEventTitle (label paths).
     Brand-blue banner that tops the card (rounded 12px top corners) with an accent subtitle over a
     large title. Pair it with an org-body called with flatTop true so the white card below doesn't
     re-round the corners the banner already owns. Subtitle 14.5px/12px (.mfs12) · title 29px/24px (.mfs24). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.brandFilledBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td class="mobile-pad-banner" style="padding: 24px;">
  <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bannerAccentText}}; word-break: break-word;">{{labels.tipsUpcomingEventBannerSubtitle}}</p>
  <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.bannerTitleText}}; word-break: break-word;">{{labels.tipsUpcomingEventTitle}}</p>
</td></tr></table>
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.preheaderTicketingCreated, labels.ticketingCreatedTitle (label paths),
     true (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.preheaderTicketingCreated}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.preheaderTicketingCreated (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.preheaderTicketingCreated}}</p></div>
  {{/if}}
  {{#if labels.ticketingCreatedTitle}}
  <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.ticketingCreatedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.ticketingCreatedTitle}}</p></div>
  {{/if}}
  
    <div style="margin: 0 0 4px;"><!-- Organization-facing / H2 (section heading). Param: labels.tipsUpcomingEventTrackHeading (label path). Desktop 22px · mobile 18px (.mfs18).
     Sits below org-header (29px) in the hierarchy — use it for section headings inside a body. -->
<p class="mfs18" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 22px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.tipsUpcomingEventTrackHeading}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.ticketingCreatedShareIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.ticketingCreatedShareIntro}}</p></div>
    <div style="margin: 0 0 10px;"><!-- Organization-facing / Button. Params: labels.viewMyForm (label path), formUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{formUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.viewMyForm}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{formUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.viewMyForm}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Button. Params: labels.auctionCreatedGuideLink (label path), formUrl (path), true (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{formUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.outlineBg}}" strokecolor="{{theme.outlineBorder}}"><w:anchorlock/><center style="color:{{theme.outlineText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.auctionCreatedGuideLink}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{formUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.outlineBg}}; border: 0.75px solid {{theme.outlineBorder}}; color: {{theme.outlineText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.auctionCreatedGuideLink}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Link. Params: labels.footerLearnMore (label path), formUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{formUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.footerLearnMore}}</a></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: "Brand" ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq "Brand" "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 16px;">
      <!-- Organization-facing / Bullet list (block partial). Slot: one or more org-bullet items.
     Usage: open a block ("#>" org-list), put org-bullet partials inside, close the block.
     No literal partial syntax in this comment — the inliner resolves partial refs even in comments. -->
<ul style="margin: 0; padding-left: 20px;">
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventTrackBullet1 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventTrackBullet1}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventTrackBullet2 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventTrackBullet2}}</li>
        <!-- Organization-facing / Bullet list item. Params: labels.tipsUpcomingEventTrackBullet3 (label path), optional false (bool → no gap between items). Use inside an org-list block. Desktop 14.5px · mobile 12px (.mfs12). -->
<li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.tipsUpcomingEventTrackBullet3}}</li>
      </ul>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Zeffy app download buttons (App Store filled + Google Play outline, side by side).
     Reads appStoreUrl, playStoreUrl, isPreview and labels from context — the caller passes no params,
     it just ensures those template variables exist (see getAppStoreUrl / getPlayStoreUrl in helpers/mobile-app-links.ts). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="padding: 0 8px 0 0;"><!-- Organization-facing / Button. Params: labels.appStoreButton (label path), appStoreUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{appStoreUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.appStoreButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{appStoreUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.appStoreButton}}</a>
  <!--<![endif]-->
</td></tr></table></td>
  <td><!-- Organization-facing / Button. Params: labels.googlePlayButton (label path), playStoreUrl (path), true (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{playStoreUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.outlineBg}}" strokecolor="{{theme.outlineBorder}}"><w:anchorlock/><center style="color:{{theme.outlineText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.googlePlayButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{playStoreUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.outlineBg}}; border: 0.75px solid {{theme.outlineBorder}}; color: {{theme.outlineText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.googlePlayButton}}</a>
  <!--<![endif]-->
</td></tr></table></td>
</tr></table></div>
    <!-- Organization-facing / Text (body paragraph). Param: labels.ticketingCreatedClosing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.ticketingCreatedClosing}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_IMPORT_FAILED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.importFailedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">{{#if isMailchimpImport}}<!-- Organization-facing / Text (body paragraph). Param: labels.importFailedIntroMailchimp (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.importFailedIntroMailchimp}}</p>{{else}}<!-- Organization-facing / Text (body paragraph). Param: labels.importFailedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.importFailedIntro}}</p>{{/if}}</div>
    {{#if hasEmailValidationError}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.importFailedEmailValidationError (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.importFailedEmailValidationError}}</p></div>
    {{else}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.importFailedInfo (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.importFailedInfo}}</p></div>
    {{/if}}
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.importFailedButton (label path), redirectionUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{redirectionUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.importFailedButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{redirectionUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.importFailedButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.thankYou (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.thankYou}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_PAYOUT_CREATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.payoutCreatedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    {{!-- Same rendering as org-header — inlined because the heading interpolates {{amount}}, which
         the partial's single false label param can't express. --}}
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.payoutCreatedIntroPrefix}}{{amount}}{{labels.payoutCreatedIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.payoutCreatedDepositPrefix}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.payoutCreatedDepositAccount}}<strong style="font-weight: 700;">{{account}}</strong>{{labels.payoutCreatedDepositSuffix}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.payoutCreatedViewMyPayout (label path), payoutDetailLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{payoutDetailLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.payoutCreatedViewMyPayout}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{payoutDetailLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.payoutCreatedViewMyPayout}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    {{#if fundsBreakdownList}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.payoutCreatedFundsHeading}}</p>
      <div class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{{fundsBreakdownList}}}</div>
    </div>
    {{/if}}
    {{#if campaignsBreakdownList}}
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.payoutCreatedCampaignsHeading}}</p>
      <div class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{{campaignsBreakdownList}}}</div>
    </div>
    {{/if}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.payoutCreatedDocsPrefix}}<a href="{{labels.payoutCreatedDocsUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.payoutCreatedDocsLink}}</a>{{labels.payoutCreatedDocsSuffix}}</p>
    </div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.allTheBest (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_FIRST_PROCESSED_PAYMENT_WITHOUT_BANK = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.firstProcessedPaymentWithoutBankPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.firstProcessedPaymentWithoutBankTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.firstProcessedPaymentWithoutBankTitle}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.firstProcessedPaymentWithoutBankIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.firstProcessedPaymentWithoutBankIntro}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.firstProcessedPaymentWithoutBankOrganizationHeading}}</p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{orgName}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.firstProcessedPaymentWithoutBankInfo (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.firstProcessedPaymentWithoutBankInfo}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.firstProcessedPaymentWithoutBankClosing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.firstProcessedPaymentWithoutBankClosing}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_RADAR_EARLY_FRAUD = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.radarEarlyFraudPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.radarEarlyFraudIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.radarEarlyFraudIntroSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.radarEarlyFraudIntro}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.radarEarlyFraudIntroSuffix}}{{/if}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.disputeDetailsHeading}}</p>
      {{#if description}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeDetailDescription}} {{description}}</p>
      {{/if}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeDetailAmount}} <strong style="color: {{theme.headerText}};">{{amount}}</strong></p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.disputeDetailDate}} {{date}}</p>
      {{#if donorEmail}}
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.radarEarlyFraudDonorEmail}} {{donorEmail}}</p>
      {{/if}}
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.radarEarlyFraudResolution (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.radarEarlyFraudResolution}}</p></div>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.radarEarlyFraudLearnMorePrefix}} <a {{#unless isPreview}}href="{{labels.disputeHelpUrl}}" target="_blank" {{/unless}}style="font-family: Arial, Helvetica, sans-serif; color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.radarEarlyFraudLearnMoreLink}}</a>
    </p>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.radarEarlyFraudQuestions (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.radarEarlyFraudQuestions}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.radarEarlyFraudThanks}}<br />{{labels.allTheBest}}</p>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_PAYOUT_FAILED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.payoutFailedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    {{!-- Same rendering as org-header — inlined because the heading interpolates {{amount}}, which
         the partial's single false label param can't express. --}}
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.payoutFailedIntroPrefix}}{{amount}}{{labels.payoutFailedIntroOrg}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.payoutFailedIntroNoReason}}</p>
    </div>
    {{#if failureMessage}}
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.payoutFailedReasonIntro}} <strong style="font-weight: 700;">{{failureMessage}}</strong></p>
    </div>
    {{/if}}
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.payoutFailedFundsPrefix}}<a href="{{labels.payoutFailedDocsUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.payoutFailedDocsLink}}</a>{{labels.payoutFailedFundsSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.payoutFailedQuestions (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.payoutFailedQuestions}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.allTheBest (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_AUCTION_CLOSED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.auctionClosedPreheader}} {{formTitle}}.
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    {{!-- Same rendering as org-header — inlined because the heading interpolates {{formTitle}},
         which the partial's single false label param can't express. --}}
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.auctionClosedTitlePrefix}}{{formTitle}}{{labels.auctionClosedTitleSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.auctionClosedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.auctionClosedIntro}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><strong style="font-weight: 700;">{{labels.auctionClosedAmountRaised}}</strong> {{totalAmountRaised}}</p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><strong style="font-weight: 700;">{{labels.auctionClosedAmountSaved}}</strong> {{totalAmountSaved}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.auctionClosedPaymentIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.auctionClosedPaymentIntro}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.auctionClosedPaymentButton (label path), auctionPaymentLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{auctionPaymentLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.auctionClosedPaymentButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{auctionPaymentLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.auctionClosedPaymentButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_INSUFFICIENT_CAPABILITIES = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.insufficientCapabilitiesPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.insufficientCapabilitiesSubtitle, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.insufficientCapabilitiesSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.insufficientCapabilitiesSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.insufficientCapabilitiesSubtitle}}</p></div>
  {{/if}}
  
  
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{alertSubject}}</p>
    </div>
    <div class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{{alertMessageHtml}}}</div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_NEWSLETTER_SIGNUP_NOTIFICATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.newsletterSignupNotificationPreheader}} {{formName}}.
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.newsletterSignupNotificationTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.newsletterSignupNotificationTitle}}</p></div>
    {{#if organizationPageUrl}}
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationOrgPageIntro}} <a href="{{organizationPageUrl}}" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.newsletterSignupNotificationOrgPageLink}}</a>{{labels.newsletterSignupNotificationOrgPageIntroSuffix}}</p>
    {{/if}}
    <div style="margin: 0 0 16px;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 8px;"><tr>
        <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; white-space: nowrap; padding-right: 12px;">{{labels.newsletterSignupNotificationFormHeading}}</td>
        <td width="100%" style="vertical-align: middle;"><table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr><td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{theme.dividerNeutral}}; border-radius: 10px;">&nbsp;</td></tr></table></td>
      </tr></table>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationFormName}} {{formName}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 8px;"><tr>
        <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; white-space: nowrap; padding-right: 12px;">{{labels.newsletterSignupNotificationContactHeading}}</td>
        <td width="100%" style="vertical-align: middle;"><table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr><td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{theme.dividerNeutral}}; border-radius: 10px;">&nbsp;</td></tr></table></td>
      </tr></table>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationContactName}} {{contactFirstName}} {{contactLastName}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationContactEmail}} {{contactEmail}}</p>
      {{#if contactCommunicationPreferences}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationContactCommunicationPreferences}} {{contactCommunicationPreferences}}</p>
      {{/if}}
      {{#if contactPhoneNumber}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationContactPhone}} {{contactPhoneNumber}}</p>
      {{/if}}
      {{#if contactAddress}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationContactAddress}} {{contactAddress}}</p>
      {{/if}}
      {{#if contactCity}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationContactCity}} {{contactCity}}</p>
      {{/if}}
      {{#if contactState}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationContactState}} {{contactState}}</p>
      {{/if}}
      {{#if contactCountry}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationContactCountry}} {{contactCountry}}</p>
      {{/if}}
      {{#if contactLanguage}}
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationContactLanguage}} {{contactLanguage}}</p>
      {{/if}}
    </div>
    {{#if welcomeSequenceUrl}}
    <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 16px; border-collapse: separate;"><tr>
      <td style="padding: 16px; background-color: {{theme.dividerBrand}}; border-radius: 8px;">
        <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.newsletterSignupNotificationWelcomeSequenceText (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationWelcomeSequenceText}}</p></div>
        <!-- Organization-facing / Button. Params: labels.newsletterSignupNotificationWelcomeSequenceCta (label path), welcomeSequenceUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{welcomeSequenceUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.newsletterSignupNotificationWelcomeSequenceCta}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{welcomeSequenceUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.newsletterSignupNotificationWelcomeSequenceCta}}</a>
  <!--<![endif]-->
</td></tr></table>
      </td>
    </tr></table>
    {{/if}}
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.newsletterSignupNotificationClosing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newsletterSignupNotificationClosing}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_OUTBOUND_PAYMENT_FAILED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.outboundPaymentFailedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.treasuryOopsSubtitle, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.treasuryOopsSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.treasuryOopsSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryOopsSubtitle}}</p></div>
  {{/if}}
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.outboundPaymentFailedTitlePrefix}} {{amount}} {{labels.outboundPaymentFailedTitleTo}} {{beneficiary}} {{labels.outboundPaymentFailedTitleSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.outboundPaymentFailedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.outboundPaymentFailedIntro}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.outboundPaymentFailedInfo (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.outboundPaymentFailedInfo}}</p></div>
    <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.treasuryRaiseMoreHeading}}</p>
    <ul style="margin: 0; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMorePeerToPeer}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreRaffle}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreEvent}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreShop}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreAndMore}}</li>
    </ul>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.treasuryStripePartnerPrefix}} <a {{#unless isPreview}}href="{{labels.treasuryStripePartnerUrl}}" target="_blank" {{/unless}}class="account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: {{theme.link}}; text-decoration: underline;">{{labels.treasuryStripePartnerLink}}</a> {{labels.treasuryStripePartnerSuffix}}
    </p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_BENEFICIARY_ADDED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.beneficiaryAddedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.treasurySuccessSubtitle, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.treasurySuccessSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.treasurySuccessSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasurySuccessSubtitle}}</p></div>
  {{/if}}
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.beneficiaryAddedTitlePrefix}} {{beneficiary}} {{labels.beneficiaryAddedTitleSuffix}}</p>
    </div>
    <div style="margin: 0;"><!-- Organization-facing / Text (body paragraph). Param: labels.beneficiaryAddedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.beneficiaryAddedIntro}}</p></div>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.treasuryStripePartnerPrefix}} <a {{#unless isPreview}}href="{{labels.treasuryStripePartnerUrl}}" target="_blank" {{/unless}}class="account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: {{theme.link}}; text-decoration: underline;">{{labels.treasuryStripePartnerLink}}</a> {{labels.treasuryStripePartnerSuffix}}
    </p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_SUBSCRIPTION_AMOUNT_UPDATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.subscriptionAmountUpdatedOrganizationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.subscriptionAmountUpdatedOrganizationIntroPrefix}} <strong style="color: {{theme.headerText}};">{{donorFirstName}} {{donorLastName}} {{labels.subscriptionAmountUpdatedOrganizationIntroOrg}} <strong style="font-weight: 700;">{{orgName}}</strong></strong> {{labels.subscriptionAmountUpdatedOrganizationIntroMiddle}}
      <strong style="color: {{theme.headerText}};">{{previousAmount}}</strong> {{labels.subscriptionAmountUpdatedOrganizationIntroTo}}
      <strong style="color: {{theme.headerText}};">{{newAmount}}</strong>{{labels.subscriptionAmountUpdatedOrganizationIntroSuffix}}
    </p>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.subscriptionAmountUpdatedOrganizationEditNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.subscriptionAmountUpdatedOrganizationEditNote}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_STRIPE_VERIFICATION_COMPLETED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.stripeVerificationCompletedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.stripeVerificationCompletedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.stripeVerificationCompletedTitle}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.stripeVerificationCompletedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.stripeVerificationCompletedIntroSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeVerificationCompletedIntro}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.stripeVerificationCompletedIntroSuffix}}{{/if}}</p></div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.stripeVerificationCompletedWhatsNext}}</p>
    </div>
    <ul style="margin: 0 0 16px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeVerificationCompletedBankConnected}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeVerificationCompletedBankNotConnectedPrefix}}<a href="{{labels.stripeVerificationCompletedBankUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.stripeVerificationCompletedBankLink}}</a>{{labels.stripeVerificationCompletedBankNotConnectedSuffix}}</li>
    </ul>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.stripeVerificationCompletedHelpPrefix}}<a href="{{labels.stripeVerificationCompletedHelpUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.stripeVerificationCompletedHelpLink}}</a>{{labels.stripeVerificationCompletedHelpSuffix}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_DONATION_RECEIVED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.donationReceivedOrganizationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: formTitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{formTitle}}</p></div>
    <p class="mfs24" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">
      {{#if isChequeAwaitingPayment}}{{labels.chequeDonationOnTheWayOrganizationTitle}}{{else}}{{labels.donationReceivedOrganizationTitlePrefix}} {{amount}}{{labels.donationReceivedOrganizationTitleSuffix}}{{/if}}
    </p>
    {{#if tribute}}
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">
      💜 {{#if (eq tribute "inHonourOf")}}{{labels.donationReceivedOrganizationInHonourOf}}{{else}}{{labels.donationReceivedOrganizationInMemoryOf}}{{/if}} {{inHonourName}}{{labels.donationReceivedOrganizationTributeSuffix}}
    </p>
    {{/if}}
    {{#if (and isPadOrAch (eq currency "usd"))}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.donationReceivedOrganizationAchNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.donationReceivedOrganizationAchNote}}</p></div>
    {{/if}}
    {{#if (and isPadOrAch (eq currency "cad"))}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.donationReceivedOrganizationPadNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.donationReceivedOrganizationPadNote}}</p></div>
    {{/if}}
    {{#if (and isPadOrAch (eq currency "eur"))}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.donationReceivedOrganizationSepaNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.donationReceivedOrganizationSepaNote}}</p></div>
    {{/if}}
    {{#if isDaf}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.donationReceivedOrganizationDafNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.donationReceivedOrganizationDafNote}}</p></div>
    {{/if}}
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{donorFirstName}} {{donorLastName}}</p>
      {{#if donorEmail}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{donorEmail}}</p>
      {{/if}}
      {{#if address}}
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{address}}</p>
      {{/if}}
    </div>
    {{#if fundName}}
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.donationReceivedOrganizationFundLabel}} {{fundName}}
    </p>
    {{/if}}
    {{#if additionalBuyerQuestions.length}}
    <div style="margin: 0 0 16px;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 8px;"><tr>
        <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; white-space: nowrap; padding-right: 12px;">{{labels.donationReceivedOrganizationQuestionsHeading}}</td>
        <td width="100%" style="vertical-align: middle;"><table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr><td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{theme.dividerNeutral}}; border-radius: 10px;">&nbsp;</td></tr></table></td>
      </tr></table>
      {{#each additionalBuyerQuestions}}
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../theme.bodyText}}; word-break: break-word;"><strong>{{question}}</strong><br />{{answer}}</p>
      {{/each}}
    </div>
    {{/if}}
    {{#if viewPaymentLink}}
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.donationReceivedOrganizationViewPaymentButton (label path), viewPaymentLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{viewPaymentLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.donationReceivedOrganizationViewPaymentButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{viewPaymentLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.donationReceivedOrganizationViewPaymentButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.donationReceivedOrganizationDashboardNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.donationReceivedOrganizationDashboardNote}}</p></div>
    {{/if}}
    {{#if formattedSavedAmount}}
    <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.donationReceivedOrganizationSavedPrefix}} <strong style="color: {{theme.headerText}};">{{formattedSavedAmount}}</strong>{{labels.donationReceivedOrganizationSavedSuffix}}
    </p>
    {{/if}}
    {{#if transactionNumber}}
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.donationReceivedOrganizationTransactionNumberPrefix}} <strong style="color: {{theme.headerText}};">{{transactionNumber}}</strong> {{labels.donationReceivedOrganizationTransactionNumberSuffix}}
    </p>
    {{/if}}
    <div style="margin: 0 0 8px;"><!-- Organization-facing / Text (body paragraph). Param: labels.paymentNotificationMobileAppPrompt (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.paymentNotificationMobileAppPrompt}}</p></div>
    <div style="margin: 0;"><!-- Organization-facing / Zeffy app store badges (Google Play + App Store images, side by side).
     Reads appStoreUrl, playStoreUrl, isPreview and labels from context. The badge CIDs are owned by this
     partial: the transactional service ships the matching inline PNGs and previews swap them to data URIs.
     labels.storeBadgeLocale picks the official badge language (en, fr, de); the App Store badge width varies by language. -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="padding: 0 8px 0 0;">
    <a {{#unless isPreview}}href="{{playStoreUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
      <img src="cid:img-google-play-badge-{{labels.storeBadgeLocale}}" width="108" height="32" alt="{{labels.googlePlayButton}}" style="display: block; border: 0; width: 108px; height: 32px;" />
    </a>
  </td>
  <td>
    <a {{#unless isPreview}}href="{{appStoreUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
      <img src="cid:img-app-store-badge-{{labels.storeBadgeLocale}}" width="{{labels.appStoreBadgeWidth}}" height="32" alt="{{labels.appStoreButton}}" style="display: block; border: 0; width: {{labels.appStoreBadgeWidth}}px; height: 32px;" />
    </a>
  </td>
</tr></table></div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_SUPPORT_SERVER_ERROR = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.supportServerErrorPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.supportServerErrorSubtitle, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.supportServerErrorSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.supportServerErrorSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.supportServerErrorSubtitle}}</p></div>
  {{/if}}
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.supportServerErrorTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.supportServerErrorTitle}}</p></div>
    <div class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{{alertMessageHtml}}}</div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_INDIVIDUAL_FUNDRAISING_OUTREACH = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.individualFundraisingOutreachPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.individualFundraisingOutreachIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.individualFundraisingOutreachIntro}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.individualFundraisingOutreachHowItWorks (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.individualFundraisingOutreachHowItWorks}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.individualFundraisingOutreachNextSteps (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.individualFundraisingOutreachNextSteps}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.individualFundraisingOutreachThanks (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.individualFundraisingOutreachThanks}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.individualFundraisingOutreachClosing}}<br />{{labels.individualFundraisingOutreachSignature}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_CARD_PAYMENT_CAPABILITY_BLOCKED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.cardPaymentCapabilityBlockedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    {{!-- Same rendering as org-header — inlined because the heading interpolates {{formName}}, which
         the partial's single false label param can't express. --}}
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.cardPaymentCapabilityBlockedIntroPrefix}}{{formName}}{{labels.cardPaymentCapabilityBlockedIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.cardPaymentCapabilityBlockedDeclined (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional orgName + labels.cardPaymentCapabilityBlockedDeclinedSuffix name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.cardPaymentCapabilityBlockedDeclined}}{{#if orgName}}<strong style="font-weight: 700;">{{orgName}}</strong>{{labels.cardPaymentCapabilityBlockedDeclinedSuffix}}{{/if}}</p></div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.cardPaymentCapabilityBlockedResolve}}</p>
    </div>
    <ul style="margin: 0 0 16px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.cardPaymentCapabilityBlockedStep1}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.cardPaymentCapabilityBlockedStep2}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.cardPaymentCapabilityBlockedStep3}}</li>
    </ul>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.cardPaymentCapabilityBlockedHelpPrefix}}<a href="mailto:support@zeffy.com" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">support@zeffy.com</a>{{labels.cardPaymentCapabilityBlockedHelpSuffix}}</p>
    </div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.bestRegards (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.bestRegards}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_REFUND_REQUEST = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.refundRequestPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.refundRequestSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.refundRequestSubtitle}}</p></div>
    <div style="margin: 0 0 24px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{donorName}}{{labels.refundRequestTitleSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.refundRequestGreeting (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.refundRequestGreeting}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{donorName}}{{labels.refundRequestIntroSuffix}}</p>
    </div>
    <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 16px; border-collapse: separate;"><tr>
      <td style="padding: 16px; background-color: {{theme.dividerBrand}}; border: 1px solid {{theme.dividerNeutral}}; border-radius: 8px;">
        {{#if formTitle}}
        <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><strong style="font-weight: 700; color: {{theme.headerText}};">{{labels.refundRequestFormLabel}}</strong> {{formTitle}}</p>
        {{/if}}
        <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><strong style="font-weight: 700; color: {{theme.headerText}};">{{labels.refundRequestDateLabel}}</strong> {{paymentDate}}</p>
        <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><strong style="font-weight: 700; color: {{theme.headerText}};">{{labels.refundRequestAmountLabel}}</strong> {{amount}}</p>
        <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><strong style="font-weight: 700; color: {{theme.headerText}};">{{labels.refundRequestReasonLabel}}</strong> {{reason}}</p>
        {{#if donorMessage}}
        <p class="mfs12" style="margin: 16px 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.refundRequestMessageLabel}}</p>
        <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word; white-space: pre-wrap;">{{donorMessage}}</p>
        {{/if}}
      </td>
    </tr></table>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.refundRequestDecision (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.refundRequestDecision}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.refundRequestViewPaymentButton (label path), paymentUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{paymentUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.refundRequestViewPaymentButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{paymentUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.refundRequestViewPaymentButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.refundRequestReplyHintPrefix}}{{donorName}}{{labels.refundRequestReplyHintSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.refundRequestExpiryPrefix}}{{expiryInDays}}{{labels.refundRequestExpirySuffix}}</p>
    </div>
    <div><!-- Organization-facing / Text (body paragraph). Param: labels.zeffyTeam (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p></div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_SCHEDULED_EMAIL_CONFIRMATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.scheduledEmailConfirmationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.scheduledEmailConfirmationTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.scheduledEmailConfirmationTitle}}</p></div>
    {{#if sentEmailSubject}}
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;"><strong style="font-weight: 700;">{{labels.scheduledEmailConfirmationSubjectLabel}}</strong> {{sentEmailSubject}}</p>
    </div>
    {{/if}}
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.scheduledEmailConfirmationSentPrefix}}{{numberRecipients}}{{labels.scheduledEmailConfirmationSentMiddle}}{{emailSentDateTime}}{{labels.scheduledEmailConfirmationSentSuffix}}</p>
    </div>
    <div style="margin: 0 0 8px;"><!-- Organization-facing / Text (body paragraph). Param: labels.scheduledEmailConfirmationMetricsIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.scheduledEmailConfirmationMetricsIntro}}</p></div>
    <ul style="margin: 0 0 16px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.scheduledEmailConfirmationMetricOpenRate}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.scheduledEmailConfirmationMetricClickRate}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.scheduledEmailConfirmationMetricFailedEmails}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.scheduledEmailConfirmationMetricMore}}</li>
    </ul>
    <div style="margin: 0;"><!-- Organization-facing / Button. Params: labels.scheduledEmailConfirmationViewButton (label path), emailLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{emailLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.scheduledEmailConfirmationViewButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{emailLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.scheduledEmailConfirmationViewButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_SATISFACTION_SURVEY = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.satisfactionSurveyPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.satisfactionSurveyIntroPrefix}} {{campaignTypePlural}} {{labels.satisfactionSurveyIntroSuffix}}
    </p>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.satisfactionSurveyYour}} {{campaignType}} <strong style="color: {{theme.headerText}};">{{campaignTitle}}</strong>
      {{#if hasActiveOccurrence}}{{labels.satisfactionSurveyJustEnded}}{{else}}{{labels.satisfactionSurveyStillRunning}}{{/if}}
      {{labels.satisfactionSurveyCurious}}
    </p>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.satisfactionSurveyFormIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.satisfactionSurveyFormIntro}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.satisfactionSurveyButton (label path), surveyLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{surveyLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.satisfactionSurveyButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{surveyLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.satisfactionSurveyButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.satisfactionSurveyFeedbackShapes (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.satisfactionSurveyFeedbackShapes}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.satisfactionSurveyThanks (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.satisfactionSurveyThanks}}</p></div>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.satisfactionSurveySignature}}</p>
    <div><!-- Organization-facing / Text (body paragraph). Param: labels.satisfactionSurveyPostScript (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.satisfactionSurveyPostScript}}</p></div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_WEEKLY_VISITOR_REPORT = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.weeklyVisitorReportPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  {{!-- Same rendering as org-banner-header — inlined because both lines interpolate variables
       (reportDate / firstName / orgName), which the partial's label params can't express. --}}
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.brandFilledBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td class="mobile-pad-banner" style="padding: 24px;">
    <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bannerAccentText}}; word-break: break-word;">{{reportDate}}</p>
    <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.bannerTitleText}}; word-break: break-word;">👋 {{labels.hi}} {{firstName}}, {{labels.weeklyVisitorReportTitlePrefix}} {{orgName}} {{labels.weeklyVisitorReportTitleSuffix}}</p>
  </td></tr></table>
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     true (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    {{#if oneTimeSupporters.length}}
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.weeklyVisitorReportOneTimeHeading}}</p>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#each oneTimeSupporters}}
        <tr>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../theme.bodyText}}; padding: 3px 8px 3px 0; vertical-align: baseline; word-break: break-word;">{{name}}</td>
          <td align="right" class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{../theme.headerText}}; padding: 3px 0; vertical-align: baseline; white-space: nowrap;">{{volume}}</td>
        </tr>
        {{/each}}
      </table>
      {{#if moreOneTimeSupportersCount}}
      <p class="mfs12" style="margin: 8px 0 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.visitorReportAndMorePrefix}}{{moreOneTimeSupportersCount}}{{labels.visitorReportAndMoreSuffix}}</p>
      {{/if}}
    </div>
    {{/if}}
    {{#if recurringSupporters.length}}
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.weeklyVisitorReportRecurringHeading}}</p>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#each recurringSupporters}}
        <tr>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../theme.bodyText}}; padding: 3px 8px 3px 0; vertical-align: baseline; word-break: break-word;">{{name}}</td>
          <td align="right" class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{../theme.headerText}}; padding: 3px 0; vertical-align: baseline; white-space: nowrap;">{{volume}}</td>
        </tr>
        {{/each}}
      </table>
      {{#if moreRecurringSupportersCount}}
      <p class="mfs12" style="margin: 8px 0 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.visitorReportAndMorePrefix}}{{moreRecurringSupportersCount}}{{labels.visitorReportAndMoreSuffix}}</p>
      {{/if}}
    </div>
    {{/if}}
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.weeklyVisitorReportCongratsPrefix}} <a {{#unless isPreview}}href="{{dashboardLink}}" target="_blank" {{/unless}}style="color: {{theme.link}}; text-decoration: underline;">{{labels.weeklyVisitorReportDashboardLink}}</a>{{labels.weeklyVisitorReportCongratsSuffix}}
    </p>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.weeklyVisitorReportThankButton (label path), thankYouEmailLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{thankYouEmailLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.weeklyVisitorReportThankButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{thankYouEmailLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.weeklyVisitorReportThankButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    {{#if organizationPageUrl}}
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.weeklyVisitorReportOrgPagePrefix}} <strong style="font-weight: 700; color: {{theme.headerText}};">{{labels.weeklyVisitorReportOrgPagePaymentCount}}</strong> {{labels.weeklyVisitorReportOrgPageMiddle}} <!-- Organization-facing / Link. Params: labels.weeklyVisitorReportOrgPageLink (label path), organizationPageUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{organizationPageUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.weeklyVisitorReportOrgPageLink}}</a>{{labels.weeklyVisitorReportOrgPageSuffix}}
    </p>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.weeklyVisitorReportOrgPageButton (label path), organizationPageEditorLink (path), true (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{organizationPageEditorLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.outlineBg}}" strokecolor="{{theme.outlineBorder}}"><w:anchorlock/><center style="color:{{theme.outlineText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.weeklyVisitorReportOrgPageButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{organizationPageEditorLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.outlineBg}}; border: 0.75px solid {{theme.outlineBorder}}; color: {{theme.outlineText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.weeklyVisitorReportOrgPageButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    {{/if}}
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.recurringReportAddUsersPrefix}} <!-- Organization-facing / Link. Params: labels.recurringReportAddUsersLink (label path), addUserLink (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{addUserLink}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.recurringReportAddUsersLink}}</a> {{labels.recurringReportAddUsersSuffix}}
    </p>
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.recurringReportMissingInfoPrefix}} <!-- Organization-facing / Link. Params: labels.recurringReportMissingInfoLink (label path), letUsKnowLink (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{letUsKnowLink}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.recurringReportMissingInfoLink}}</a>
    </p>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.weeklyVisitorReportUnsubscribePrompt}} <a {{#unless isPreview}}href="{{unsubscribeLink}}" target="_blank" {{/unless}}style="color: {{theme.link}}; text-decoration: underline;">{{labels.footerUnsubscribeLink}}</a>
    </p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_REFERRAL_DURING_SIGN_UP = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.referralDuringSignUpPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralDuringSignUpIntroPrefix}}<strong style="color: {{theme.headerText}};">{{orgName}}</strong>{{labels.referralDuringSignUpIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.referralDuringSignUpPersonalThanks (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralDuringSignUpPersonalThanks}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.referralSharing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralSharing}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.referralThankYouEverything (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralThankYouEverything}}</p></div>
    <div style="margin: 0 0 4px;"><!-- Organization-facing / Text (body paragraph). Param: labels.allTheBest (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralCeoName}}</p>
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralCeoTitle}}</p>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.referralCtaPrefix}}{{referralAmount}}{{labels.referralCtaSuffix}}</p>
    </div>
    <div style="margin: 0;"><!-- Organization-facing / Button. Params: labels.referralCtaLink (label path), referralLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{referralLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.referralCtaLink}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{referralLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.referralCtaLink}}</a>
  <!--<![endif]-->
</td></tr></table></div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_ORDER_RECEIVED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.orderReceivedOrganizationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    {{!-- Same rendering as org-subtitle — inlined because it interpolates formTitle + eventStartDate. --}}
    <div style="margin: 0 0 4px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{formTitle}}{{#if eventStartDate}} – {{eventStartDate}}{{#if eventEndDate}} – {{eventEndDate}}{{/if}}{{/if}}</p>
    </div>
    <p class="mfs24" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">
      {{#if isFreeOrder}}{{labels.orderReceivedOrganizationTitleFree}}{{else}}{{labels.orderReceivedOrganizationTitlePrefix}} {{amount}}{{labels.orderReceivedOrganizationTitleSuffix}}{{/if}}
    </p>
    {{#if (and isPadOrAch (eq currency "usd"))}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.donationReceivedOrganizationAchNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.donationReceivedOrganizationAchNote}}</p></div>
    {{/if}}
    {{#if (and isPadOrAch (eq currency "cad"))}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.donationReceivedOrganizationPadNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.donationReceivedOrganizationPadNote}}</p></div>
    {{/if}}
    {{#if (and isPadOrAch (eq currency "eur"))}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.donationReceivedOrganizationSepaNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.donationReceivedOrganizationSepaNote}}</p></div>
    {{/if}}
    <div style="margin: 0 0 16px;">
      {{#if buyerName}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{buyerName}}</p>
      {{/if}}
      {{#if buyerEmail}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{buyerEmail}}</p>
      {{/if}}
      {{#if address}}
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{address}}</p>
      {{/if}}
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.orderReceivedOrganizationPaymentMethod}} {{paymentMethod}}</p>
    </div>
    {{#if fundName}}
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.donationReceivedOrganizationFundLabel}} {{fundName}}
    </p>
    {{/if}}
    {{!-- Section heading with an inline hairline rule, vertically centered beside the text — the
         nested-table hairline mirrors org-divider so it survives Outlook's Word renderer. --}}
    {{#if isShop}}
    {{#if purchasedProducts.length}}
    <div style="margin: 0 0 16px;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 8px;"><tr>
        <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; white-space: nowrap; padding-right: 12px;">{{labels.orderReceivedOrganizationOrderSummaryHeading}}</td>
        <td width="100%" style="vertical-align: middle;"><table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr><td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{theme.dividerNeutral}}; border-radius: 10px;">&nbsp;</td></tr></table></td>
      </tr></table>
      {{#each purchasedProducts}}
      <div style="margin: 0 0 12px;">
        <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{../theme.headerText}}; word-break: break-word;">{{rateQuantity}}x {{rateName}} ({{ratePrice}})</p>
        {{#each variants}}
        <p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../../theme.bodyText}}; word-break: break-word;">{{name}}: {{value}}</p>
        {{/each}}
        {{#each answers}}
        <p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../../theme.bodyText}}; word-break: break-word;">{{question}}: {{answer}}</p>
        {{/each}}
      </div>
      {{/each}}
    </div>
    {{/if}}
    {{else}}
    {{#if participants.length}}
    <div style="margin: 0 0 16px;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 8px;"><tr>
        <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; white-space: nowrap; padding-right: 12px;">{{labels.orderReceivedOrganizationOrderSummaryHeading}}</td>
        <td width="100%" style="vertical-align: middle;"><table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr><td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{theme.dividerNeutral}}; border-radius: 10px;">&nbsp;</td></tr></table></td>
      </tr></table>
      {{#each participants}}
      <div style="margin: 0 0 12px;">
        <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{../theme.headerText}}; word-break: break-word;">{{#if ../isSweepstakes}}{{../labels.orderReceivedOrganizationSweepstakesEntry}}{{else if ../isRaffle}}{{../labels.orderReceivedOrganizationRaffleTicket}}{{else}}{{../labels.orderReceivedOrganizationParticipant}}{{/if}} {{increment @index}}: {{ticketName}} / {{ticketPrice}}</p>
        {{#each answers}}
        <p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../../theme.bodyText}}; word-break: break-word;">{{question}}: {{answer}}</p>
        {{/each}}
      </div>
      {{/each}}
    </div>
    {{/if}}
    {{#if addOns.length}}
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.orderReceivedOrganizationAddOnsHeading}}</p>
      {{#each addOns}}
      <p class="mfs12" style="margin: 0 0 2px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../theme.bodyText}}; word-break: break-word;">{{rateQuantity}}x {{rateName}} ({{ratePrice}})</p>
      {{/each}}
    </div>
    {{/if}}
    {{/if}}
    {{#if additionalBuyerQuestions.length}}
    <div style="margin: 0 0 16px;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 8px;"><tr>
        <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; white-space: nowrap; padding-right: 12px;">{{labels.donationReceivedOrganizationQuestionsHeading}}</td>
        <td width="100%" style="vertical-align: middle;"><table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr><td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{theme.dividerNeutral}}; border-radius: 10px;">&nbsp;</td></tr></table></td>
      </tr></table>
      {{#each additionalBuyerQuestions}}
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{../theme.bodyText}}; word-break: break-word;"><strong>{{question}}</strong><br />{{answer}}</p>
      {{/each}}
    </div>
    {{/if}}
    {{#if extraDonation}}
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.orderReceivedOrganizationExtraDonationPrefix}} {{extraDonation}}</p>
    {{/if}}
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.donationReceivedOrganizationViewPaymentButton (label path), viewPaymentLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{viewPaymentLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.donationReceivedOrganizationViewPaymentButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{viewPaymentLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.donationReceivedOrganizationViewPaymentButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.donationReceivedOrganizationDashboardNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.donationReceivedOrganizationDashboardNote}}</p></div>
    {{#if showSavedAmount}}
    <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.donationReceivedOrganizationSavedPrefix}} <strong style="color: {{theme.headerText}};">{{formattedSavedAmount}}</strong>{{labels.donationReceivedOrganizationSavedSuffix}}
    </p>
    {{/if}}
    {{#if transactionNumber}}
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.donationReceivedOrganizationTransactionNumberPrefix}} <strong style="color: {{theme.headerText}};">{{transactionNumber}}</strong> {{labels.donationReceivedOrganizationTransactionNumberSuffix}}
    </p>
    {{/if}}
    <div style="margin: 0 0 8px;"><!-- Organization-facing / Text (body paragraph). Param: labels.paymentNotificationMobileAppPrompt (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.paymentNotificationMobileAppPrompt}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Zeffy app store badges (Google Play + App Store images, side by side).
     Reads appStoreUrl, playStoreUrl, isPreview and labels from context. The badge CIDs are owned by this
     partial: the transactional service ships the matching inline PNGs and previews swap them to data URIs.
     labels.storeBadgeLocale picks the official badge language (en, fr, de); the App Store badge width varies by language. -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="padding: 0 8px 0 0;">
    <a {{#unless isPreview}}href="{{playStoreUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
      <img src="cid:img-google-play-badge-{{labels.storeBadgeLocale}}" width="108" height="32" alt="{{labels.googlePlayButton}}" style="display: block; border: 0; width: 108px; height: 32px;" />
    </a>
  </td>
  <td>
    <a {{#unless isPreview}}href="{{appStoreUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
      <img src="cid:img-app-store-badge-{{labels.storeBadgeLocale}}" width="{{labels.appStoreBadgeWidth}}" height="32" alt="{{labels.appStoreButton}}" style="display: block; border: 0; width: {{labels.appStoreBadgeWidth}}px; height: 32px;" />
    </a>
  </td>
</tr></table></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.orderReceivedOrganizationMissingInfoPrefix}} <a {{#unless isPreview}}href="{{labels.orderReceivedOrganizationMissingInfoUrl}}" target="_blank" {{/unless}}style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.orderReceivedOrganizationMissingInfoLink}}</a>
    </p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_DESKTOP_COMPLETION_SUGGESTION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.desktopCompletionPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.desktopCompletionIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.desktopCompletionIntro}}</p></div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.desktopCompletionWhyHeading}}</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12 emoji-inline" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">⚡ <strong style="color: {{theme.headerText}};">{{labels.desktopCompletionFasterTitle}}</strong> {{labels.desktopCompletionFasterBody}}</p>
      <p class="mfs12 emoji-inline" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">🧰 <strong style="color: {{theme.headerText}};">{{labels.desktopCompletionFeaturesTitle}}</strong> {{labels.desktopCompletionFeaturesBody}}</p>
      <p class="mfs12 emoji-inline" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">🧭 <strong style="color: {{theme.headerText}};">{{labels.desktopCompletionNavigationTitle}}</strong> {{labels.desktopCompletionNavigationBody}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.desktopCompletionButton (label path), formEditLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{formEditLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.desktopCompletionButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{formEditLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.desktopCompletionButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.desktopCompletionHelpHeading}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.desktopCompletionHelpBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.desktopCompletionHelpBody}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.desktopCompletionClosing}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_REFERRAL_FIRST_REFEREE_TRANSACTION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.referralFirstRefereeTransactionPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Subtitle. Param: labels.referralFirstRefereeTransactionTitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.referralFirstRefereeTransactionTitle}}</p></div>
    {{!-- Same rendering as org-header — inlined because the heading interpolates {{amount}},
         which the partial's single false label param can't express. --}}
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.referralFirstRefereeTransactionCongratsPrefix}}{{amount}}{{labels.referralFirstRefereeTransactionCongratsSuffix}}</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.referralFirstRefereeTransactionBodyPrefix}}{{referralAmount}}{{labels.referralFirstRefereeTransactionBodySuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 8px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.referralCtaPrefix}}{{referralAmount}}{{labels.referralCtaSuffix}}</p>
    </div>
    <div style="margin: 0;"><!-- Organization-facing / Button. Params: labels.referralCtaLink (label path), referralLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{referralLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.referralCtaLink}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{referralLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.referralCtaLink}}</a>
  <!--<![endif]-->
</td></tr></table></div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_ISSUING_EXPENSE_FAILED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.issuingExpenseFailedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: labels.treasuryOopsSubtitle, labels.issuingExpenseFailedTitle (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  {{#if labels.treasuryOopsSubtitle}}
  <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.treasuryOopsSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.treasuryOopsSubtitle}}</p></div>
  {{/if}}
  {{#if labels.issuingExpenseFailedTitle}}
  <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.issuingExpenseFailedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.issuingExpenseFailedTitle}}</p></div>
  {{/if}}
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Account line. Params: labels.organizationAccountLabel (labels.organizationAccountLabel), orgName. -->
<!-- Financial notifications name the nonprofit they are about: recipients often administer several. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationAccountLabel}} <strong style="font-weight: 700;">{{orgName}}</strong></p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.issuingExpenseFailedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingExpenseFailedIntro}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.issuingExpenseFailedInfo (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.issuingExpenseFailedInfo}}</p></div>
    <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.treasuryRaiseMoreHeading}}</p>
    <ul style="margin: 0; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMorePeerToPeer}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreRaffle}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreEvent}}</li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreShop}}</li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">{{labels.treasuryRaiseMoreAndMore}}</li>
    </ul>
    <div style="margin: 24px 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs10_5" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.treasuryCelticBankDisclaimer}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_AUCTION_CREATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderAuctionCreated}} {{formTitle}}.
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing composition: container → single body → org-* components. -->
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.auctionCreatedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.auctionCreatedTitle}}</p></div>
{{#unless showBankAccountNote}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.auctionCreatedShareIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.auctionCreatedShareIntro}}</p></div>
    {{/unless}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Button. Params: labels.viewMyForm (label path), formUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{formUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.viewMyForm}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{formUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.viewMyForm}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <p class="mfs12" style="margin: 0 0 12px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.auctionCreatedEditPrefix}} <!-- Organization-facing / Link. Params: labels.auctionCreatedEditLink (label path), editUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{editUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.auctionCreatedEditLink}}</a>{{labels.auctionCreatedEditSuffix}}
    </p>
    {{#if showBankAccountNote}}
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.auctionCreatedBankPrefix}} <!-- Organization-facing / Link. Params: labels.auctionCreatedBankLink (label path), bankAccountUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{bankAccountUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.auctionCreatedBankLink}}</a>{{labels.auctionCreatedBankSuffix}}
    </p>
    {{/if}}
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.auctionCreatedTipsHeading}}</p>
    </div>
    <ul style="margin: 0 0 24px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.auctionCreatedTipTrackBidders}}
      </li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.auctionCreatedTipTrackItems}}
      </li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.auctionCreatedTipMonitorRaised}}
      </li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.auctionCreatedTipNotification}}
      </li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.auctionCreatedTipAutoPayment}}
      </li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.auctionCreatedTipEmailBidders}}
      </li>
    </ul>
    <p class="mfs12" style="margin: 0 0 12px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.auctionCreatedGuidePrefix}} <!-- Organization-facing / Link. Params: labels.auctionCreatedGuideLink (label path), labels.auctionCreatedGuideUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.auctionCreatedGuideUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.auctionCreatedGuideLink}}</a>{{labels.auctionCreatedGuideSuffix}}
    </p>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.auctionCreatedSupport (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.auctionCreatedSupport}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_ORG_PAGE_CONTACT_MESSAGE = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.orgPageContactMessagePreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 4px;"><!-- Organization-facing / Subtitle. Param: labels.orgPageContactMessageSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.orgPageContactMessageSubtitle}}</p></div>
    <div style="margin: 0 0 24px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.orgPageContactMessageTitlePrefix}} {{orgName}} {{labels.orgPageContactMessageTitleSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.orgPageContactMessageGreeting (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.orgPageContactMessageGreeting}}</p></div>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.orgPageContactMessageIntroPrefix}} <!-- Organization-facing / Link. Params: labels.orgPageContactMessageIntroLink (label path), organizationPageUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{organizationPageUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.orgPageContactMessageIntroLink}}</a>{{labels.orgPageContactMessageIntroSuffix}}
    </p>
    <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 16px; border-collapse: separate;"><tr>
      <td style="padding: 16px; background-color: {{theme.dividerBrand}}; border: 1px solid {{theme.dividerNeutral}}; border-radius: 8px;">
        <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.orgPageContactMessageFrom}} {{senderEmail}}</p>
        <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word; white-space: pre-wrap;">{{visitorMessage}}</p>
      </td>
    </tr></table>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.orgPageContactMessageReplyHint (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.orgPageContactMessageReplyHint}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <p class="mfs12" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.orgPageContactMessageRecipientPrefix}} {{contactEmailAddress}}{{labels.orgPageContactMessageRecipientMiddle}} <!-- Organization-facing / Link. Params: labels.orgPageContactMessageRecipientLink (label path), contactEmailSettingsUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{contactEmailSettingsUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.orgPageContactMessageRecipientLink}}</a> {{labels.orgPageContactMessageRecipientSuffix}} {{labels.orgPageContactMessageRecipientLoginNote}}
    </p>
    <div style="margin: 0 0 4px;"><!-- Organization-facing / Text (body paragraph). Param: labels.organizationPageCreatedHappyFundraising (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationPageCreatedHappyFundraising}}</p></div>
    <div><!-- Organization-facing / Text (body paragraph). Param: labels.zeffyTeam (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p></div>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_EXPORT_COMPLETED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.exportCompletedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.exportCompletedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.exportCompletedIntro}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.exportCompletedButton (label path), url (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{url}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.exportCompletedButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{url}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.exportCompletedButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.exportCompletedQuestions (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.exportCompletedQuestions}}</p></div>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.allTheBest (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.ORGANIZATION_TICKETING_CREATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderTicketingCreated}} {{formTitle}}.
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing composition: container → single body → org-* components. -->
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    {{#if (eq formCategory "Shop")}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.storeCreatedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.storeCreatedTitle}}</p></div>
    {{else if (eq formCategory "MembershipV2")}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.membershipCreatedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.membershipCreatedTitle}}</p></div>
    {{else if (eq formCategory "Lottery")}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.raffleCreatedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.raffleCreatedTitle}}</p></div>
    {{else if (eq formCategory "Sweepstakes")}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.sweepstakesCreatedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.sweepstakesCreatedTitle}}</p></div>
    {{else if (eq formCategory "Custom")}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.customCreatedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.customCreatedTitle}}</p></div>
    {{else}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.ticketingCreatedTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.ticketingCreatedTitle}}</p></div>
    {{/if}}
{{#unless showBankAccountNote}}
    {{#if (eq formCategory "MembershipV2")}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.membershipCreatedShareIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.membershipCreatedShareIntro}}</p></div>
    {{else if (eq formCategory "Lottery")}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.raffleCreatedShareIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.raffleCreatedShareIntro}}</p></div>
    {{else if (eq formCategory "Sweepstakes")}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.sweepstakesCreatedShareIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.sweepstakesCreatedShareIntro}}</p></div>
    {{else}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.ticketingCreatedShareIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.ticketingCreatedShareIntro}}</p></div>
    {{/if}}
    {{/unless}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Button. Params: labels.viewMyForm (label path), formUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{formUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.viewMyForm}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{formUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.viewMyForm}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    {{#if showBankAccountNote}}
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.bankAccountReminderPrefix}} <!-- Organization-facing / Link. Params: labels.bankAccountReminderLink (label path), bankAccountUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{bankAccountUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.bankAccountReminderLink}}</a>{{labels.bankAccountReminderSuffix}}
    </p>
    {{/if}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Divider. Optional param: false ("Neutral", the default, or "Brand").
     Table-based hairline (not a <div>) so the 1px height survives Outlook's Word rendering engine. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{#if (eq false "Brand")}}{{theme.dividerBrand}}{{else}}{{theme.dividerNeutral}}{{/if}}; border-radius: 10px;">&nbsp;</td>
</tr></table></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.ticketingCreatedTipsHeading}}</p>
    </div>
    <ul style="margin: 0 0 16px; padding-left: 20px;">
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{#if (eq formCategory "MembershipV2")}}
        {{labels.tipManualPaymentPrefixMembership}} <!-- Organization-facing / Link. Params: labels.tipManualPaymentLinkMembership (label path), labels.tipManualPaymentUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipManualPaymentUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipManualPaymentLinkMembership}}</a>
        {{else if (eq formCategory "Shop")}}
        {{labels.tipManualPaymentPrefixShop}} <!-- Organization-facing / Link. Params: labels.tipManualPaymentLinkShop (label path), labels.tipManualPaymentUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipManualPaymentUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipManualPaymentLinkShop}}</a>
        {{else}}
        {{labels.tipManualPaymentPrefix}} <!-- Organization-facing / Link. Params: labels.tipManualPaymentLink (label path), labels.tipManualPaymentUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipManualPaymentUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipManualPaymentLink}}</a>
        {{/if}}
        {{labels.tipManualPaymentSuffix}}
      </li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.tipNotificationEmail}}
      </li>
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.tipEmailParticipantsPrefix}}
        {{#if (eq formCategory "MembershipV2")}}<!-- Organization-facing / Link. Params: labels.tipEmailParticipantsLinkMembership (label path), labels.tipEmailParticipantsUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipEmailParticipantsUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipEmailParticipantsLinkMembership}}</a>
        {{else if (eq formCategory "Shop")}}<!-- Organization-facing / Link. Params: labels.tipEmailParticipantsLinkShop (label path), labels.tipEmailParticipantsUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipEmailParticipantsUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipEmailParticipantsLinkShop}}</a>
        {{else}}<!-- Organization-facing / Link. Params: labels.tipEmailParticipantsLink (label path), labels.tipEmailParticipantsUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipEmailParticipantsUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipEmailParticipantsLink}}</a>
        {{/if}}
        {{labels.tipEmailParticipantsSuffix}}
      </li>
      {{!-- Check-in / admissions only exists for Event and Custom forms (no scannable-ticket check-in
           for Membership/Lottery/Shop) — omitted entirely rather than shown with adapted copy. --}}
      {{#if (or (eq formCategory "Event") (eq formCategory "Custom"))}}
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.tipManageAdmissionsPrefix}} <!-- Organization-facing / Link. Params: labels.tipManageAdmissionsLink (label path), labels.tipManageAdmissionsUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipManageAdmissionsUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipManageAdmissionsLink}}</a> {{labels.tipManageAdmissionsSuffix}}
      </li>
      {{/if}}
      {{!-- Shop purchases never generate an e-ticket (no e-ticket editor step) — omitted for Shop.
           Membership resends a "membership card" rather than an "e-ticket". --}}
      {{#unless (eq formCategory "Shop")}}
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.tipResendTicketPrefix}}
        {{#if (eq formCategory "MembershipV2")}}
        <!-- Organization-facing / Link. Params: labels.tipResendTicketLinkMembership (label path), labels.tipResendTicketUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipResendTicketUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipResendTicketLinkMembership}}</a> {{labels.tipResendTicketSuffixMembership}}
        {{else if (eq formCategory "Sweepstakes")}}
        <!-- Organization-facing / Link. Params: labels.tipResendTicketLinkSweepstakes (label path), labels.tipResendTicketUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipResendTicketUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipResendTicketLinkSweepstakes}}</a> {{labels.tipResendTicketSuffix}}
        {{else}}
        <!-- Organization-facing / Link. Params: labels.tipResendTicketLink (label path), labels.tipResendTicketUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipResendTicketUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipResendTicketLink}}</a> {{labels.tipResendTicketSuffix}}
        {{/if}}
      </li>
      {{/unless}}
      <li class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.tipTrackVisitors}}
      </li>
      <li class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}};">
        {{labels.tipRefundCancelPrefix}}
        {{#if (eq formCategory "Shop")}}<!-- Organization-facing / Link. Params: labels.tipRefundCancelLinkShop (label path), labels.tipRefundCancelUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipRefundCancelUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipRefundCancelLinkShop}}</a>
        {{else if (eq formCategory "Sweepstakes")}}<!-- Organization-facing / Link. Params: labels.tipRefundCancelLinkSweepstakes (label path), labels.tipRefundCancelUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipRefundCancelUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipRefundCancelLinkSweepstakes}}</a>
        {{else}}<!-- Organization-facing / Link. Params: labels.tipRefundCancelLink (label path), labels.tipRefundCancelUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.tipRefundCancelUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.tipRefundCancelLink}}</a>
        {{/if}}
        {{labels.tipRefundCancelSuffix}}
      </li>
    </ul>
    <p class="mfs12" style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">
      {{labels.ticketingCreatedHelpCenterPrefix}} <!-- Organization-facing / Link. Params: labels.ticketingCreatedHelpCenterLink (label path), labels.ticketingCreatedHelpCenterUrl (path), isPreview (bool). Desktop 14.5px · mobile 12px (.mfs12). -->
<a {{#unless isPreview}}href="{{labels.ticketingCreatedHelpCenterUrl}}" target="_blank" {{/unless}}class="mfs12 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.link}}; text-decoration: underline; word-break: break-word;">{{labels.ticketingCreatedHelpCenterLink}}</a>{{labels.ticketingCreatedHelpCenterSuffix}}
    </p>
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Text (body paragraph). Param: labels.ticketingCreatedClosing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.ticketingCreatedClosing}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.SUBSCRIPTION_AMOUNT_UPDATED_DONOR = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.subscriptionUpdatedDonorPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}} {{lastName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.subscriptionUpdatedDonorTitlePrefix}} {{orgName}} {{labels.subscriptionUpdatedDonorTitleSuffix}}
  </h1>
</td></tr>

<!-- ========== 4. CONFIRMATION ========== -->
<tr data-section="confirmation"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.subscriptionAmountUpdatedDonorIntroPrefix}} {{orgName}} {{labels.subscriptionAmountUpdatedDonorIntroFrom}}
    <strong style="color: {{theme.tIntense}};">{{previousAmount}}</strong> {{labels.subscriptionAmountUpdatedDonorIntroTo}}
    <strong style="color: {{theme.tIntense}};">{{newAmount}}</strong>{{labels.subscriptionAmountUpdatedDonorIntroSuffix}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.subscriptionAmountUpdatedDonorAccountPrefix}}
    <a {{#unless isPreview}}href="{{accountLink}}" target="_blank" {{/unless}}class="account-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.subscriptionDonorAccountLink}}</a>{{labels.subscriptionDonorAccountSuffix}}
  </p>
</td></tr>

<!-- ========== 5. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.allTheBest}}<br />{{labels.zeffyTeam}}
  </p>
</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.SUBSCRIPTION_PAYMENT_METHOD_UPDATED_DONOR = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.subscriptionPaymentMethodUpdatedDonorPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}} {{lastName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.subscriptionPaymentMethodUpdatedDonorTitlePrefix}} {{orgName}} {{labels.subscriptionPaymentMethodUpdatedDonorTitleSuffix}}
  </h1>
</td></tr>

<!-- ========== 4. CONFIRMATION ========== -->
<tr data-section="confirmation"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.subscriptionPaymentMethodUpdatedDonorIntroPrefix}} {{orgName}} {{labels.subscriptionPaymentMethodUpdatedDonorIntroSuffix}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.subscriptionPaymentMethodUpdatedDonorAccountPrefix}}
    <a {{#unless isPreview}}href="{{accountLink}}" target="_blank" {{/unless}}class="account-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.subscriptionDonorAccountLink}}</a>{{labels.subscriptionDonorAccountSuffix}}
  </p>
</td></tr>

<!-- ========== 5. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.allTheBest}}<br />{{labels.zeffyTeam}}
  </p>
</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.USER_INVITATION_FIRST_REMINDER = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.invitationFirstReminderPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{firstName}} {{labels.invitationFirstReminderIntro}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{#if userFirstName}}{{labels.hi}} {{userFirstName}}{{labels.invitationFirstReminderTitleMiddle}} {{orgName}}{{labels.invitationFirstReminderTitleSuffix}}{{else}}{{labels.invitationFirstReminderTitleFallback}} {{orgName}}{{labels.invitationFirstReminderTitleSuffix}}{{/if}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.invitationFirstReminderBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.invitationFirstReminderBody}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.invitationFirstReminderButton (label path), invitationLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{invitationLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.invitationFirstReminderButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{invitationLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.invitationFirstReminderButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <!-- Organization-facing / Subtitle. Param: labels.invitationReminderCommunityNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.invitationReminderCommunityNote}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_COLLABORATOR_APP_INVITE = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.collaboratorAppInvitePreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.collaboratorAppInviteGreeting}}</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{inviterFirstName}} {{labels.collaboratorAppInviteTitleMiddle}} {{campaignTitle}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.collaboratorAppInviteBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.collaboratorAppInviteBody}}</p></div>
    {{#if setUpAccountLink}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.collaboratorAppInviteSetUpAccount (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.collaboratorAppInviteSetUpAccount}}</p></div>
    <table cellpadding="0" cellspacing="0" border="0" role="presentation" width="100%" style="border-collapse: collapse; margin: 0 0 24px;">
      <tr>
        <td align="center"><!-- Organization-facing / Button. Params: labels.collaboratorAppInviteSetUpAccountButton (label path), setUpAccountLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{setUpAccountLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.collaboratorAppInviteSetUpAccountButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{setUpAccountLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.collaboratorAppInviteSetUpAccountButton}}</a>
  <!--<![endif]-->
</td></tr></table></td>
      </tr>
    </table>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.collaboratorAppInviteDownloadApp (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.collaboratorAppInviteDownloadApp}}</p></div>
    {{/if}}
    <table cellpadding="0" cellspacing="0" border="0" role="presentation" width="100%" style="border-collapse: collapse; margin: 0 0 24px;">
      <tr>
        <td align="center" style="padding: 0 0 16px;">
          {{#if setUpAccountLink}}
          <img src="{{qrCodeSrc}}" width="120" height="120" alt="" style="display: block; border: 0; width: 120px; height: 120px;" />
          {{else}}
          <img src="{{qrCodeSrc}}" width="160" height="160" alt="" style="display: block; border: 0; width: 160px; height: 160px;" />
          {{/if}}
        </td>
      </tr>
      <tr>
        <td align="center"><!-- Organization-facing / Zeffy app store badges (Google Play + App Store images, side by side).
     Reads appStoreUrl, playStoreUrl, isPreview and labels from context. The badge CIDs are owned by this
     partial: the transactional service ships the matching inline PNGs and previews swap them to data URIs.
     labels.storeBadgeLocale picks the official badge language (en, fr, de); the App Store badge width varies by language. -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr>
  <td style="padding: 0 8px 0 0;">
    <a {{#unless isPreview}}href="{{playStoreUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
      <img src="cid:img-google-play-badge-{{labels.storeBadgeLocale}}" width="108" height="32" alt="{{labels.googlePlayButton}}" style="display: block; border: 0; width: 108px; height: 32px;" />
    </a>
  </td>
  <td>
    <a {{#unless isPreview}}href="{{appStoreUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
      <img src="cid:img-app-store-badge-{{labels.storeBadgeLocale}}" width="{{labels.appStoreBadgeWidth}}" height="32" alt="{{labels.appStoreButton}}" style="display: block; border: 0; width: {{labels.appStoreBadgeWidth}}px; height: 32px;" />
    </a>
  </td>
</tr></table></td>
      </tr>
    </table>
    <table cellpadding="0" cellspacing="0" border="0" role="presentation" width="100%" style="border-collapse: separate; border-spacing: 0 8px; margin: 0 0 16px;">
      <tr>
        <td class="mfs12" style="padding: 12px 16px; border: 1px solid {{theme.dividerNeutral}}; border-radius: 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}};"><img src="cid:icon-flash" width="20" height="20" alt="" style="display: inline-block; border: 0; width: 20px; height: 20px; vertical-align: middle; margin: 0 8px 0 0;" /><span style="vertical-align: middle;">{{labels.collaboratorAppInviteQuickSetup}}</span></td>
      </tr>
      {{#if isTapToPaySupported}}
      <tr>
        <td class="mfs12" style="padding: 12px 16px; border: 1px solid {{theme.dividerNeutral}}; border-radius: 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}};"><img src="cid:icon-credit-card" width="20" height="20" alt="" style="display: inline-block; border: 0; width: 20px; height: 20px; vertical-align: middle; margin: 0 8px 0 0;" /><span style="vertical-align: middle;">{{labels.collaboratorAppInviteTapToPay}}</span></td>
      </tr>
      {{/if}}
      <tr>
        <td class="mfs12" style="padding: 12px 16px; border: 1px solid {{theme.dividerNeutral}}; border-radius: 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}};"><img src="cid:icon-scan" width="20" height="20" alt="" style="display: inline-block; border: 0; width: 20px; height: 20px; vertical-align: middle; margin: 0 8px 0 0;" /><span style="vertical-align: middle;">{{labels.collaboratorAppInviteCheckIn}}</span></td>
      </tr>
    </table>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationInvitationClosing}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_CARD_EXPIRING = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.userCardExpiringPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 12px;">
    {{labels.userCardExpiringIntroPrefix}} {{programTypeLabel}} {{labels.userCardExpiringIntroWith}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong> {{labels.userCardExpiringIntroRenewsOn}} <strong style="color: {{theme.tIntense}};">{{renewDate}}</strong> {{labels.userCardExpiringIntroFor}} <strong style="color: {{theme.tIntense}};">{{renewPrice}}</strong>.
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.userCardExpiringWarningPrefix}} <strong style="color: {{theme.tIntense}};">{{last4PaymentMethod}}</strong> {{labels.userCardExpiringWarningSuffix}}
  </p>
</td></tr>

<!-- ========== 4. CTA ========== -->
<tr data-section="cta"><td align="center" style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" align="center" class="mobile-cta-stack" style="margin: 0 auto;"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{updatePaymentUrl}}" {{/unless}}style="height:44px;v-text-anchor:middle;width:240px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{labels.userCardExpiringButton}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#unless isPreview}}href="{{updatePaymentUrl}}" target="_blank" {{/unless}}class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.userCardExpiringButton}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 5. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.userCardExpiringThanks}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.zeffyTeamOnBehalfOf}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>.
  </p>
</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.USER_MERGE_USERS_REQUEST = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.mergeUsersRequestPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.mergeUsersRequestTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.mergeUsersRequestTitle}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.mergeUsersRequestIntroPrefix}} <strong style="color: {{theme.headerText}};">{{oldEmail}}</strong> {{labels.mergeUsersRequestIntroMiddle}} <strong style="color: {{theme.headerText}};">{{newEmail}}</strong>{{labels.mergeUsersRequestIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.mergeUsersRequestInstruction (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.mergeUsersRequestInstruction}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.mergeUsersRequestButton (label path), mergeLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{mergeLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.mergeUsersRequestButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{mergeLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.mergeUsersRequestButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.mergeUsersRequestNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.mergeUsersRequestNote}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_NPO_STARTER_INVITATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.npoStarterInvitationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.npoStarterInvitationCongratulations}} {{orgName}}{{#if is501c3Eligible}}{{labels.npoStarterInvitation501c3TitleSuffix}}{{else}}{{labels.npoStarterInvitationIncorporatedTitleSuffix}}{{/if}}</p>
    </div>
    {{#if is501c3Eligible}}
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.npoStarterInvitation501c3Reviewed (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.npoStarterInvitation501c3Reviewed}}</p></div>
    <div style="margin: 0 0 8px;"><!-- Organization-facing / Subtitle. Param: labels.npoStarterInvitation501c3RoadmapHeading (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.npoStarterInvitation501c3RoadmapHeading}}</p></div>
    <div style="margin: 0 0 24px;">
      <ul style="margin: 0; padding-left: 20px;">
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.npoStarterInvitationStep501c3Status}}</li>
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.npoStarterInvitationStepEssentials}}</li>
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.npoStarterInvitationStepFundraising}}</li>
      </ul>
    </div>
    {{else}}
    <div style="margin: 0 0 8px;"><!-- Organization-facing / Subtitle. Param: labels.npoStarterInvitationWhatsNextHeading (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.npoStarterInvitationWhatsNextHeading}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.npoStarterInvitationRoadmapHeading (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.npoStarterInvitationRoadmapHeading}}</p></div>
    <div style="margin: 0 0 16px;">
      <ul style="margin: 0; padding-left: 20px;">
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.npoStarterInvitationStepEssentials}}</li>
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.npoStarterInvitationStepFundraising}}</li>
      </ul>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.npoStarterInvitationReady (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.npoStarterInvitationReady}}</p></div>
    {{/if}}
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: ctaLabel (label path), ctaLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{ctaLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{ctaLabel}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{ctaLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{ctaLabel}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <!-- Organization-facing / Subtitle. Param: labels.invitationReminderCommunityNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.invitationReminderCommunityNote}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_FAILED_RECURRING_CARD_PAYMENT = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.userFailedRecurringCardPaymentPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.5;">
    {{labels.hi}} {{fullName}},
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 12px;">
    {{labels.userFailedRecurringCardPaymentIntroPrefix}} {{programTypeLabel}} {{labels.userFailedRecurringCardPaymentIntroOf}} <strong style="color: {{theme.tIntense}};">{{amount}}</strong> {{labels.userFailedRecurringCardPaymentIntroFor}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>.
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.userFailedRecurringCardPaymentKeepActivePrefix}} {{programTypeLabelShort}} {{labels.userFailedRecurringCardPaymentKeepActiveSuffix}}
  </p>
</td></tr>

<!-- ========== 4. CTA ========== -->
<tr data-section="cta"><td align="center" style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" align="center" class="mobile-cta-stack" style="margin: 0 auto;"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{updatePaymentUrl}}" {{/unless}}style="height:44px;v-text-anchor:middle;width:240px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{labels.userFailedRecurringCardPaymentButton}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#unless isPreview}}href="{{updatePaymentUrl}}" target="_blank" {{/unless}}class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.userFailedRecurringCardPaymentButton}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 5. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.userFailedRecurringCardPaymentThanks}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.zeffyTeamOnBehalfOf}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>.
  </p>
</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.USER_CONTACT_EMAIL_CHANGED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.contactEmailChangedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.contactEmailChangedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.contactEmailChangedIntro}}</p></div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.contactEmailChangedDetailsHeading}}</p>
      <p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.contactEmailChangedPreviousEmail}} {{oldEmail}}</p>
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.contactEmailChangedUpdatedEmail}} {{newEmail}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.contactEmailChangedButton (label path), dashboardUrl (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{dashboardUrl}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.contactEmailChangedButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{dashboardUrl}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.contactEmailChangedButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_INVITATION_SECOND_REMINDER = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.invitationSecondReminderPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;"><!-- Organization-facing / Subtitle. Param: labels.invitationSecondReminderSubtitle (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.invitationSecondReminderSubtitle}}</p></div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.invitationSecondReminderTitlePrefix}} {{firstName}}{{labels.invitationSecondReminderTitleSuffix}}</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.invitationSecondReminderBodyPrefix}} <strong style="color: {{theme.headerText}};">{{orgName}}</strong>{{labels.invitationSecondReminderBodySuffix}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.invitationSecondReminderButton (label path), invitationLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{invitationLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.invitationSecondReminderButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{invitationLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.invitationSecondReminderButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <!-- Organization-facing / Subtitle. Param: labels.invitationReminderCommunityNote (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.invitationReminderCommunityNote}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_ORGANIZATION_CREATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.organizationCreatedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}}{{labels.organizationCreatedTitleSuffix}}</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.organizationCreatedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationCreatedIntro}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.organizationCreatedTechnology (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationCreatedTechnology}}</p></div>
    <div style="margin: 0 0 8px;"><!-- Organization-facing / Subtitle. Param: labels.organizationCreatedToolsHeading (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.organizationCreatedToolsHeading}}</p></div>
    <div style="margin: 0 0 16px;">
      <ul style="margin: 0; padding-left: 20px;">
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationCreatedToolDonationsPrefix}} <a href="{{labels.organizationCreatedToolDonationsUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.organizationCreatedToolDonationsLink}}</a>{{labels.organizationCreatedToolDonationsSuffix}}</li>
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationCreatedToolTicketsPrefix}} <a href="{{labels.organizationCreatedToolTicketsUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.organizationCreatedToolTicketsLink}}</a>{{labels.organizationCreatedToolTicketsSuffix}}</li>
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationCreatedToolMembershipsPrefix}} <a href="{{labels.organizationCreatedToolMembershipsUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.organizationCreatedToolMembershipsLink}}</a> {{labels.organizationCreatedToolRafflesMiddle}} <a href="{{labels.organizationCreatedToolRafflesUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.organizationCreatedToolRafflesLink}}</a></li>
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationCreatedToolPeerToPeerPrefix}} <a href="{{labels.organizationCreatedToolPeerToPeerUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.organizationCreatedToolPeerToPeerLink}}</a>{{labels.organizationCreatedToolPeerToPeerSuffix}}</li>
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationCreatedToolStorePrefix}} <a href="{{labels.organizationCreatedToolStoreUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.organizationCreatedToolStoreLink}}</a>{{labels.organizationCreatedToolStoreSuffix}}</li>
      </ul>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationCreatedNoCostPrefix}} <a href="{{labels.organizationCreatedNoCostUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.organizationCreatedNoCostLink}}</a>{{labels.organizationCreatedNoCostSuffix}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.organizationCreatedQuestions (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationCreatedQuestions}}</p></div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationCreatedSignature}}</p>
    </div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationCreatedHelpPrefix}} <a href="{{labels.organizationCreatedHelpUrl}}" target="_blank" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.organizationCreatedHelpLink}}</a>{{labels.organizationCreatedHelpSuffix}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_INVITATION_REFUSED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.invitationRefusedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{userEmail}} {{labels.invitationRefusedTitle}}</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.invitationRefusedBody}}</p>
    </div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_FAILED_PAD_ACH = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.userFailedPadAchPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.5;">
    {{labels.hi}} {{fullName}},
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.userFailedPadAchIntroPrefix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>
    {{labels.userFailedPadAchIntroMiddle}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>
    {{labels.userFailedPadAchIntroSuffix}}
  </p>
</td></tr>

<!-- ========== 4. TRANSACTION DETAILS ========== -->
<tr data-section="details"><td style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 8px;">{{labels.failedPadAchDetailsHeading}}</p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 4px;">{{labels.failedPadAchBuyerName}} {{buyerName}}</p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 4px;">{{labels.failedPadAchBuyerEmail}} {{buyerEmail}}</p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 4px;">{{labels.failedPadAchAmount}} {{amount}}</p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">{{labels.failedPadAchTransactionDate}} {{transactionDate}}</p>
</td></tr>

<!-- ========== 5. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.userFailedPadAchClosing}}<br />{{labels.zeffyTeam}}
  </p>
</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.USER_ORGANIZATION_INVITATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.organizationInvitationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      {{#if userFirstName}}
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{userFirstName}} {{userLastName}}!</p>
      {{else}}
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.organizationInvitationGreetingFallback}}</p>
      {{/if}}
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{firstName}} {{labels.organizationInvitationIntroMiddle}} {{orgName}}{{labels.organizationInvitationIntroSuffix}}</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.organizationInvitationBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationInvitationBody}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.organizationInvitationButton (label path), invitationLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{invitationLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.organizationInvitationButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{invitationLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.organizationInvitationButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.organizationInvitationClosing}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_EMAIL_VERIFICATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.emailVerificationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.emailVerificationTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.emailVerificationTitle}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.emailVerificationIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.emailVerificationIntro}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.emailVerificationButton (label path), validationLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{validationLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.emailVerificationButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{validationLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.emailVerificationButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.emailVerificationSafety (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.emailVerificationSafety}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_ADMIN_ADDED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{#if appOnlyAccess}}{{labels.adminAddedAppOnlyPreheader}}{{else}}{{labels.adminAddedPreheader}}{{/if}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{#if newAdminName}}{{newAdminName}}{{else}}{{newAdminEmail}}{{/if}} {{labels.adminAddedTitleMiddle}} {{orgName}}{{#if appOnlyAccess}} {{labels.adminAddedAppOnlyTitleSuffix}}{{else}}.{{/if}}</p>
    </div>
    {{#if appOnlyAccess}}
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{#if appOnlyCanTakePayments}}{{labels.adminAddedAppOnlyBodyCheckInAndTapToPay}}{{else}}{{labels.adminAddedAppOnlyBodyCheckIn}}{{/if}} {{#if appOnlyCampaigns}}{{appOnlyCampaigns}}{{else}}{{labels.adminAddedAppOnlyAllCampaigns}}{{/if}} {{labels.adminAddedAppOnlyBodySuffix}}</p>
    </div>
    {{else}}
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.adminAddedBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.adminAddedBody}}</p></div>
    {{/if}}
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.adminAddedUnauthorized}} <a href="mailto:{{labels.zeffyContactEmail}}" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.zeffyContactEmail}}</a>.</p>
    </div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_DELETE_IMPORT_SUCCESS = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.deleteImportSuccessPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.deleteImportSuccessIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.deleteImportSuccessIntro}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.deleteImportSuccessHelp (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.deleteImportSuccessHelp}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_RESET_PASSWORD = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.resetPasswordPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.resetPasswordTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.resetPasswordTitle}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.resetPasswordIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.resetPasswordIntro}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Button. Params: labels.resetPasswordButton (label path), resetPasswordLink (path), false (bool → outline variant), isPreview (bool → drop href). Desktop 12.5px · mobile 11px (.mfs11). -->
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: separate;"><tr><td align="center">
  <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{resetPasswordLink}}" {{/unless}}style="height:40px;v-text-anchor:middle;width:200px;" arcsize="20%" fillcolor="{{theme.brandFilledBg}}" strokecolor="{{theme.brandFilledBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.brandFilledText}};font-family:Arial,sans-serif;font-size:12.5px;font-weight:bold;">{{labels.resetPasswordButton}}</center></v:roundrect><![endif]-->
  <!--[if !mso]><!-->
  <a {{#unless isPreview}}href="{{resetPasswordLink}}" target="_blank" {{/unless}}class="cta-primary mfs11" style="display: inline-block; background-color: {{theme.brandFilledBg}}; color: {{theme.brandFilledText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 24px; border-radius: 8px; line-height: 1.4; text-align: center;">{{labels.resetPasswordButton}}</a>
  <!--<![endif]-->
</td></tr></table></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.resetPasswordSafety (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.resetPasswordSafety}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_ADMIN_REVOKED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.adminRevokedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{adminName}} {{labels.adminRevokedTitleMiddle}} {{orgName}}.</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.adminRevokedBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.adminRevokedBody}}</p></div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.adminRevokedUnauthorized}} <a href="mailto:{{labels.zeffyContactEmail}}" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.zeffyContactEmail}}</a>.</p>
    </div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_EMAIL_CHANGE_CONFIRMED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.userEmailChangedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.userEmailChangedIntroPrefix}} <strong style="color: {{theme.headerText}};">{{userOldEmail}}</strong> {{labels.userEmailChangedIntroMiddle}} <strong style="color: {{theme.headerText}};">{{userNewEmail}}</strong>.</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.userEmailChangedUnauthorized}} <a href="mailto:{{labels.zeffyContactEmail}}" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.zeffyContactEmail}}</a>.</p>
    </div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_EMAIL_CHANGED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.emailChangedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 8px;"><!-- Organization-facing / Text (body paragraph). Param: labels.emailChangedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.emailChangedIntro}}</p></div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{newEmail}}</p>
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.emailChangedUnauthorized}} <a href="mailto:{{labels.zeffyContactEmail}}" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.zeffyContactEmail}}</a>.</p>
    </div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_PASSWORD_CHANGED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.passwordChangedPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.passwordChangedIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.passwordChangedIntro}}</p></div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.passwordChangedUnauthorized}} <a href="mailto:{{labels.zeffyContactEmail}}" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.zeffyContactEmail}}</a>.</p>
    </div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_ASSISTANT_VERIFICATION_CODE = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.assistantVerificationCodePreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.assistantVerificationCodeTitle (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.assistantVerificationCodeTitle}}</p></div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.assistantVerificationCodeIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.assistantVerificationCodeIntro}}</p></div>
    <p style="margin: 0 0 24px; font-family: Arial, Helvetica, sans-serif; font-size: 32px; line-height: 1.2; font-weight: 700; letter-spacing: 6px; color: {{theme.headerText}};">{{code}}</p>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.assistantVerificationCodeExpiry (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.assistantVerificationCodeExpiry}}</p></div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Text (body paragraph). Param: labels.assistantVerificationCodeSafety (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.assistantVerificationCodeSafety}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_DELETE_IMPORT_ERROR = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.deleteImportErrorPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.deleteImportErrorIntro (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.deleteImportErrorIntro}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_NEW_DEVICE = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.newDevicePreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;"><!-- Organization-facing / Header. Param: labels.newDeviceIntro (label path). Desktop 29px · mobile 24px (.mfs24). -->
<p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.newDeviceIntro}}</p></div>
    <div style="margin: 0 0 24px;">
      {{#if country}}<p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newDeviceCountry}} {{country}}</p>{{/if}}
      {{#if region}}<p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newDeviceRegion}} {{region}}</p>{{/if}}
      {{#if city}}<p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newDeviceCity}} {{city}}</p>{{/if}}
      {{#if date}}<p class="mfs12" style="margin: 0 0 4px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newDeviceDate}} {{date}} {{labels.newDeviceTimezone}}</p>{{/if}}
      {{#if deviceInformation}}<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newDeviceDevice}} {{deviceInformation}}</p>{{/if}}
    </div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0 0 8px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{labels.newDeviceTipsHeading}}</p>
      <ul style="margin: 0; padding-left: 20px;">
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newDeviceTipTimezone}}</li>
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newDeviceTipLocation}}</li>
        <li class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newDeviceTipBrowser}}</li>
      </ul>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.newDeviceClosing (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.newDeviceClosing}}</p></div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.USER_OWNERSHIP_TRANSFERRED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.ownershipTransferredPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Organization-facing / Container (layout). Block partial. Slot: the org-body sections (upper region).
     Renders the "view in browser" link, the stacked body sections, and the Zeffy footer (lower region). -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};"><tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full" style="max-width: 600px; width: 100%; background-color: {{theme.canvas}}; border-radius: 12px; border-collapse: separate; border-spacing: 0;">
    {{#if viewInBrowserUrl}}
    <tr><td style="padding: 12px 12px 0; text-align: center;">
      <a href="{{viewInBrowserUrl}}" target="_blank" class="mfs7_5 account-link" style="font-family: Arial, Helvetica, sans-serif; font-size: 10.5px; line-height: 1.5; color: {{theme.viewInBrowser}}; text-decoration: underline;">{{labels.orgEmailViewInBrowser}}</a>
    </td></tr>
    {{/if}}
    <tr><td style="padding: 12px 12px 0;">
      
  <!-- Organization-facing / Body (layout). Block partial. Optional params: false, false (label paths),
     false (bool — square top corners, for when an org-banner-header sits above and owns the rounding).
     Slot: the content blocks (org-text / org-button / org-link) that make up the section. White card. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.cardBg}}; border-radius: 12px 12px 0 0; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px;" class="mobile-pad-inner">
  
  
  
    <div style="margin: 0 0 12px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.subtitleText}}; word-break: break-word;">{{labels.hi}} {{firstName}},</p>
    </div>
    <div style="margin: 0 0 16px;">
      <p class="mfs24" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.3; font-weight: 700; color: {{theme.headerText}}; word-break: break-word;">{{adminName}} {{labels.ownershipTransferredTitleMiddle}} {{orgName}}.</p>
    </div>
    <div style="margin: 0 0 24px;"><!-- Organization-facing / Text (body paragraph). Param: labels.ownershipTransferredBody (label path). Desktop 14.5px · mobile 12px (.mfs12). -->
<!-- Optional false + false name a value inside the sentence, e.g. the organization a payment belongs to. -->
<p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.ownershipTransferredBody}}</p></div>
    <div style="margin: 0 0 24px;">
      <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.bodyText}}; word-break: break-word;">{{labels.ownershipTransferredUnauthorized}} <a href="mailto:{{labels.zeffyContactEmail}}" style="color: {{theme.link}}; font-weight: 700; text-decoration: underline;">{{labels.zeffyContactEmail}}</a>.</p>
    </div>
    <p class="mfs12" style="margin: 0; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.bodyText}}; word-break: break-word;">{{labels.allTheBest}}<br />{{labels.zeffyTeam}}</p>
  
</td></tr></table>

    </td></tr>
    <tr><td style="padding: 0 12px 12px;">
      <!-- Organization-facing / Footer. Reads labels + theme + currentYear. Fixed Zeffy-brand blue card. -->
<!-- The Zeffy wordmark logo is part of the footer itself: it is hardcoded to the org-facing CID
     (white wordmark + green swoosh) so any template using this footer ships it with no caller input.
     The transactional service ships the matching inline PNG whenever this CID is in the rendered HTML;
     browser previews swap it to a data URI via inlineOrgFooterLogoForPreview. -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.footerBg}}; border-radius: 0 0 12px 12px; border-collapse: separate; border-spacing: 0;"><tr><td style="padding: 30px 24px;" class="mobile-pad-inner">
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="cid:icon-zeffy-dark-green-wind" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  <p class="mfs10_5" style="margin: 0 0 16px; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerText}};">
    <strong>{{labels.orgEmailFooterPartnerIntro}}</strong> {{labels.orgEmailFooterPartnerBody}}
    <a href="https://zeffy.com/?UTM_source=click_orgemail_generatedbyzeffy" target="_blank" style="color: {{theme.footerAccent}}; text-decoration: underline;">{{labels.footerLearnMore}}</a>
  </p>
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td align="left" style="vertical-align: middle;">
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="padding-right: 9px;">
          <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td style="padding-right: 9px;">
          <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
          </a>
        </td>
        <td>
          <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
            <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
          </a>
        </td>
      </tr></table>
    </td>
    <td align="right" class="mfs9" style="vertical-align: middle; font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerCopyright}}; white-space: nowrap;">&copy; {{currentYear}} Zeffy</td>
  </tr></table>
</td></tr></table>
    </td></tr>
  </table>
</td></tr></table>
</body>
</html>
`;
exports.TRIBUTE_DONATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{#if isInMemory}}{{labels.preheaderTributeInMemory}}{{else}}{{labels.preheaderTributeInHonour}}{{/if}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.tributeGreeting}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{#if isInMemory}}{{labels.inMemoryOf}}{{else}}{{labels.inHonourOf}}{{/if}} {{inHonourName}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    <strong style="color: {{theme.tIntense}};">{{firstName}} {{lastName}}</strong> {{labels.tributeDonationMade}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>.{{#if message}} {{labels.tributeSeeMessage}}{{/if}}
  </p>
</td></tr>

<!-- ========== 4. MESSAGE FROM THE DONOR ========== -->
{{#if message}}
<tr data-section="note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.emailBg}}; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      {{!-- No quote glyph here on purpose — same reasoning as partials/note-from-org.hbs (KRA-5052). --}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.4;">
        {{labels.tributeMessageFrom}} {{firstName}} {{lastName}}
      </p>
      <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
        {{{message}}}
      </div>
    </td></tr>
  </table>
</td></tr>
{{/if}}

<!-- ========== 5. REPLY-TO-ORG NOTE ========== -->
<tr data-section="reply-note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.tributeMoreInfoPrefix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong> {{labels.tributeMoreInfoSuffix}}
  </p>
</td></tr>

<!-- Breathing room before the footer -->
<tr data-section="body-spacer"><td style="height: 30px; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.INVOICE_REMINDER_DONOR = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.invoiceReminderPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  {{#if (eq reminderType "immediate")}}
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 12px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{orgName}} {{labels.invoiceReminderImmediateMiddle}} {{invoicePrice}}{{labels.invoiceReminderImmediateSuffix}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.invoiceReminderImmediateSubtextPrefix}} <strong style="color: {{theme.tIntense}};">{{dueDate}}</strong>{{labels.invoiceReminderImmediateSubtextSuffix}}
  </p>
  {{/if}}
  {{#if (eq reminderType "beforeDue")}}
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 12px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.invoiceReminderBeforeDueTitlePrefix}} {{invoicePrice}} {{labels.invoiceReminderBeforeDueTitleSuffix}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.invoiceReminderBeforeDueSubtextPrefix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>{{labels.invoiceReminderBeforeDueSubtextMiddle}} <strong style="color: {{theme.tIntense}};">{{dueDate}}</strong>{{labels.invoiceReminderBeforeDueSubtextSuffix}}
  </p>
  {{/if}}
  {{#if (eq reminderType "onDueDate")}}
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 12px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.invoiceReminderOnDueDateTitlePrefix}} {{invoicePrice}} {{labels.invoiceReminderOnDueDateTitleSuffix}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.invoiceReminderOnDueDateSubtextPrefix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong> {{labels.invoiceReminderOnDueDateSubtextSuffix}}
  </p>
  {{/if}}
  {{#if (eq reminderType "overdue")}}
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 12px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.invoiceReminderOverdueTitlePrefix}} {{invoicePrice}} {{labels.invoiceReminderOverdueTitleSuffix}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.invoiceReminderOverdueSubtextPrefix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong> {{labels.invoiceReminderOverdueSubtextMiddle}} <strong style="color: {{theme.tIntense}};">{{dueDate}}</strong> {{labels.invoiceReminderOverdueSubtextSuffix}}
  </p>
  {{/if}}
</td></tr>

<!-- ========== 4. CTA ========== -->
<tr data-section="cta"><td align="center" style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" align="center" class="mobile-cta-stack" style="margin: 0 auto;"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{invoiceUrl}}" {{/unless}}style="height:44px;v-text-anchor:middle;width:200px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{labels.invoiceReminderButton}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#unless isPreview}}href="{{invoiceUrl}}" target="_blank" {{/unless}}class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.invoiceReminderButton}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 5. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.invoiceReminderQuestionsPrefix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong> {{labels.invoiceReminderQuestionsSuffix}}
  </p>
</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.AUCTION_BID_PLACED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderAuctionBidPlaced}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.auctionBidPlacedTitle}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.auctionYouBidAt}} {{auctionName}}. {{labels.auctionBidPlacedLedeSuffix}}
  </p>
</td></tr>

<!-- ========== 4. BID DETAILS ========== -->
<tr data-section="bid-details"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.noteBg}};{{#if theme.isDark}} border: 1px solid {{theme.bModerate}};{{/if}} border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 12px;">{{labels.auctionBidDetails}}</p>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#each bidItems}}
        <tr>
          <td width="12" class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; color: {{../theme.tBrand}}; padding: 3px 8px 3px 0; vertical-align: baseline; line-height: 1.5;">&bull;</td>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; color: {{../theme.tModerate}}; padding: 3px 0; vertical-align: baseline; line-height: 1.5; word-break: break-word;"><strong style="color: {{../theme.tIntense}};">{{itemPrice}}</strong>{{#if isTaxed}} <span style="color: {{../theme.tQuiet}};">{{../labels.auctionBidTaxMention}}</span>{{/if}} {{bidConnector}} <em>{{itemName}}</em></td>
        </tr>
        {{/each}}
      </table>
    </td></tr>
  </table>
</td></tr>

<!-- ========== 5. NOTE FROM ORGANIZER ========== -->
{{#if message}}
<tr data-section="note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.emailBg}}; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      {{!-- No quote glyph here on purpose (KRA-5052). A lone opening quote beside the heading read
            as a grammar error to organizations, and the design-system version that closes it sits
            centred on the card's border — which needs absolute positioning plus an image mask that
            Gmail and Outlook strip. The card's own outline already frames the message. --}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.4;">
        {{labels.aThankYouFrom}} {{orgName}}
      </p>
      <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
        {{{message}}}
      </div>
    </td></tr>
  </table>
</td></tr>
{{/if}}

<!-- ========== 6. CHECK BACK ========== -->
<tr data-section="check-back"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.auctionCheckBackPrefix}} <strong style="color: {{theme.tIntense}};">{{eventClosedDate}}</strong> {{labels.auctionCheckBackSuffix}}
  </p>
</td></tr>

<!-- ========== 7. CTA ========== -->
<tr data-section="cta"><td align="center" style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-cta-stack"><tr><td align="center">
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{{ctaUrl}}" style="height:44px;v-text-anchor:middle;width:200px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{labels.auctionViewMyBids}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a href="{{ctaUrl}}" target="_blank" class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.auctionViewMyBids}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 8. SECURITY NOTE ========== -->
<tr data-section="security-note"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 18px;">
    <strong style="color: {{theme.tIntense}};">{{labels.auctionPleaseNote}}</strong> {{labels.auctionPersonalLinkNote}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.auctionCardNotChargedPrefix}} <strong style="color: {{theme.tIntense}};">{{labels.auctionCardNotChargedEmphasis}}</strong> {{labels.auctionCardNotChargedSuffix}}
  </p>
</td></tr>

<!-- ========== 9. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.AUCTION_OUTBID = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderAuctionOutbid}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.auctionOutbidTitlePrefix}} {{itemName}}.
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 18px;">
    {{labels.auctionOutbidBody1Prefix}} <strong style="color: {{theme.tIntense}};">{{eventClosedDate}}</strong> {{labels.auctionOutbidBody1Suffix}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.auctionOutbidVisit}}
  </p>
</td></tr>

<!-- ========== 3. CTA ========== -->
<tr data-section="cta"><td style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-cta-stack"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{{ctaUrl}}" style="height:44px;v-text-anchor:middle;width:200px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{labels.auctionPlaceNewBid}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a href="{{ctaUrl}}" target="_blank" class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.auctionPlaceNewBid}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 4. SECURITY NOTE ========== -->
<tr data-section="security-note"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 18px;">
    <strong style="color: {{theme.tIntense}};">{{labels.auctionPleaseNote}}</strong> {{labels.auctionPersonalLinkNote}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.auctionCardNotChargedPrefix}} <strong style="color: {{theme.tIntense}};">{{labels.auctionCardNotChargedEmphasis}}</strong> {{labels.auctionCardNotChargedSuffix}}
  </p>
</td></tr>

<!-- ========== 5. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.AUCTION_NEW_TOP_BIDDER = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderAuctionNewTopBidder}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.auctionNewTopBidderTitlePrefix}} {{itemName}}.
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.auctionNewTopBidderBody1Prefix}} <strong style="color: {{theme.tIntense}};">{{eventClosedDate}}</strong> {{labels.auctionNewTopBidderBody1Suffix}}
  </p>
</td></tr>

<!-- ========== 3. CTA ========== -->
<tr data-section="cta"><td style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-cta-stack"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{{ctaUrl}}" style="height:44px;v-text-anchor:middle;width:200px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{labels.auctionCheckYourBid}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a href="{{ctaUrl}}" target="_blank" class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.auctionCheckYourBid}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 4. SECURITY NOTE ========== -->
<tr data-section="security-note"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 18px;">
    <strong style="color: {{theme.tIntense}};">{{labels.auctionPleaseNote}}</strong> {{labels.auctionPersonalLinkNote}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.auctionCardNotChargedPrefix}} <strong style="color: {{theme.tIntense}};">{{labels.auctionCardNotChargedEmphasis}}</strong> {{labels.auctionCardNotChargedSuffix}}
  </p>
</td></tr>

<!-- ========== 5. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.AUCTION_THANK_YOU_NON_WINNER = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderAuctionNonWinner}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.auctionNonWinnerTitle}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.auctionYouBidAt}} {{auctionName}}. {{labels.auctionNonWinnerLedeSuffix}}
  </p>
</td></tr>

<!-- ========== 4. ITEMS OUTBID ON ========== -->
<tr data-section="items-outbid"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.noteBg}};{{#if theme.isDark}} border: 1px solid {{theme.bModerate}};{{/if}} border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 12px;">{{labels.auctionItemsOutbidOn}}</p>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#each lostItems}}
        <tr>
          <td width="12" class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; color: {{../theme.tBrand}}; padding: 3px 8px 3px 0; vertical-align: baseline; line-height: 1.5;">&bull;</td>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{../theme.tModerate}}; padding: 3px 0; vertical-align: baseline; line-height: 1.5; word-break: break-word;">{{name}}</td>
        </tr>
        {{/each}}
      </table>
    </td></tr>
  </table>
</td></tr>

<!-- ========== 5. NOTE FROM ORGANIZER ========== -->
{{#if message}}
<tr data-section="note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.emailBg}}; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      {{!-- No quote glyph here on purpose (KRA-5052). A lone opening quote beside the heading read
            as a grammar error to organizations, and the design-system version that closes it sits
            centred on the card's border — which needs absolute positioning plus an image mask that
            Gmail and Outlook strip. The card's own outline already frames the message. --}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.4;">
        {{labels.aThankYouFrom}} {{orgName}}
      </p>
      <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
        {{{message}}}
      </div>
    </td></tr>
  </table>
</td></tr>
{{/if}}
{{#if message}}
<!-- Spacer so the footer isn't glued to the note block (no receipt section sits between them here) -->
<tr data-section="note-spacer"><td style="font-size: 0; line-height: 0; height: 24px;">&nbsp;</td></tr>
{{/if}}

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.AUCTION_THANK_YOU_WINNER = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{#if paymentHasFailed}}{{labels.preheaderAuctionWonPaymentFailed}}{{else}}{{labels.preheaderAuctionWon}}{{/if}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.auctionWinnerTitle}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 3px;">
    {{labels.auctionWinnerLedePrefix}} {{auctionName}}. {{labels.auctionWinnerLedeSuffix}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.managePurchase}} <a href="{{simplykConnectionLink}}" class="account-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.zeffyAccount}}</a>
  </p>
</td></tr>

<!-- ========== 4. PAYMENT FAILED NOTICE ========== -->
{{#if paymentHasFailed}}
<tr data-section="payment-failed"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.noteBg}}; border: 1px solid {{theme.tError}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tError}}; margin: 0 0 6px; line-height: 1.4;">{{labels.auctionWinnerPaymentFailedTitle}}</p>
      <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; color: {{theme.tModerate}}; margin: 0; line-height: 1.5;">
        {{labels.auctionWinnerPaymentFailedNote}} {{labels.auctionWinnerPaymentFailedContactPrefix}} {{orgName}} {{labels.auctionWinnerPaymentFailedContactSuffix}}
      </p>
    </td></tr>
  </table>
</td></tr>
{{/if}}

<!-- ========== 5. ITEMS WON ========== -->
<tr data-section="items-won"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.noteBg}};{{#if theme.isDark}} border: 1px solid {{theme.bModerate}};{{/if}} border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 12px;">{{labels.auctionItemsWon}}</p>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#each wonItems}}
        <tr>
          <td width="12" class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; color: {{../theme.tBrand}}; padding: 3px 8px 3px 0; vertical-align: baseline; line-height: 1.5;">&bull;</td>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{../theme.tModerate}}; padding: 3px 0; vertical-align: baseline; line-height: 1.5; word-break: break-word;">{{name}}</td>
        </tr>
        {{/each}}
      </table>
      {{#if hasLostItems}}
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 18px 0 12px;">{{labels.auctionItemsNotWon}}</p>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#each lostItems}}
        <tr>
          <td width="12" class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; color: {{../theme.tBrand}}; padding: 3px 8px 3px 0; vertical-align: baseline; line-height: 1.5;">&bull;</td>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{../theme.tModerate}}; padding: 3px 0; vertical-align: baseline; line-height: 1.5; word-break: break-word;">{{name}}</td>
        </tr>
        {{/each}}
      </table>
      {{/if}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: {{theme.tQuiet}}; margin: 14px 0 0; line-height: 1.4;">
        {{labels.fullReceiptBelow}}
      </p>
    </td></tr>
  </table>
</td></tr>

<!-- ========== 6. NOTE FROM ORGANIZER ========== -->
{{#if message}}
<tr data-section="note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.emailBg}}; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      {{!-- No quote glyph here on purpose (KRA-5052). A lone opening quote beside the heading read
            as a grammar error to organizations, and the design-system version that closes it sits
            centred on the card's border — which needs absolute positioning plus an image mask that
            Gmail and Outlook strip. The card's own outline already frames the message. --}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.4;">
        {{labels.aThankYouFrom}} {{orgName}}
      </p>
      <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
        {{{message}}}
      </div>
    </td></tr>
  </table>
</td></tr>
{{/if}}

<!-- ========== 7. RECEIPT ========== -->
<tr data-section="receipt"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
    <!-- Receipt header -->
    <tr><td style="padding: 0 0 12px;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0;">{{#if isChequePending}}{{labels.transactionInfo}}{{else}}{{labels.transactionReceipt}}{{/if}}</p>
    </td></tr>
    <!-- Buyer details -->
    <tr><td style="padding: 0;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{#if isDonation}}{{labels.donorName}}{{else if isSweepstakes}}{{labels.participantName}}{{else}}{{labels.buyerName}}{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{firstName}} {{lastName}}</td>
        </tr>
        {{#if companyName}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{labels.company}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{companyName}}</td>
        </tr>
        {{/if}}
        {{#if address}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap; vertical-align: top;">{{labels.location}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0; word-break: break-word; vertical-align: top;">{{address}}</td>
        </tr>
        {{/if}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{#if isDonation}}{{labels.donationDate}}{{else}}{{labels.date}}{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{date}}</td>
        </tr>
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{labels.method}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{paymentMethodDisplay}}</td>
        </tr>
        {{#if shippingAddress}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0; white-space: nowrap;">{{labels.shippingAddress}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0; word-break: break-word;">{{shippingAddress}}</td>
        </tr>
        {{/if}}
      </table>
    </td></tr>
    <!-- Purchase / donation details -->
    <tr><td style="padding: 12px 0 0;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 6px;">{{#if isDonation}}{{labels.donationDetails}}{{else if isSweepstakes}}{{labels.participationDetails}}{{else}}{{labels.purchaseDetails}}{{/if}}</p>
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        {{#if isDonation}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{#if isOneTime}}{{labels.oneTimeDonation}}{{else if isWeekly}}{{labels.weeklyDonation}}{{else if isBiWeekly}}{{labels.biWeeklyDonation}}{{else if isMonthly}}{{labels.monthlyDonation}}{{else if isQuarterly}}{{labels.quarterlyDonation}}{{else}}{{labels.yearlyDonation}}{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{#unless shouldHideAmounts}}{{donationAmount}}{{/unless}}</td>
        </tr>
        {{else}}
        {{#each tickets}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tModerate}}; padding: 3px 0; word-break: break-word;">{{#unless ../isAuction}}{{number}} × {{/unless}}{{title}}{{#if variantValues}}{{#each variantValues}} • {{this}}{{/each}}{{else}}{{#if variantLabel}} — {{variantLabel}}{{/if}}{{/if}}{{#if taxMarkers}} <span style="color: {{../theme.tQuiet}};">({{taxMarkers}} {{#if hasMultipleTaxMarkers}}{{../labels.taxAppliesSuffixMany}}{{else}}{{../labels.taxAppliesSuffixOne}}{{/if}})</span>{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{formattedPrice}}</td>
        </tr>
        {{/each}}
        {{#each addOns}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tModerate}}; padding: 3px 0; word-break: break-word;">{{number}} × <span style="color: {{../theme.tBrand}};">{{../labels.addOnReceiptPrefix}}</span> {{title}}{{#if taxMarkers}} <span style="color: {{../theme.tQuiet}};">({{taxMarkers}} {{#if hasMultipleTaxMarkers}}{{../labels.taxAppliesSuffixMany}}{{else}}{{../labels.taxAppliesSuffixOne}}{{/if}})</span>{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{formattedPrice}}</td>
        </tr>
        {{/each}}
        {{#if extraDonation}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.additionalDonation}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{extraDonation}}</td>
        </tr>
        {{/if}}
        {{#if shippingFeeAmount}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.shippingFee}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{shippingFeeAmount}}</td>
        </tr>
        {{/if}}
        {{#if discountAmount}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.discount}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">−{{discountAmount}}</td>
        </tr>
        {{/if}}
        {{#if proratedAdjustmentAmount}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.proratedAdjustment}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">−{{proratedAdjustmentAmount}}</td>
        </tr>
        {{/if}}
        {{/if}}
        {{#each orderTaxes}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tModerate}}; padding: 3px 0;"><span style="color: {{../theme.tQuiet}};">({{marker}})</span> {{label}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{../theme.tIntense}}; padding: 3px 0; white-space: nowrap;">{{amount}}</td>
        </tr>
        {{/each}}
        {{#if shouldDisplayContributionLine}}
        <tr>
          <td class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; padding: 3px 0;">{{labels.optionalContributionToZeffy}}{{#if shouldDisplayDonorRefundOptionInEmail}} – <a href="{{donorRefundPageLink}}" style="color: {{theme.tBrand}}; text-decoration: underline;">{{labels.learnMore}}</a>{{else}} – <a href="https://www.zeffy.com/home/100-free-for-donors?UTM_source=email_whatiszeffy" style="color: {{theme.tBrand}}; text-decoration: underline;">{{labels.whatIsZeffy}}</a>{{/if}}</td>
          <td align="right" class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tIntense}}; padding: 3px 0;">{{contributionAmount}}</td>
        </tr>
        {{/if}}
      </table>
    </td></tr>
    {{#if shouldHideAmounts}}
    <!-- No total: the value is an internal record the donor self-assesses, so no figure is stated to them. -->
    <tr><td style="padding: 0; font-size: 0; line-height: 0; height: {{#if soldByTaxNumbers}}12px{{else}}30px{{/if}};">&nbsp;</td></tr>
    {{else}}
    <!-- Divider -->
    <tr><td style="padding: 12px 0;">
      <div style="height: 1px; background-color: {{theme.bSupershy}};"></div>
    </td></tr>
    <!-- Total -->
    <tr><td style="padding: 0 0 {{#if soldByTaxNumbers}}12px{{else}}30px{{/if}};">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td class="mfs14" style="font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: 700; line-height: 1.3; color: {{theme.tIntense}};">{{#if paymentHasFailed}}{{labels.totalDue}}{{else if isChequePending}}{{labels.total}}{{else}}{{labels.totalPaid}}{{/if}}</td>
        <td align="right" class="mfs14" style="font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: 700; line-height: 1.3; color: {{theme.tIntense}};">{{paidAmount}}</td>
      </tr></table>
    </td></tr>
    {{/if}}

    {{#if soldByTaxNumbers}}
    <!-- Sold by + tax registration numbers — only when at least one applied tax carries a tax ID -->
    <tr><td style="padding: 0 0 12px;">
      <div style="height: 1px; background-color: {{theme.bSupershy}};"></div>
    </td></tr>
    <tr><td style="padding: 0 0 30px;">
      <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; margin: 0;"><span style="color: {{theme.tQuiet}};">{{labels.soldBy}}</span> <span style="color: {{theme.tIntense}};">{{orgName}}</span></p>
      <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; margin: 6px 0 0;">{{#each soldByTaxNumbers}}{{#unless @first}}<span style="color: {{../theme.bSupershy}};">&nbsp;&nbsp;|&nbsp;&nbsp;</span>{{/unless}}<span style="color: {{../theme.tQuiet}};">{{name}}</span> <span style="color: {{../theme.tIntense}};">{{number}}</span>{{/each}}</p>
    </td></tr>
    {{/if}}

    {{#if isOfflinePayment}}
    <!-- Offline (cheque/cash) payment still owed to and collected by the organizer -->
    <tr><td style="padding: 0 0 30px;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 1.4; color: {{theme.tModerate}}; margin: 0;">
        {{#if isDonation}}{{labels.offlinePaymentPendingPrefixDonation}}{{else if isSweepstakes}}{{labels.offlinePaymentPendingPrefixParticipation}}{{else}}{{labels.offlinePaymentPendingPrefixPurchase}}{{/if}} <strong>{{#if isCashPayment}}{{labels.offlinePaymentMethodCash}}{{else}}{{labels.offlinePaymentMethodCheque}}{{/if}}</strong> {{labels.offlinePaymentArrangePrefix}} {{orgName}} {{labels.offlinePaymentArrangeSuffix}}
      </p>
    </td></tr>
    {{/if}}

    {{#if hasGiftAidConfirmation}}
    <tr><td style="padding: 2px 0 0;">
      {{#if iconGiftAid}}
      <img src="{{iconGiftAid}}" width="66" alt="Gift Aid" style="display: block; border: 0; margin: 0 0 10px;" />
      {{/if}}
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; color: {{theme.tIntense}}; margin: 0;">{{labels.giftAidAdded}} {{hasGiftAid}}</p>
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: {{theme.tQuiet}}; line-height: 1.5; margin: 6px 0 0;">
        {{labels.giftAidDeclaration}} {{orgName}} {{labels.giftAidExtra}} {{giftaidExtraAmount}} {{labels.giftAidNoCost}}
      </p>
    </td></tr>
    {{/if}}

    {{#if shouldDisplayCharityNumberOnTransactionReceipt}}
    <tr><td style="padding: {{#if hasGiftAidConfirmation}}14px{{else}}2px{{/if}} 0 0;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: {{theme.tQuiet}}; line-height: 1.5; margin: 0;">
        {{labels.receiptEmittedBy}} {{orgName}}<br />
        {{transactionReceiptCharityNumberLabel}} {{charityNumber}}
      </p>
    </td></tr>
    {{/if}}

    {{#if registeredCharityName}}
    <tr><td style="padding: {{#if (or hasGiftAidConfirmation shouldDisplayCharityNumberOnTransactionReceipt)}}14px{{else}}2px{{/if}} 0 0;">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: {{theme.tQuiet}}; line-height: 1.5; margin: 0;">
        <span style="color: {{theme.tIntense}};">{{registeredCharityName}}</span> {{labels.registeredCharityStatement}} {{registeredCharityNumber}}
      </p>
    </td></tr>
    {{/if}}

    {{#if (or hasGiftAidConfirmation shouldDisplayCharityNumberOnTransactionReceipt registeredCharityName)}}
    <tr><td style="padding: 0; font-size: 0; line-height: 0; height: 24px;">&nbsp;</td></tr>
    {{/if}}
  </table>
</td></tr>

<!-- ========== 8. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.AUCTION_BID_CANCELLED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderAuctionBidCancelled}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 14px;">
    {{labels.auctionBidCancelledLine1Prefix}} <strong style="color: {{theme.tIntense}};">{{bidAmount}}</strong> {{labels.auctionBidCancelledLine1Mid}} <strong style="color: {{theme.tIntense}};">{{itemName}}</strong> {{labels.auctionBidCancelledLine1Suffix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>.
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.auctionBidCancelledLine2Prefix}} <strong style="color: {{theme.tIntense}};">{{eventClosedDate}}</strong>. {{labels.auctionBidCancelledLine2Suffix}}
  </p>
</td></tr>

<!-- ========== 3. CTA ========== -->
<tr data-section="cta"><td align="center" style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" align="center" class="mobile-cta-stack" style="margin: 0 auto;"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{{ctaUrl}}" style="height:44px;v-text-anchor:middle;width:200px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{labels.auctionVisitAuction}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a href="{{ctaUrl}}" target="_blank" class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.auctionVisitAuction}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 4. SECURITY NOTE ========== -->
<tr data-section="security-note"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 18px;">
    <strong style="color: {{theme.tIntense}};">{{labels.auctionPleaseNote}}</strong> {{labels.auctionPersonalLinkNote}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.auctionCardNotChargedPrefix}} <strong style="color: {{theme.tIntense}};">{{labels.auctionCardNotChargedEmphasis}}</strong> {{labels.auctionCardNotChargedSuffix}}
  </p>
</td></tr>

<!-- ========== 5. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.TRANSFER_IN_PROGRESS_TICKETING = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>
<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* This template carries its own head instead of the shared email-head partial; keep the dark-mode
     meta tags and opt-out in sync with it. See the comment there for why they differ. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  /* WYSIWYG saves color:rgb(0,0,0); override with theme.tModerate (dark: hsl(campaign-h,24%,93%) via resolveEmailThemeTokens). */
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderInProgress}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.transferInProgressTitlePrefix}} {{orgName}} {{labels.transferInProgressTitleSuffix}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.transferInProgressBody}}
  </p>
</td></tr>

<!-- ========== 4. NOTE FROM ORGANIZER ========== -->
{{#if sepaDebit}}
<tr data-section="sepa-debit-details"><td class="mobile-pad-inner" style="padding: 24px 30px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}};">
  <h2 style="margin: 0 0 12px; font-size: 18px; color: {{theme.tIntense}};">{{labels.sepaDebitDetailsTitle}}</h2>
  {{#if sepaDebit.mandateReference}}<p>{{labels.sepaMandateReference}}: {{sepaDebit.mandateReference}}</p>{{/if}}
  {{#if sepaDebit.maskedIban}}<p>{{labels.sepaBankAccount}}: {{sepaDebit.maskedIban}}</p>{{/if}}
  {{#if sepaDebit.creditorName}}<p>{{labels.sepaCreditorName}}: {{sepaDebit.creditorName}}</p>{{/if}}
  {{#if sepaDebit.creditorId}}<p>{{labels.sepaCreditorId}}: {{sepaDebit.creditorId}}</p>{{/if}}
  {{#if sepaDebit.creditorEmail}}<p>{{labels.sepaCreditorContact}}: {{sepaDebit.creditorEmail}}</p>{{/if}}
  {{#if sepaDebit.creditorPhone}}<p>{{labels.sepaCreditorContact}}: {{sepaDebit.creditorPhone}}</p>{{/if}}
  {{#if sepaDebit.creditorAddress}}<p>{{labels.sepaCreditorContact}}: {{sepaDebit.creditorAddress}}</p>{{/if}}
  <p>{{labels.sepaTotalIncludingTip}}: {{sepaDebit.totalAmount}}</p>
  {{#if sepaDebit.expectedDebitDate}}
  <p>{{labels.sepaExpectedDebitDate}}: {{sepaDebit.expectedDebitDate}}</p>
  {{else}}
  
  <p>{{labels.sepaExpectedDebitDate}}: {{labels.sepaDebitDateUnavailable}}</p>
  
  {{/if}}
  <p style="margin: 12px 0 0;">{{labels.sepaProcessingNoticeDisclaimer}}</p>
</td></tr>
{{/if}}
{{#if message}}
<tr data-section="note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.emailBg}}; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      {{!-- No quote glyph here on purpose (KRA-5052). A lone opening quote beside the heading read
            as a grammar error to organizations, and the design-system version that closes it sits
            centred on the card's border — which needs absolute positioning plus an image mask that
            Gmail and Outlook strip. The card's own outline already frames the message. --}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.4;">
        {{labels.aThankYouFrom}} {{orgName}}
      </p>
      <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
        {{{message}}}
      </div>
    </td></tr>
  </table>
</td></tr>
{{/if}}
{{#if message}}
<tr data-section="note-spacer"><td style="height: 24px; font-size: 0; line-height: 0;">&nbsp;</td></tr>
{{/if}}

<!-- ========== 5. ZEFFY FOOTER ========== -->
{{#if isSweepstakes}}
<!-- Zeffy branding footer. Param: labels.footerCopyrightParticipation (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightParticipation}}
  </p>
</td></tr>
{{else}}
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>
{{/if}}

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.DONATION_RENEWAL = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderDonationRenewal}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. BODY (org WYSIWYG content — editable) ========== -->
<tr data-section="note"><td style="padding: 30px;" class="mobile-pad-inner">
  <div class="note-message note-greeting mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{{message}}}
  </div>
</td></tr>

<!-- ========== 4. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.MEMBERSHIP_NEW_CARD_DONOR = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.newMembershipCardPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.newMembershipCardIntro}}
  </p>
</td></tr>

<!-- ========== 4. CTA ========== -->
<tr data-section="cta"><td align="center" style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" align="center" class="mobile-cta-stack" style="margin: 0 auto;"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{eTicketUrl}}" {{/unless}}style="height:44px;v-text-anchor:middle;width:260px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{labels.newMembershipCardButton}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#unless isPreview}}href="{{eTicketUrl}}" target="_blank" {{/unless}}class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.newMembershipCardButton}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 5. WHAT'S NEW ========== -->
<tr data-section="whats-new"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 16px;">
    {{labels.newMembershipCardWhatsNewHeading}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    <strong style="color: {{theme.tIntense}};">{{labels.newMembershipCardSecureTitle}}</strong><br />{{labels.newMembershipCardSecureBody}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    <strong style="color: {{theme.tIntense}};">{{labels.newMembershipCardDesignTitle}}</strong><br />{{labels.newMembershipCardDesignBody}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    <strong style="color: {{theme.tIntense}};">{{labels.newMembershipCardPrintTitle}}</strong><br />{{labels.newMembershipCardPrintBody}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    <strong style="color: {{theme.tIntense}};">{{labels.newMembershipCardStatusTitle}}</strong><br />{{labels.newMembershipCardStatusBody}}
  </p>
</td></tr>

<!-- ========== 6. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.newMembershipCardThanks}}<br />{{labels.zeffyTeam}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tQuiet}}; margin: 0;">
    {{labels.newMembershipCardPostScript}}
  </p>
</td></tr>

<!-- ========== 7. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.MEMBERSHIP_RENEWAL = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderMembership}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. BODY (org WYSIWYG content — editable) ========== -->
<tr data-section="note"><td style="padding: 30px;" class="mobile-pad-inner">
  <div class="note-message note-greeting mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{{message}}}
  </div>
</td></tr>

<!-- ========== 4. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.MEMBERSHIP_MEMBER_CARD = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.memberCardPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}}{{#if firstName}} {{firstName}}{{/if}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.thankYouMember}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.membershipSecured}}
  </p>
</td></tr>

<!-- ========== 4. MEMBERSHIP CARD ========== -->
{{!-- Designer annotation on this frame: no renewal info, no tax receipt info, no transaction info.
      The member did not pay, so none of the payer's money or account belongs in this email. --}}
<tr data-section="order"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.noteBg}};{{#if theme.isDark}} border: 1px solid {{theme.bModerate}};{{/if}} border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px 18px 0;" class="mobile-pad-inner">
      {{#if buyerName}}
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 15px;">{{labels.memberCardFrom}} {{buyerName}}</p>
      {{/if}}
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">
        <tr>
          <td class="mfs12" width="15" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tOrderNumber}}; text-align: right; padding: 3px 6px 3px 0; vertical-align: baseline; font-variant-numeric: tabular-nums; line-height: 1.5;">1×</td>
          <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 600; color: {{theme.tModerate}}; padding: 3px 0; vertical-align: baseline; line-height: 1.5; word-break: break-word;">{{membershipType}}</td>
        </tr>
      </table>
    </td></tr>
    <!-- CTA -->
    {{#if cardUrl}}
    <tr><td style="padding: 15px 18px 18px;" class="mobile-pad-inner">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td>
          <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{cardUrl}}" {{/unless}}style="height:42px;v-text-anchor:middle;width:504px;" arcsize="29%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:17px;font-weight:bold;">{{labels.downloadMemberCard}}</center></v:roundrect><![endif]-->
          <!--[if !mso]><!-->
          <a {{#unless isPreview}}href="{{cardUrl}}" target="_blank" {{/unless}}class="cta-primary" style="display: block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 12px; border-radius: 6px; line-height: 1.4; text-align: center;">
            {{labels.downloadMemberCard}}
          </a>
          <!--<![endif]-->
        </td>
      </tr></table>
    </td></tr>
    {{/if}}
  </table>
</td></tr>

<!-- ========== 5. NOTE FROM THE ORGANIZATION ========== -->
{{#if message}}
<tr data-section="note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.emailBg}}; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      {{!-- No quote glyph here on purpose (KRA-5052). A lone opening quote beside the heading read
            as a grammar error to organizations, and the design-system version that closes it sits
            centred on the card's border — which needs absolute positioning plus an image mask that
            Gmail and Outlook strip. The card's own outline already frames the message. --}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.4;">
        {{labels.aThankYouFrom}} {{orgName}}
      </p>
      <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
        {{{message}}}
      </div>
    </td></tr>
  </table>
</td></tr>
{{/if}}

<!-- Breathing room before the footer — every section above stops at its own top padding -->
<tr data-section="body-spacer"><td style="height: 30px; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.MEMBERSHIP_MEMBERS_ONLY_NOT_ELIGIBLE = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.membersOnlyNotEligiblePreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.5;">
    {{labels.membersOnlyNotEligibleGreeting}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.membersOnlyNotEligibleThanks}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.membersOnlyNotEligibleIntroPrefix}} <strong style="color: {{theme.tIntense}};">{{labels.membersOnlyNotEligibleIntroTickets}}</strong>
    {{labels.membersOnlyNotEligibleIntroOn}} <strong style="color: {{theme.tIntense}};">{{campaignName}}</strong>{{labels.membersOnlyNotEligibleIntroSuffix}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.membersOnlyNotEligibleAlternative}}
  </p>
</td></tr>

<!-- ========== 4. CTA ========== -->
<tr data-section="cta"><td align="center" style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" align="center" class="mobile-cta-stack" style="margin: 0 auto;"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{campaignLink}}" {{/unless}}style="height:44px;v-text-anchor:middle;width:220px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{labels.membersOnlyNotEligibleButton}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#unless isPreview}}href="{{campaignLink}}" target="_blank" {{/unless}}class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.membersOnlyNotEligibleButton}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 5. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.membersOnlyNotEligibleClosing}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.membersOnlyNotEligibleSignaturePrefix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>
  </p>
</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.SEPA_DEBIT_NOTICE = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.sepaDebitNoticePreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>
<tr data-section="header"><td class="mobile-pad-inner" style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name" valign="middle"><p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3;">{{orgName}}</p></td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>
<tr data-section="lede"><td class="mobile-pad-inner" style="padding: 30px 30px 0;">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}}{{#if firstName}} {{firstName}}{{/if}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; color: {{theme.tIntense}};">{{labels.sepaDebitNoticeTitle}}</h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{#if sepaDebit.maskedIban}}
    {{labels.sepaDebitNoticeIntroPrefix}} {{sepaDebit.totalAmount}} {{labels.sepaDebitNoticeIntroSuffix}}
    {{else}}
    {{labels.sepaDebitNoticePreheader}}
    {{/if}}
  </p>
</td></tr>
{{#if sepaDebit}}
<tr data-section="sepa-debit-details"><td class="mobile-pad-inner" style="padding: 24px 30px; font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}};">
  <h2 style="margin: 0 0 12px; font-size: 18px; color: {{theme.tIntense}};">{{labels.sepaDebitDetailsTitle}}</h2>
  {{#if sepaDebit.mandateReference}}<p>{{labels.sepaMandateReference}}: {{sepaDebit.mandateReference}}</p>{{/if}}
  {{#if sepaDebit.maskedIban}}<p>{{labels.sepaBankAccount}}: {{sepaDebit.maskedIban}}</p>{{/if}}
  {{#if sepaDebit.creditorName}}<p>{{labels.sepaCreditorName}}: {{sepaDebit.creditorName}}</p>{{/if}}
  {{#if sepaDebit.creditorId}}<p>{{labels.sepaCreditorId}}: {{sepaDebit.creditorId}}</p>{{/if}}
  {{#if sepaDebit.creditorEmail}}<p>{{labels.sepaCreditorContact}}: {{sepaDebit.creditorEmail}}</p>{{/if}}
  {{#if sepaDebit.creditorPhone}}<p>{{labels.sepaCreditorContact}}: {{sepaDebit.creditorPhone}}</p>{{/if}}
  {{#if sepaDebit.creditorAddress}}<p>{{labels.sepaCreditorContact}}: {{sepaDebit.creditorAddress}}</p>{{/if}}
  <p>{{labels.sepaTotalIncludingTip}}: {{sepaDebit.totalAmount}} ({{sepaDebit.currency}})</p>
  {{#if sepaDebit.expectedDebitDate}}
  <p>{{labels.sepaExpectedDebitDate}}: {{sepaDebit.expectedDebitDate}}</p>
  {{else}}
  
  <p>{{labels.sepaDebitNoticeDatePending}}</p>
  
  {{/if}}
  
</td></tr>
{{/if}}
<!-- Zeffy branding footer. Param: labels.footerCopyrightSepaDebitNotice (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightSepaDebitNotice}}
  </p>
</td></tr>
</table>
</td></tr>
</table>
</body>
</html>
`;
exports.IMPACT_CHAIN_THANK_YOU = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderImpactChain}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <h1 class="mfs24 emoji-inline" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.impactChainRaisedPrefix}} {{campaignName}} {{labels.impactChainRaisedMid}} {{paymentAmount}} {{labels.impactChainRaisedSuffix}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    <strong style="color: {{theme.tIntense}};">{{donorFullName}}</strong> {{labels.impactChainDonatedMid}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong> {{labels.impactChainDonatedSuffix}}
  </p>
</td></tr>

<!-- ========== 4. KEEP SHARING CTA ========== -->
<tr data-section="cta"><td style="padding: 20px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#if sharingLinkUrl}}href="{{sharingLinkUrl}}" {{/if}}style="height:42px;v-text-anchor:middle;width:540px;" arcsize="29%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:17px;font-weight:bold;">{{labels.impactChainCta}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#if sharingLinkUrl}}href="{{sharingLinkUrl}}" target="_blank" {{/if}}class="cta-primary" style="display: block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 12px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.impactChainCta}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- Breathing room before the footer -->
<tr data-section="body-spacer"><td style="height: 30px; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 5. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.RECEIPT_CANCELLED_DONOR = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.receiptCancelledDonorPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.receiptCancelledDonorIntroPrefix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>
    {{labels.receiptCancelledDonorIntroMiddle}} <strong style="color: {{theme.tIntense}};">{{labels.receiptCancelledDonorIntroSuffix}}</strong>
  </p>
</td></tr>

<!-- ========== 4. CTA ========== -->
<tr data-section="cta"><td align="center" style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" align="center" class="mobile-cta-stack" style="margin: 0 auto;"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{fileUrl}}" {{/unless}}style="height:44px;v-text-anchor:middle;width:220px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{labels.receiptCancelledDonorButton}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#unless isPreview}}href="{{fileUrl}}" target="_blank" {{/unless}}class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.receiptCancelledDonorButton}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 5. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.receiptCancelledDonorQuestionsPrefix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong> {{labels.receiptCancelledDonorQuestionsSuffix}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.allTheBest}}<br />{{labels.zeffyTeam}}
  </p>
</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.NEWSLETTER_SIGNUP_CONFIRMATION = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.newsletterSignupConfirmationPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.5;">
    {{labels.hi}}{{#if firstName}} {{firstName}}{{/if}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 16px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.newsletterSignupConfirmationTitle}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.newsletterSignupConfirmationIntroPrefix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>{{labels.newsletterSignupConfirmationIntroSuffix}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.newsletterSignupConfirmationAction}}
  </p>
</td></tr>

<!-- ========== 4. CTA ========== -->
<tr data-section="cta"><td align="center" style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" align="center" class="mobile-cta-stack" style="margin: 0 auto;"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{confirmationLink}}" {{/unless}}style="height:44px;v-text-anchor:middle;width:260px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{labels.newsletterSignupConfirmationButton}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a {{#unless isPreview}}href="{{confirmationLink}}" target="_blank" {{/unless}}class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{labels.newsletterSignupConfirmationButton}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.tBrand}}; margin: 12px 0 0;">
    {{labels.newsletterSignupConfirmationExpiryPrefix}} {{expiryHours}}{{labels.newsletterSignupConfirmationExpirySuffix}}
  </p>
</td></tr>

<!-- ========== 5. CONSENT RECORD ========== -->
<tr data-section="consent-record"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin: 0 0 8px;"><tr>
    <td class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; font-weight: 700; color: {{theme.tQuiet}}; white-space: nowrap; padding-right: 12px; text-transform: uppercase; letter-spacing: 0.04em;">{{labels.newsletterSignupConfirmationRecordHeading}}</td>
    <td width="100%" style="vertical-align: middle;"><table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse: collapse;"><tr><td style="height: 1px; line-height: 1px; font-size: 1px; background-color: {{theme.bSupershy}}; border-radius: 10px;">&nbsp;</td></tr></table></td>
  </tr></table>
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 4px; word-break: break-word;">
    <strong style="color: {{theme.tModerate}};">{{labels.newsletterSignupConfirmationRecordConsent}}</strong> {{consentWording}}
  </p>
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 4px; word-break: break-word;">
    <strong style="color: {{theme.tModerate}};">{{labels.newsletterSignupConfirmationRecordSignedUpAt}}</strong> {{signedUpAt}}
  </p>
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 4px; word-break: break-word;">
    <strong style="color: {{theme.tModerate}};">{{labels.newsletterSignupConfirmationRecordEmail}}</strong> {{contactEmail}}
  </p>
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0; word-break: break-word;">
    <strong style="color: {{theme.tModerate}};">{{labels.newsletterSignupConfirmationRecordIp}}</strong> {{signupIpAddress}}
  </p>
</td></tr>

<!-- ========== 6. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.newsletterSignupConfirmationIgnore}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.newsletterSignupConfirmationSignaturePrefix}} <strong style="color: {{theme.tIntense}};">{{orgName}}</strong>
  </p>
</td></tr>

<!-- ========== 7. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyrightNewsletterConfirmation (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightNewsletterConfirmation}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.NEWSLETTER_THANK_YOU = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.newsletterThankYouPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td width="100%" class="mobile-header-name mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
    <!-- Donor header / "More ways to support" button cell, placed after the org name cell. Renders only when organizationPageUrl is set (published Org Page). Params: false (bool → 480px DAF layout). On mobile it moves under the name. -->
{{#if organizationPageUrl}}
<td align="right" valign="middle" class="mobile-header-cta" style="padding-left: 12px;">
  <a href="{{organizationPageUrl}}" target="_blank" class="mobile-header-btn mfs11" style="display: inline-block; background-color: {{theme.headerBg}}; border: 1px solid {{theme.bModerate}}; border-radius: 8px; padding: 6px 15px; font-size: 13.5px; line-height: 15px; font-family: Arial, Helvetica, sans-serif; font-weight: 500; color: {{theme.tIntense}}; text-decoration: none; white-space: nowrap;">{{labels.moreWaysToSupport}}{{#if iconExternalLink}}&nbsp;<img src="{{iconExternalLink}}" width="15" height="15" alt="" class="mobile-header-icon" style="display: inline-block; vertical-align: -2px; border: 0;" />{{/if}}</a>
</td>
{{/if}}
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}}{{#if firstName}} {{firstName}}{{/if}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.newsletterThankYouTitle}}
  </h1>
</td></tr>

<!-- ========== 4. NOTE FROM ORGANIZER ========== -->
{{#if message}}
<tr data-section="note"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.emailBg}}; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px;" class="mobile-pad-inner">
      {{!-- No quote glyph here on purpose (KRA-5052). A lone opening quote beside the heading read
            as a grammar error to organizations, and the design-system version that closes it sits
            centred on the card's border — which needs absolute positioning plus an image mask that
            Gmail and Outlook strip. The card's own outline already frames the message. --}}
      <p class="mfs10" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tBrand}}; margin: 0 0 12px; line-height: 1.4;">
        {{labels.aThankYouFrom}} {{orgName}}
      </p>
      <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
        {{{message}}}
      </div>
    </td></tr>
  </table>
</td></tr>
{{/if}}
<!-- Spacer so the footer isn't glued to the note block (no receipt section sits between them here) -->
<tr data-section="note-spacer"><td style="font-size: 0; line-height: 0; height: 24px;">&nbsp;</td></tr>

<!-- ========== 5. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyrightNewsletterConfirmation (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightNewsletterConfirmation}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.REMINDER_TICKETING = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderReminder}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 2.5 EVENT DETAILS (fixed, not editable by the org) ========== -->
<!-- Event / raffle details card (date block, venue or online link, add-to-calendar). Shared by the
     ticketing thank-you and the event reminder. Block partial: children render inside the card, under
     the details (the reminder puts its ticket CTAs there); call it with an empty block otherwise. -->
{{#if (or eventStartDate eventAddress eventOnlineUrl)}}
<tr data-section="event"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.noteBg}};{{#if theme.isDark}} border: 1px solid {{theme.bModerate}};{{/if}} border-radius: 9px; border-collapse: separate; border-spacing: 0;">
    <tr><td style="padding: 18px 18px 0;" class="mobile-pad-inner">
      <p class="mfs11" style="font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: {{theme.tQuiet}}; margin: 0 0 6px; line-height: 1.5;">{{#if isSweepstakes}}{{labels.sweepstakesDetails}}{{else if isLotteryForm}}{{labels.raffleDetails}}{{else}}{{labels.eventDetails}}{{/if}}</p>
      <p class="mfs13_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 16px; font-weight: 700; color: {{theme.tModerate}}; margin: 0; line-height: 1.3;">{{eventTitle}}</p>
    </td></tr>
    {{#if theme.isDark}}
    <tr><td style="padding: 14px 0 0; font-size: 0; line-height: 0; mso-line-height-rule: exactly;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td style="border-top: 1px solid {{theme.bModerate}}; font-size: 0; line-height: 0; height: 0; mso-line-height-rule: exactly;">&nbsp;</td>
      </tr></table>
    </td></tr>
    {{/if}}
    <tr><td style="padding: {{#if theme.isDark}}14px{{else}}12px{{/if}} 18px 18px;" class="mobile-pad-inner">
      {{#if eventCalendarBesideDate}}
      <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        <td width="48" valign="middle" style="padding-right: 9px;">
          <table width="48" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: transparent; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 6px; text-align: center; border-collapse: separate; border-spacing: 0;">
            <tr><td style="padding: 4px 4px 1px;">
              <p class="mfs7_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 9px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: {{theme.tBrand}}; margin: 0; line-height: 1;">{{eventMonth}}</p>
            </td></tr>
            <tr><td>
              <p class="mfs15" style="font-family: Arial, Helvetica, sans-serif; font-size: 18px; font-weight: 700; line-height: 1.05; color: {{theme.tIntense}}; margin: 0; letter-spacing: -0.02em;">{{eventDay}}</p>
            </td></tr>
            <tr><td style="padding: 1px 4px 5px;">
              <p class="mfs7_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 9px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: {{theme.tBrand}}; margin: 0; line-height: 1;">{{eventWeekday}}</p>
            </td></tr>
          </table>
        </td>
        <td valign="middle" style="padding-right: 24px;">
          <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 2px; line-height: 1.5;">{{eventDateLabel}}</p>
          <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{#if theme.isDark}}{{theme.tBrand}}{{else}}{{theme.tQuiet}}{{/if}}; margin: 0; line-height: 1.4;">{{eventTimeRange}}</p>
        </td>
        <td valign="middle" class="mobile-cal-beside" style="white-space: nowrap;">
          <a href="{{calendarFileUrl}}" class="cal-btn mfs10_5" style="display: inline-block; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tBrand}}; text-decoration: none; line-height: 1.5; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 1000px; padding: 6px 12px;">
            {{#if iconCalendar}}<img src="{{iconCalendar}}" width="12" height="12" alt="" style="display: inline-block; vertical-align: -2px; margin-right: 6px; border: 0;" />{{/if}}<span>{{labels.addToCalendar}}</span>
          </a>
        </td>
      </tr></table>
      {{else}}
      {{#if (or eventStartDate (or eventAddress eventOnlineUrl))}}
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
        {{#if eventStartDate}}
        <td width="{{#if (or eventAddress eventOnlineUrl)}}50%{{else}}100%{{/if}}" valign="middle" class="mobile-stack" style="{{#if (or eventAddress eventOnlineUrl)}}padding-right: 24px;{{/if}}">
          <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
            <td width="48" valign="middle" style="padding-right: 12px;">
              <table width="48" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: transparent; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 6px; text-align: center; border-collapse: separate; border-spacing: 0;">
                <tr><td style="padding: 4px 4px 1px;">
                  <p class="mfs7_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 9px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: {{theme.tBrand}}; margin: 0; line-height: 1;">{{eventMonth}}</p>
                </td></tr>
                <tr><td>
                  <p class="mfs15" style="font-family: Arial, Helvetica, sans-serif; font-size: 18px; font-weight: 700; line-height: 1.05; color: {{theme.tIntense}}; margin: 0; letter-spacing: -0.02em;">{{eventDay}}</p>
                </td></tr>
                <tr><td style="padding: 1px 4px 5px;">
                  <p class="mfs7_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 9px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: {{theme.tBrand}}; margin: 0; line-height: 1;">{{eventWeekday}}</p>
                </td></tr>
              </table>
            </td>
            <td valign="middle">
              <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 2px; line-height: 1.5;">{{eventDateLabel}}</p>
              <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{#if theme.isDark}}{{theme.tBrand}}{{else}}{{theme.tQuiet}}{{/if}}; margin: 0; line-height: 1.4;">{{eventTimeRange}}</p>
            </td>
          </tr></table>
        </td>
        {{/if}}
        {{#if (or eventAddress eventOnlineUrl)}}
        <td width="{{#if eventStartDate}}50%{{else}}100%{{/if}}" valign="middle" class="mobile-stack {{#if eventStartDate}}mobile-stack-divider{{/if}}" style="{{#if eventStartDate}}padding-left: 0;{{/if}}">
          {{#if eventOnlineUrl}}
          <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
            {{#if iconOnline}}
            <td width="20" valign="top" style="padding-right: 5px; padding-top: 1px;">
              <img src="{{iconOnline}}" width="15" height="15" alt="" style="display: block; border: 0;" />
            </td>
            {{/if}}
            <td valign="top">
              <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tIntense}}; margin: 0; line-height: 1.5;">{{labels.onlineEvent}}</p>
              <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; margin: 4px 0 0; line-height: 1.4;">
                <a href="{{eventOnlineUrl}}" class="map-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.joinOnline}}</a>
              </p>
            </td>
          </tr></table>
          {{else}}
          <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
            {{#if iconPin}}
            <td width="20" valign="top" style="padding-right: 5px; padding-top: 1px;">
              <img src="{{iconPin}}" width="15" height="15" alt="" style="display: block; border: 0;" />
            </td>
            {{/if}}
            <td valign="top">
              <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tIntense}}; margin: 0; line-height: 1.5;">{{eventAddress}}</p>
              {{#if eventMapLink}}
              <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; margin: 4px 0 0; line-height: 1.4;">
                <a href="{{eventMapLink}}" class="map-link" style="color: {{theme.tBrand}}; font-weight: 700; text-decoration: underline;">{{labels.openInMaps}}</a>
              </p>
              {{/if}}
            </td>
          </tr></table>
          {{/if}}
        </td>
        {{/if}}
      </tr></table>
      {{/if}}
      {{#if calendarFileUrl}}
      {{#unless eventCalendarBesideDate}}
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin-top: 12px;"><tr>
        <td>
          <a href="{{calendarFileUrl}}" class="cal-btn mfs10_5" style="display: inline-block; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; color: {{theme.tBrand}}; text-decoration: none; line-height: 1.5; border: 1px solid {{theme.bSecondaryCta}}; border-radius: 1000px; padding: 6px 12px;">
            {{#if iconCalendar}}<img src="{{iconCalendar}}" width="12" height="12" alt="" style="display: inline-block; vertical-align: -2px; margin-right: 6px; border: 0;" />{{/if}}<span>{{labels.addToCalendar}}</span>
          </a>
        </td>
      </tr></table>
      {{/unless}}
      {{/if}}
      {{/if}}
      
      {{#if viewTicketsUrl}}
      <table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin-top: 14px;"><tr>
        <td>
          <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" {{#unless isPreview}}href="{{viewTicketsUrl}}" {{/unless}}style="height:42px;v-text-anchor:middle;width:504px;" arcsize="29%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:17px;font-weight:bold;">{{labels.viewTickets}}</center></v:roundrect><![endif]-->
          <!--[if !mso]><!-->
          <a {{#unless isPreview}}href="{{viewTicketsUrl}}" target="_blank" {{/unless}}class="cta-primary" style="display: block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; font-weight: 700; text-decoration: none; padding: 9px 12px; border-radius: 6px; line-height: 1.4; text-align: center;">
            {{labels.viewTickets}}
          </a>
          <!--<![endif]-->
        </td>
      </tr></table>
      {{/if}}
      {{#if (or appleWalletUrl googleWalletUrl)}}
<!-- Wallet badges — both always shown (no device detection), buyer taps the one matching their device -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="margin-top: 15px;"><tr>
  <td align="center">
    <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
      {{#if appleWalletUrl}}
      <td style="padding: 0 3px;">
        <a {{#unless isPreview}}href="{{appleWalletUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
          <img src="{{badgeAppleWalletImg}}" width="78" height="24" alt="{{labels.addToAppleWallet}}" style="display: block; border: 0; width: 78px; height: 24px;" />
        </a>
      </td>
      {{/if}}
      {{#if googleWalletUrl}}
      <td style="padding: 0 3px;">
        <a {{#unless isPreview}}href="{{googleWalletUrl}}" target="_blank" {{/unless}}style="display: block; text-decoration: none;">
          <img src="{{badgeGoogleWalletImg}}" width="87" height="24" alt="{{labels.addToGoogleWallet}}" style="display: block; border: 0; width: 87px; height: 24px;" />
        </a>
      </td>
      {{/if}}
    </tr></table>
  </td>
</tr></table>
{{/if}}
      {{#if cancelAttendanceUrl}}
      <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; text-align: center; margin: 12px 0 0; line-height: 1.5;">
        {{labels.reminderCantMakeIt}}
        <a {{#unless isPreview}}href="{{cancelAttendanceUrl}}" target="_blank" {{/unless}}style="color: {{theme.tBrand}}; text-decoration: underline;">{{labels.reminderFreeYourSpot}}</a>
      </p>
      {{/if}}

    </td></tr>
  </table>
</td></tr>
{{/if}}

<!-- ========== 3. BODY (org WYSIWYG content — editable) ========== -->
<tr data-section="note"><td style="padding: 30px;" class="mobile-pad-inner">
  <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{{message}}}
  </div>
</td></tr>

<!-- ========== 4. ZEFFY FOOTER ========== -->
{{#if isSweepstakes}}
<!-- Zeffy branding footer. Param: labels.footerCopyrightParticipation (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightParticipation}}
  </p>
</td></tr>
{{else}}
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>
{{/if}}

<!-- ========== 5. UNSUBSCRIBE (campaign sends only — rendered when unsubscribeUrl is provided) ========== -->
{{#if unsubscribeUrl}}
<tr data-section="unsubscribe"><td style="padding: 0 30px 24px; background-color: {{theme.footerBg}};" class="mobile-pad-inner">
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.tQuiet}}; margin: 0; text-align: center;">
    {{labels.footerUnsubscribePrompt}}
    <a href="{{{unsubscribeUrl}}}" target="_blank" style="color: {{theme.tQuiet}}; text-decoration: underline;">{{labels.footerUnsubscribeLink}}</a>
  </p>
</td></tr>
{{/if}}

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.FULFILLMENT_READY_FOR_PICKUP = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderReadyForPickup}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. BODY (org WYSIWYG message) ========== -->
<tr data-section="note"><td style="padding: 30px;" class="mobile-pad-inner">
  <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{{message}}}
  </div>
</td></tr>

<!-- ========== 4. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.FULFILLMENT_ORDER_SHIPPED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.preheaderOrderShipped}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. BODY (org WYSIWYG message) ========== -->
<tr data-section="note"><td style="padding: 30px;" class="mobile-pad-inner">
  <div class="note-message mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{{message}}}
  </div>
</td></tr>

<!-- ========== 4. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.DISPUTE_CREATED_CUSTOMER = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{labels.disputeCreatedCustomerPreheader}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{organizationName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{fullName}},
  </p>
  <h1 class="mfs24" style="font-family: Arial, Helvetica, sans-serif; font-size: 29px; line-height: 1.2; font-weight: 700; margin: 0 0 9px; letter-spacing: -0.02em; color: {{theme.tIntense}};">
    {{labels.disputeCreatedCustomerTitle}}
  </h1>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.disputeCreatedCustomerIntroPrefix}} {{organizationName}} {{labels.disputeCreatedCustomerIntroSuffix}}
  </p>
</td></tr>

<!-- ========== 4. PAYMENT DETAILS ========== -->
<tr data-section="payment-details"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 6px;">
    {{labels.disputeDetailsHeading}}
  </p>
  {{#if description}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.disputeDetailDescription}} {{description}}
  </p>
  {{/if}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.disputeDetailAmount}} <strong style="color: {{theme.tIntense}};">{{amount}}</strong>
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.disputeDetailDate}} {{date}}
  </p>
</td></tr>

<!-- ========== 5. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{labels.disputeCreatedCustomerAction}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.disputeCreatedCustomerSignOff}}<br />{{labels.zeffyTeam}}
  </p>
</td></tr>

<!-- ========== 6. ZEFFY FOOTER ========== -->
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.GUEST_INFO_UPDATED = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{#if isSweepstakes}}{{labels.preheaderSweepstakesParticipantInfoUpdated}}{{else}}{{labels.preheaderGuestInfoUpdated}}{{/if}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{#if isSweepstakes}}{{labels.sweepstakesParticipantUpdatedInfoPrefix}}{{else}}{{labels.buyerGuestUpdatedInfoPrefix}}{{/if}} {{campaignName}}.
  </p>
</td></tr>

<!-- ========== 4. GUEST DETAILS ========== -->
<tr data-section="guest-details"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 6px;">
    {{#if isSweepstakes}}{{labels.sweepstakesParticipantDetailsHeader}}{{else}}{{labels.guestDetailsHeader}}{{/if}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{guestName}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{guestEmail}}
  </p>
</td></tr>

<!-- ========== 5. CTA ========== -->
<tr data-section="cta"><td style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-cta-stack"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{{ticketsUrl}}" style="height:44px;v-text-anchor:middle;width:200px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{#if isSweepstakes}}{{labels.viewMySweepstakesEntries}}{{else}}{{labels.viewMyTickets}}{{/if}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a href="{{ticketsUrl}}" target="_blank" class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{#if isSweepstakes}}{{labels.viewMySweepstakesEntries}}{{else}}{{labels.viewMyTickets}}{{/if}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 6. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{#if isSweepstakes}}{{labels.goodLuckInSweepstakes}}{{else}}{{labels.lookForwardToSeeingYou}}{{/if}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.signOffThanks}}<br />{{orgName}}
  </p>
</td></tr>

<!-- ========== 7. ZEFFY FOOTER ========== -->
{{#if isSweepstakes}}
<!-- Zeffy branding footer. Param: labels.footerCopyrightParticipation (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightParticipation}}
  </p>
</td></tr>
{{else}}
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>
{{/if}}

</table>
</td></tr>
</table>
</body>
</html>
`;
exports.GUEST_TICKET = `<!doctype html>
<html lang="{{lang}}" xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="x-apple-disable-message-reformatting" />
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no" />
<meta name="color-scheme" content="{{#if theme.isDark}}only dark{{else}}light dark{{/if}}" />
<meta name="supported-color-schemes" content="{{#if theme.isDark}}dark{{else}}light dark{{/if}}" />
<title>{{subject}}</title>

<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->
<style>
  /* Two opt-outs on purpose. Apple Mail 13+ and iOS read only this CSS rule: "only" stops them darkening
     our pure-white card while leaving the dark navy copy as is (KRA-5294). Gmail Android stopped inverting
     light emails once the meta tags above said "only light", leaving a white body in a dark app (KRA-5911),
     so a light email keeps "light dark" there and lets Gmail apply its own inversion. */
  :root { color-scheme: only {{#if theme.isDark}}dark{{else}}light{{/if}}; }
  p { margin: 0; }
  table { border-collapse: collapse; }
  img { display: block; border: 0; outline: none; text-decoration: none; }
  a { color: inherit; text-decoration: none; }
  .cta-primary { transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; }
  .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.08), 0 6px 16px rgba(0,0,0,0.12); }
  .cta-secondary { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cta-secondary:hover { transform: translateY(-1px); box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
  .cal-btn { transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease; }
  .cal-btn:hover { transform: translateY(-1px); }
  .map-link { transition: border-bottom-color 0.15s ease; }
  .map-link:hover { opacity: 0.8; }
  .social-icon { transition: transform 0.15s ease; }
  .social-icon:hover { transform: translateY(-1px); }
  .account-link { transition: border-bottom-color 0.15s ease; }
  .account-link:hover { opacity: 0.8; }
  .note-message * {
    color: {{theme.tModerate}} !important;
    -webkit-text-fill-color: {{theme.tModerate}} !important;
  }
  /* Links inside the WYSIWYG body must read as links — the rules above would otherwise flatten them to body text color with no underline. */
  .note-message a {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    text-decoration: underline !important;
  }
  /* WYSIWYG buttons (styled-tag-button) must keep a white label in an email-safe sans-serif: the editor's
     styled-tag-button class (color:#fff) is stripped at render and its inline font-family:Roboto is not
     email-safe, so .note-message * would repaint the label dark and clients fall back to serif. This rule
     only covers the LIVE PREVIEW, where the button stays a bare span carrying data-button-color (attribute
     selectors work in-browser). For SENT emails the white label + font are baked INLINE on the same spans by
     applyWysiwygButtonLabelColor (in sanitizeEmailBody) — Gmail drops attribute-selector <style> rules and a
     broad "a span" selector would wrongly whiten every link's inner span, so we scope it to the button marker. */
  .note-message [data-button-color] {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  /* Greeting accent: color the first paragraph of an opt-in body (.note-greeting) in the brand tone,
     matching the dedicated blue greeting used by the other branded emails. */
  .note-greeting > p:first-child,
  .note-greeting > p:first-child * {
    color: {{theme.tBrand}} !important;
    -webkit-text-fill-color: {{theme.tBrand}} !important;
    font-weight: 700 !important;
  }
  /* The global img display:block rule (footer logo / icons) would force inline emojis that Gmail
     injects as img tags onto their own line inside the WYSIWYG body. Keep body images inline. */
  .note-message img { display: inline-block; vertical-align: middle; }
  /* Same fix for template-owned inline emojis (e.g. 👉, 💡): Gmail rewrites them as <img>, which the global img{display:block} would drop onto their own line. */
  .emoji-inline img { display: inline-block !important; vertical-align: middle; }
  /* WYSIWYG buttons (styled-tag-button) serialize box-sizing:inherit plus a fixed height:36px; the
     editor's styled-tag-button class sets border-box but that class is stripped at render. Without a
     border-box ancestor the padding stacks on top of the height and the button renders too tall. The body
     paragraph and the button span both declare box-sizing:inherit, so anchoring border-box here fixes the
     whole chain (email + live preview). */
  .note-message { box-sizing: border-box; }
  @media only screen and (max-width: 479px) {
    .mobile-full { width: 100% !important; max-width: 100% !important; }
    .mobile-pad { padding-left: 18px !important; padding-right: 18px !important; }
    .mobile-pad-inner { padding-left: 22px !important; padding-right: 22px !important; }
    .mobile-stack { display: block !important; width: 100% !important; padding-bottom: 14px !important; }
    .mobile-stack-divider { border-left: 0 !important; border-top: 1px solid {{theme.bSupershy}} !important; padding-left: 0 !important; padding-top: 14px !important; }
    .mobile-stack:last-child { padding-bottom: 0 !important; }
    .mobile-cal-beside { display: block !important; width: 100% !important; text-align: left !important; padding-top: 12px !important; white-space: normal !important; }
    .mobile-hide { display: none !important; }
    .mobile-header-name { display: block !important; width: 100% !important; }
    .mobile-header-cta { display: block !important; width: 100% !important; text-align: left !important; padding: 10px 0 0 0 !important; }
    .mobile-header-btn { padding: 4px 10px !important; line-height: 14px !important; }
    .mobile-header-icon { width: 13px !important; height: 13px !important; }
    .mobile-cta-stack,
    .mobile-cta-stack tbody,
    .mobile-cta-stack tr { display: block !important; width: 100% !important; }
    .mobile-cta-stack td { display: block !important; width: 100% !important; padding: 0 0 8px 0 !important; box-sizing: border-box !important; }
    .mobile-cta-stack td:last-child { padding-bottom: 0 !important; }
    .mobile-cta-stack .cta-primary,
    .mobile-cta-stack .cta-secondary { display: block !important; width: 100% !important; box-sizing: border-box !important; text-align: center !important; padding: 12px 16px !important; font-size: 11px !important; border-radius: 6px !important; }
    .mobile-outer-pad { padding: 0 !important; }
    .mobile-no-radius { border-radius: 0 !important; box-shadow: none !important; }
    /* Text is enlarged ~20% on desktop via inline sizes; these restore the original mobile sizes. */
    .mfs7_5 { font-size: 7.5px !important; }
    .mfs9 { font-size: 9px !important; }
    .mfs10 { font-size: 10px !important; }
    .mfs10_5 { font-size: 10.5px !important; }
    .mfs11 { font-size: 11px !important; }
    .mfs12 { font-size: 12px !important; }
    .mfs13 { font-size: 13px !important; }
    .mfs13_5 { font-size: 13.5px !important; }
    .mfs14 { font-size: 14px !important; }
    .mfs15 { font-size: 15px !important; }
    .mfs18 { font-size: 18px !important; }
    .mfs22 { font-size: 22px !important; }
    .mfs24 { font-size: 24px !important; }
    /* org-banner-header keeps its tighter 20px vertical padding on mobile (desktop is 24px). */
    .mobile-pad-banner { padding-top: 20px !important; padding-bottom: 20px !important; }
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: {{theme.canvas}}; -webkit-font-smoothing: antialiased;">
<!-- Preheader (hidden preview text) -->
<div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: {{theme.canvas}};">
  {{#if isSweepstakes}}{{labels.preheaderGuestSweepstakesEntry}}{{else}}{{labels.preheaderGuestTicket}}{{/if}}
  &#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;&#8204;&nbsp;
</div>
<!-- Main wrapper -->
<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation" style="background-color: {{theme.canvas}};">
<tr><td align="center" class="mobile-outer-pad" style="padding: 24px 16px;">
<!-- Email card — 600px max -->
<table width="600" cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-full mobile-no-radius" style="max-width: 600px; width: 100%; background-color: {{theme.emailBg}}; border-radius: 12px; overflow: hidden; border-collapse: separate; border-spacing: 0; box-shadow: 0 12px 24px rgba(0,0,0,0.12);">

<!-- ========== 1. TOP RIBBON (6px) ========== -->
<tr data-section="ribbon"><td style="height: 6px; background-color: {{theme.brandFill}}; font-size: 0; line-height: 0;">&nbsp;</td></tr>

<!-- ========== 2. HEADER ========== -->
<tr data-section="header"><td style="padding: 18px 30px; background-color: {{theme.headerBg}}; border-bottom: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tModerate}}; line-height: 1.3; letter-spacing: -0.01em;">
      {{orgName}}
    </td>
  </tr></table>
</td></tr>

<!-- ========== 3. LEDE ========== -->
<tr data-section="lede"><td style="padding: 30px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; font-weight: 700; color: {{theme.tBrand}}; margin: 0 0 9px; line-height: 1.5;">
    {{labels.hi}} {{firstName}},
  </p>
  <p class="mfs16" style="font-family: Arial, Helvetica, sans-serif; font-size: 18px; line-height: 1.35; font-weight: 700; margin: 0 0 12px; letter-spacing: -0.01em; color: {{theme.tIntense}};">
    {{#if isSweepstakes}}{{labels.guestSweepstakesEntryLedePrefix}} {{buyerName}} {{labels.guestSweepstakesEntrySentTo}} {{campaignName}}.{{else}}{{labels.guestTicketLedePrefix}} {{buyerName}} {{labels.guestTicketSentTo}} {{campaignName}}.{{/if}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{#if isSweepstakes}}{{labels.guestSweepstakesEntryLinkedBelow}}{{else}}{{labels.guestTicketLinkedBelow}}{{/if}}
  </p>
</td></tr>

<!-- ========== 4. CTA ========== -->
<tr data-section="cta"><td style="padding: 18px 30px 0;" class="mobile-pad-inner">
  <table cellpadding="0" cellspacing="0" border="0" role="presentation" class="mobile-cta-stack"><tr><td>
    <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{{ticketsUrl}}" style="height:44px;v-text-anchor:middle;width:200px;" arcsize="14%" fillcolor="{{theme.ctaBg}}" strokecolor="{{theme.ctaBg}}" stroke="f"><w:anchorlock/><center style="color:{{theme.ctaText}};font-family:Arial,sans-serif;font-size:13px;font-weight:bold;">{{#if isSweepstakes}}{{labels.viewMySweepstakesEntries}}{{else}}{{labels.viewMyTickets}}{{/if}}</center></v:roundrect><![endif]-->
    <!--[if !mso]><!-->
    <a href="{{ticketsUrl}}" target="_blank" class="cta-primary" style="display: inline-block; background-color: {{theme.ctaBg}}; color: {{theme.ctaText}}; font-family: Arial, Helvetica, sans-serif; font-size: 13px; font-weight: 700; text-decoration: none; padding: 12px 22px; border-radius: 6px; line-height: 1.4; text-align: center;">
      {{#if isSweepstakes}}{{labels.viewMySweepstakesEntries}}{{else}}{{labels.viewMyTickets}}{{/if}}
    </a>
    <!--<![endif]-->
  </td></tr></table>
</td></tr>

<!-- ========== 5. EVENT DETAILS ========== -->
<tr data-section="event-details"><td style="padding: 24px 30px 0;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; font-weight: 700; color: {{theme.tIntense}}; margin: 0 0 6px;">
    {{#if isSweepstakes}}{{labels.guestSweepstakesDetailsHeader}}{{else}}{{labels.guestEventDetailsHeader}}{{/if}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{campaignName}}
  </p>
  {{#if campaignDateTime}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{campaignDateTime}}
  </p>
  {{/if}}
  {{#if campaignAddress}}
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{campaignAddress}}
  </p>
  {{/if}}
</td></tr>

<!-- ========== 6. CLOSING ========== -->
<tr data-section="closing"><td style="padding: 24px 30px 30px;" class="mobile-pad-inner">
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0 0 16px;">
    {{#if isSweepstakes}}{{labels.goodLuckInSweepstakes}}{{else}}{{labels.lookForwardToSeeingYou}}{{/if}}
  </p>
  <p class="mfs12" style="font-family: Arial, Helvetica, sans-serif; font-size: 14.5px; line-height: 1.5; color: {{theme.tModerate}}; margin: 0;">
    {{labels.signOffBest}}<br />{{orgName}}
  </p>
</td></tr>

<!-- ========== 7. ZEFFY FOOTER ========== -->
{{#if isSweepstakes}}
<!-- Zeffy branding footer. Param: labels.footerCopyrightParticipation (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyrightParticipation}}
  </p>
</td></tr>
{{else}}
<!-- Zeffy branding footer. Param: labels.footerCopyright (label path) — the "why you got this" line, which differs per email. -->
<tr data-section="footer"><td style="padding: 30px; background-color: {{theme.footerBg}}; border-top: 1px solid {{theme.bSupershy}};" class="mobile-pad-inner">
  <!-- Zeffy logo (CID inline attachment, light or dark variant picked per send) -->
  {{#if iconZeffyLogo}}
  <a href="https://www.zeffy.com/" target="_blank" style="display: inline-block; margin-bottom: 16px; text-decoration: none;">
    <img src="{{iconZeffyLogo}}" width="72" alt="Zeffy" style="display: block; border: 0;" />
  </a>
  {{/if}}
  <p class="mfs10_5" style="font-family: Arial, Helvetica, sans-serif; font-size: 12.5px; line-height: 1.5; color: {{theme.footerStrong}}; font-weight: 700; margin: 0 0 4px;">{{labels.footerHeadline}}</p>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; line-height: 1.4; color: {{theme.footerText}}; margin: 0 0 16px;">
    {{labels.footerBody}}
    <a href="https://zeffy.com/?UTM_source=click_donoremail_generatedbyzeffy" style="color: {{theme.tBrand}}; text-decoration: underline; font-weight: 700;" target="_blank">{{labels.footerLearnMore}}</a>
  </p>
  <!-- Social icons -->
  <table cellpadding="0" cellspacing="0" border="0" role="presentation"><tr>
    <td style="padding-right: 9px;">
      <a href="http://linkedin.com/company/zeffy/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/linkedin_32px.png" width="24" height="24" alt="LinkedIn" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td style="padding-right: 9px;">
      <a href="https://www.facebook.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/facebook_32px.png" width="24" height="24" alt="Facebook" style="display: block; border-radius: 6px;" />
      </a>
    </td>
    <td>
      <a href="https://www.instagram.com/zeffyplatform/" target="_blank" class="social-icon">
        <img src="https://creative-assets.mailinblue.com/editor/social-icons/rounded_colored/instagram_32px.png" width="24" height="24" alt="Instagram" style="display: block; border-radius: 6px;" />
      </a>
    </td>
  </tr></table>
  <p class="mfs9" style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: {{theme.tQuiet}}; line-height: 1.4; margin: 20px 0 0; padding-top: 16px; border-top: 1px solid {{theme.bSupershy}}; text-align: center;">
    {{labels.footerCopyright}}
  </p>
</td></tr>
{{/if}}

</table>
</td></tr>
</table>
</body>
</html>
`;
